export default {
  '导出': {
    zh: '导出',
    ar: 'تصدير',
    en: 'Export',
    fa: 'صادرات',
    pt: 'Exportar'
  },
  '导入': {
    zh: '导入',
    ar: 'استورد',
    en: 'Import',
    fa: 'واردات',
    pt: 'Importar'
  },
  '导入频道信息': {
    zh: '导入频道信息',
    en: 'Import Channel Information',
    ar: 'استيراد معلومات القناة',
    fa: 'وارد کردن اطلاعات کانال',
    pt: 'Importar informações do canal'
  },
  '批量导入': {
    zh: '批量导入',
    en: 'Batch Import',
    ar: 'استيراد دفعي',
    fa: 'وارد کردن گروهی',
    pt: 'Importação em lote'
  },
  '频道信息': {
    zh: '频道信息',
    en: 'Channel Information',
    ar: 'معلومات القناة',
    fa: 'اطلاعات کانال',
    pt: 'Informações do canal'
  },
  '仅支持上传 Excel 文件': {
    zh: '仅支持上传 Excel 文件',
    en: 'Only Excel files can be uploaded',
    ar: 'يُسمح برفع ملفات Excel فقط',
    fa: 'فقط فایل‌های Excel قابل بارگذاری هستند',
    pt: 'Só é possível carregar arquivos Excel'
  },
  '新增': {
    en: 'Add',
    zh: '新增',
    fa: 'اضافه کردن',
    ar: 'يضيف',
    pt: 'Adicionar'
  },
  '删除': {
    en: 'Delete',
    zh: '删除',
    fa: 'حذف',
    ar: 'حذف',
    pt: 'Apagar'
  },
  '操作': {
    zh: '操作',
    ar: 'اشتغل',
    en: 'Operate',
    fa: 'عمل',
    pt: 'Operação'
  },
  '全部': {
    zh: '全部',
    en: 'All',
    ar: 'كل',
    fa: 'همه',
    pt: 'Todos'
  },
  '品牌': {
    zh: '品牌',
    en: 'Brand',
    ar: 'وسم',
    fa: 'برند',
    pt: 'Marca'
  },
  '查询': {
    zh: '查询',
    en: 'Search',
    ar: 'استعلم',
    fa: 'پرس',
    pt: 'Consultar'
  },
  '重置': {
    zh: '重置',
    en: 'Reset',
    ar: 'اعاده تعيين',
    fa: 'تنظیم مجدد',
    pt: 'Teiniciar'
  },
  '编辑': {
    zh: '编辑',
    en: 'Edit',
    ar: 'حرر',
    fa: 'ویرایش',
    pt: 'Editar'
  },
  '审核': {
    zh: '审核',
    en: 'Audit',
    ar: 'مراجعه الحسابات',
    fa: 'ممیزی',
    pt: 'Auditoria'
  },
  '影片': {
    zh: '影片',
    en: 'Movies',
    ar: 'فيلم',
    fa: 'فیلم',
    pt: 'Filmes'
  },
  '修改': {
    zh: '修改',
    en: 'Edit',
    ar: 'تنقيح',
    fa: 'تجدید نظر',
    pt: 'Editar'
  },
  '添加': {
    zh: '添加',
    en: 'Add',
    ar: 'أضف إلى',
    fa: 'اضافه کردن به',
    pt: 'Adicionar'
  },
  '分类等级': {
    zh: '分类等级',
    en: 'Classification Level',
    ar: 'مستوى التصنيف',
    fa: 'سطح طبقه بندی',
    pt: 'Nível de Classificação'
  },
  '返回': {
    zh: '返回',
    en: 'Back',
    ar: 'أعاد',
    fa: 'بازگشت',
    pt: 'Retorno'
  },
  '移除': {
    zh: '移除',
    en: 'Remove',
    ar: 'أبعد',
    fa: 'حذف',
    pt: 'Remover'
  },
  '关闭': {
    zh: '关闭',
    en: 'Close',
    ar: 'إيقاف التشغيل',
    fa: 'خاموش شدن',
    pt: 'Fechar'
  },
  '刷新': {
    zh: '刷新',
    en: 'Refresh',
    ar: 'ينعش',
    fa: 'تازه کردن',
    pt: 'Actualizar'
  },
  '关闭其他': {
    zh: '关闭其他',
    en: 'Close other',
    ar: 'أغلق آخر',
    fa: 'بستن دیگری',
    pt: 'Fechar Outros'
  },
  '关闭全部': {
    zh: '关闭全部',
    en: 'Close all',
    ar: 'أغلق الكل',
    fa: 'بستن همه',
    pt: 'Fechar Tudo'
  },
  '确定': {
    zh: '确定',
    en: 'OK',
    ar: 'تأكيد',
    fa: 'تایید',
    pt: 'Confirmar'
  },
  '查看': {
    zh: '查看',
    en: 'View',
    ar: 'منظر',
    fa: 'مشاهده',
    pt: 'Ver'
  },
  '编辑成功': {
    zh: '编辑成功',
    en: 'Edit Successfully',
    ar: 'تحرير ناجح',
    fa: 'ویرایش موفق',
    pt: 'Editar Sucesso'
  },
  '新增成功': {
    zh: '新增成功',
    en: 'Add Successfully',
    ar: 'تم إضافة بنجاح',
    fa: 'با موفقیت اضافه شد',
    pt: 'Adicionado com Sucesso'
  },
  '确定删除这条数据吗?': {
    zh: '确定删除这条数据吗?',
    en: 'Are you sure to delete this data?',
    ar: 'هل أنت متأكد أنك تريد حذف هذه البيانات؟',
    fa: 'آیا مطمئن هستید که این داده ها را حذف می کنید؟',
    pt: 'Tem a certeza de que pretende apagar estes dados?'
  },
  '是的，确定': {
    zh: '是的，确定',
    en: 'Yes, sure',
    ar: 'نعم بالتأكيد',
    fa: 'بله حتما',
    pt: 'Sim, Claro'
  },
  '不，取消': {
    zh: '不，取消',
    en: 'No, cancel',
    ar: 'لا ، إلغاء',
    fa: 'نه، لغو',
    pt: 'Não, Cancelado'
  },
  'Warning': {
    zh: 'Warning',
    en: 'Warning',
    ar: 'اخطار',
    fa: 'اخطار',
    pt: 'Aviso'
  },
  '序号': {
    zh: '序号',
    en: 'NO.',
    ar: 'رقم',
    fa: 'شماره',
    pt: 'Número'
  },
  '取消': {
    zh: '取消',
    en: 'Cancel',
    ar: 'ألغى',
    fa: 'لغو کردن',
    pt: 'Cancelar'
  },
  '限制字符数量': {
    zh: '你不能填写超过{num}字符',
    en: 'You cannot enter more than {num} characters',
    ar: 'لا يمكنك إدخال أكثر من {num} حرف',
    fa: 'شما نمی توانید بیش از {num} نویسه وارد کنید',
    pt: 'Não pode preencher mais de {num} caracteres'
  },
  '请选择语言': {
    zh: '请选择语言',
    en: 'Please select language',
    ar: 'يرجى اختيار لغة',
    fa: 'لطفا یک زبان را انتخاب کنید',
    pt: 'Seleccione o idioma'
  },
  '下一步': {
    zh: '下一步',
    en: 'Next Step',
    ar: 'الخطوة التالية',
    fa: 'قدم بعدی',
    pt: 'Próxima Etapa'
  },
  '上一步': {
    zh: '上一步',
    en: 'Last Step',
    ar: 'الخطوة السابقة',
    fa: 'قدم قبلی',
    pt: 'Passo anterior'
  },
  '开始时间': {
    zh: '开始时间',
    en: 'Start Time',
    ar: 'وقت البدء',
    fa: 'زمان شروع',
    pt: 'Hora de Início'
  },
  '结束时间': {
    zh: '结束时间',
    en: 'End Time',
    ar: 'نهاية الوقت',
    fa: 'زمان پایان',
    pt: 'Hora de Fim'
  },
  '文档下载': {
    zh: '文档下载',
    en: 'Document Download',
    ar: 'الوثائق',
    fa: 'پرونده',
    pt: 'Download Documento'
  },
  '下载': {
    zh: '下载',
    en: 'Download',
    ar: 'تحميل',
    fa: 'دانلود',
    pt: 'Descarregar'
  },
  '文档名称': {
    zh: '文档名称',
    en: 'Name',
    ar: 'اسم الملف',
    fa: 'نام پرونده',
    pt: 'Nome do Arquivo'
  },
  '请选择时间': {
    zh: '请选择时间',
    en: 'Please select a time',
    ar: 'الرجاء اختيار الوقت',
    fa: 'لطفاً یک زمان انتخاب کنید',
    pt: 'Por favor, escolha a hora'
  },
  '请选择品牌': {
    zh: '请选择品牌',
    en: 'Please select a brand',
    ar: 'الرجاء اختيار العلامة التجارية',
    fa: 'لطفا یک برند انتخاب کنید',
    pt: 'Por favor, seleccione a marca'
  },
  '请输入大于0的整数': {
    zh: '请输入大于0的整数',
    en: 'Please input an integer greater than 0',
    ar: 'الرجاء إدخال عدد صحيح أكبر من 0',
    fa: 'لطفاً یک کلی بیشتر از ۰ وارد کنید',
    pt: 'Por favor, insira um número inteiro maior que 0'
  },
  'URL必须以 (https|http|ftp|rtsp|mms)://) 开头': {
    zh: 'URL必须以 (https\\http\\ftp\\rtsp\\mms)://) 开头',
    en: 'The URL must start with (https \\ http \\ ftp \\ rtsp \\ mms)://)',
    ar: 'عنوان الموقع يجب أن تبدأ مع ( https \\ http \\ ftp \\ rtsp \\ MMS ) : / / )',
    fa: 'URL باید از آن شروع شود (http ؛ ftp ؛ rtsp ؛ mms)://)',
    pt: 'URL tem de começar por (https\\http\\ftp\\rtsp\\mms)://)'
  },
  '至少保留一个影片': {
    zh: '至少保留一个影片',
    en: 'Keep at least one film',
    ar: 'الحفاظ على فيلم واحد على الأقل',
    fa: 'حداقل یک فیلم بمانید',
    pt: 'Manter pelo menos um film'
  },
  '至少保留一个剧集': {
    zh: '至少保留一个剧集',
    en: 'Keep at least one TV Shows',
    ar: 'الحفاظ على واحد على الأقل من الدراما',
    fa: 'حداقل یک سریال تلویزیونی بمانید',
    pt: 'Mantenha pelo menos um episódio'
  },
  '确认删除勾选影片吗?': {
    zh: '确认删除勾选影片吗?',
    en: 'Are you sure to delete the selected?',
    ar: 'تأكيد حذف الخيار ؟',
    fa: 'مطمئنی که انتخاب را حذف کنید؟',
    pt: 'Tem certeza de que deseja excluir os selecionados?'
  },
  '提示': {
    zh: '提示',
    en: 'Tip',
    ar: 'تلميح',
    fa: 'نکته',
    pt: 'Dica'
  },
  '格式为S01E01': {
    zh: '格式为S01E01',
    en: 'Format: S01E01',
    ar: 'شكل S01E01',
    fa: 'فرمت S01E01',
    pt: 'O Formato é S01E01'
  },
  '分类列表': {
    zh: '分类列表',
    en: 'Category List',
    ar: 'قائمة التصنيفات',
    fa: 'لیست دسته بندی',
    pt: 'Lista de Categorias'
  },
  '已选分类列表': {
    zh: '已选分类列表',
    en: 'Selected List',
    ar: 'قائمة مختارة',
    fa: 'فهرست برگزیده',
    pt: 'Lista Selecionada'
  },
  '子品牌名称': {
    zh: '子品牌名称',
    en: 'Sub Brand Name',
    ar: 'اسم العلامة التجارية الفرعية',
    fa: 'نام فرعی',
    pt: 'Nome da Submarca'
  },
  '分类名称': {
    zh: '分类名称',
    en: 'Classification Name',
    ar: 'اسم الفئة',
    fa: 'نام دسته',
    pt: 'Nome da Categoria'
  },
  '图片大小建议在500kb以内。': {
    zh: '图片大小建议在500kb以内。',
    en: 'Image size is recommended to be within 500kb.',
    ar: 'من المستحسن استخدام حجم الصورة في 500 كيلو بايت .',
    fa: 'اندازه تصویر در 500 کیلوبایت توصیه می شود.',
    pt: 'O tamanho da imagem é recomendado dentro de 500kb.'
  },
  '系列封面图': {
    zh: '系列封面图',
    en: 'Movie Sets Cover',
    ar: 'صورة الغلاف',
    fa: 'عکس پوشش',
    pt: 'Imagem da capa da série'
  },
  '影片封面图': {
    zh: '影片封面图',
    en: 'Movie Cover',
    ar: 'صورة غلاف الفيلم',
    fa: 'پوشش فیلم',
    pt: 'Imagem Capa Filme'
  },
  '尺寸': {
    zh: '尺寸',
    en: 'Size',
    ar: 'بحجم',
    fa: 'اندازه',
    pt: 'Tamanho'
  },
  '海报语言': {
    zh: '海报语言',
    en: 'Poster Language',
    ar: 'ملصق اللغة',
    fa: 'پوستر زبان',
    pt: 'Idioma do Pôster'
  },
  '文件': {
    zh: '文件',
    en: 'File',
    ar: 'الوثائق',
    fa: 'پرونده',
    pt: 'Ficheiro'
  },
  '点击上传': {
    zh: '点击上传',
    en: 'Upload',
    ar: 'تحميل',
    fa: 'بارگذاری',
    pt: 'Carregar'
  },
  '请上传文件': {
    zh: '请上传文件',
    en: 'Please upload the file',
    ar: 'الرجاء تحميل الملف',
    fa: 'لطفا فایل را آپلود کنید',
    pt: 'Carregue os ficheiros'
  },
  '上传图片': {
    zh: '上传图片',
    en: 'Upload Picture',
    ar: 'تحميل الصور',
    fa: 'بارگذاری',
    pt: 'Carregar Imagem'
  },
  '海报名称': {
    zh: '海报名称',
    en: 'Poster Name',
    ar: 'اسم الصورة',
    fa: 'نام پستری',
    pt: 'Nome do Pôster'
  },
  '导入影片': {
    zh: '导入影片',
    en: 'Import Movie',
    ar: 'استيراد فيديو',
    fa: 'واردات فیلم',
    pt: 'Filme de Importação'
  },
  '导入剧集': {
    zh: '导入剧集',
    en: 'Import TV Shows',
    ar: 'استيراد المسلسلات التلفزيونية',
    fa: 'واردات سریال های تلویزیونی',
    pt: 'Importar Episódios'
  },
  '选择文件': {
    zh: '选择文件',
    en: 'Select File',
    ar: 'حدد الملف',
    fa: 'انتخاب پرونده',
    pt: 'Selecione o Arquivo'
  },
  '请选择子品牌': {
    zh: '请选择子品牌',
    en: 'Please select the sub brand',
    ar: 'الرجاء اختيار العلامة التجارية الفرعية',
    fa: 'لطفا یک برند زیر انتخاب کنید',
    pt: 'Seleccione por favor uma sub marca'
  },
  '上传时间': {
    zh: '上传时间',
    en: 'Upload Time',
    ar: 'خلق الوقت',
    fa: 'زمان آپلود',
    pt: 'Tempo de Upload'
  },
  '请先勾选需要批量操作的影片': {
    zh: '请先勾选需要批量操作的影片',
    en: 'Please select the movie that needs batch operation first',
    ar: 'الرجاء اختيار الفيلم الذي يتطلب عملية دفعة',
    fa: 'لطفا فیلم را انتخاب کنید که اول به عملیات گروه نیاز دارد',
    pt: 'Selecione primeiro o filme que precisa de operação em lote'
  },
  '请先勾选状态相同的影片': {
    zh: '请先勾选状态相同的影片',
    en: 'Please select the movies with the same status first',
    ar: 'يجب أن تكون الدولة المحددة متسقة',
    fa: 'لطفاً ابتدا ویدیوهایی را با همین وضعیت انتخاب کنید',
    pt: 'Por favor, verifique primeiro com o mesmo estado'
  },
  '请选择状态进行批量修改': {
    zh: '请选择状态进行批量修改',
    en: 'Please select the status for batch modification',
    ar: 'الرجاء تحديد الحالة أولاً للتعديل',
    fa: 'لطفا وضعیت را برای تغییر دادن انتخاب کنید',
    pt: 'Selecione o status para modificação em lote'
  },
  '操作成功': {
    zh: '操作成功',
    en: 'Operation successfully',
    ar: 'تم تغییر بنجاح',
    fa: 'عملیات با موفقیت انجام شد',
    pt: 'Operação bem Sucedida'
  },
  '审核状态': {
    zh: '审核状态',
    en: 'Audit Status',
    ar: 'حالة مراجعة الحسابات',
    fa: 'وضعیت حسابرسی',
    pt: 'Estado da Revisão'
  },
  '终端审核': {
    zh: '终端审核',
    en: 'Terminal',
    ar: 'تدقيق نقاط النهاية',
    fa: 'ممیزی نقطه پایانی',
    pt: 'Terminal'
  },
  '终端审核中': {
    zh: '终端审核中',
    en: 'Terminal in progress',
    ar: 'المحطة الطرفية في التقدم',
    fa: 'ترمینال در حال پیشرفت',
    pt: 'Terminal em Análise'
  },
  '未审核': {
    zh: '未审核',
    en: 'Unaudited',
    ar: 'غير مدقق',
    fa: 'حسابرسی نشده',
    pt: 'Não Revisado'
  },
  '退回审核': {
    zh: '退回审核',
    en: 'Resume',
    ar: 'تدقيق المرتجعات',
    fa: 'حسابرسی را برمیگرداند',
    pt: 'Retomar'
  },
  '未通过': {
    zh: '未通过',
    en: 'Failed',
    ar: 'فشل',
    fa: 'ناموفق بود',
    pt: 'Não Passou'
  },
  '已审核': {
    zh: '已审核',
    en: 'Approved',
    ar: 'مصدق',
    fa: 'تایید',
    pt: 'Auditado'
  },
  '批量操作': {
    zh: '批量操作',
    en: 'Batch Operation',
    ar: 'عمليات متعددة',
    fa: 'عملیات چندین',
    pt: 'Operação em Lote'
  },
  '已通过审核': {
    zh: '已通过审核',
    en: 'Approved',
    ar: 'مصدق',
    fa: 'تایید',
    pt: 'Aprovado'
  },
  '未通过审核': {
    zh: '未通过审核',
    en: 'Failed',
    ar: 'فشل',
    fa: 'ناموفق بود',
    pt: 'Não Aprovado'
  },
  '重新审核': {
    zh: '重新审核',
    en: 'Re Audit',
    ar: 'إعادة المحاكمة',
    fa: 'بررسی دوباره',
    pt: 'Nova Auditoria'
  },
  '原因': {
    zh: '原因',
    en: 'Reason',
    ar: 'سبب',
    fa: 'دلیل',
    pt: 'Razão'
  },
  '审核结果': {
    zh: '审核结果',
    en: 'Result',
    ar: 'نتيجة',
    fa: 'نتیجه',
    pt: 'Resultado'
  },
  '审核通过': {
    zh: '审核通过',
    en: 'Pass',
    ar: 'من خلال مراجعة الحسابات',
    fa: 'موافقت',
    pt: 'Passar'
  },
  '审核不通过': {
    zh: '审核不通过',
    en: 'Failed',
    ar: 'فشل المراجعة',
    fa: 'رد نشده',
    pt: 'Falhar'
  },
  '请输入审核不通过原因': {
    zh: '请输入审核不通过原因',
    en: 'Please input the reason',
    ar: 'من فضلك أدخل السبب',
    fa: 'لطفا دلیل را وارد کنید',
    pt: 'Por favor, insira os motivos para não passar na revisão'
  },
  '是否直接上线影片': {
    zh: '是否直接上线影片',
    en: 'Whether to online the movie',
    ar: 'مباشرة على الانترنت',
    fa: 'این ویدیو را آپلود کنید',
    pt: 'Quer colocar o filme online'
  },
  '确认将以下影片终端审核？': {
    zh: '确认将以下影片终端审核？',
    en: 'Are you sure to audit the following video terminals?',
    ar: 'تدقيق نقاط النهاية؟',
    fa: 'تأیید کنید که ترمینال فیلم زیر بررسی خواهد شد؟',
    pt: 'Tem certeza de auditar os seguintes terminais de vídeo?'
  },
  '确认将以下影片通过审核？': {
    zh: '确认将以下影片通过审核？',
    en: 'Are you sure to approve the following movies?',
    ar: 'هل أنت متأكد من تمرير الأفلام التالية؟',
    fa: 'مطمئني اين فيلم ها رو رد کني؟',
    pt: 'Tem certeza de que aprova os seguintes filmes?'
  },
  '确认影片通过审核？': {
    zh: '确定影片通过审核？',
    en: 'Are you sure to approve the following movies?',
    ar: 'هل أنت متأكد من تمرير الأفلام التالية؟',
    fa: 'مطمئني اين فيلم ها رو رد کني؟',
    pt: 'Tem certeza de que aprova os seguintes filmes?'
  },
  '确认将影片终端审核？': {
    zh: '确认将影片终端审核？',
    en: ' Are you sure to audit the following video terminals?',
    ar: 'تدقيق نقاط النهاية؟',
    fa: 'تأیید کنید که ترمینال فیلم زیر بررسی خواهد شد؟',
    pt: 'Tem certeza de auditar os seguintes terminais de vídeo?'
  },
  '请选择类型': {
    zh: '请选择类型',
    en: 'Please select type',
    ar: 'الرجاء اختيار نوع',
    fa: 'لطفا نوع را انتخاب کنید',
    pt: 'Seleccione por favor o tipo'
  },
  '确认将影片修改为上线吗?': {
    zh: '确认将影片修改为上线吗?',
    en: 'Are you sure to change the movie to online?',
    ar: 'هل أنت متأكد من أنك تريد تغيير الفيلم على الانترنت ؟',
    fa: 'مطمئني فيلم رو به آنلاين عوض کني؟',
    pt: 'Você tem certeza de mudar o filme para online?'
  },
  '确认将影片修改为下线吗?': {
    zh: '确认将影片修改为下线吗?',
    en: 'Are you sure to change the movie to offline?',
    ar: 'هل أنت متأكد من أنك تريد تغيير الفيلم إلى دوونلين ؟',
    fa: 'آیا تأیید می کنید که فیلم به صورت آفلاین اصلاح شده است؟',
    pt: 'Você tem certeza de mudar o filme para offline?'
  },
  '确认将影片修改为退回审核吗?': {
    zh: '确认将影片修改为退回审核吗?',
    en: 'Are you sure to change the movie to return for audit?',
    ar: 'تأكد من تعديل الفيلم للعودة إلى التدقيق؟',
    fa: 'مطمئني که فيلم رو عوض کني تا برگردي براي بازرسي؟',
    pt: 'Você tem certeza de modificar o filme a ser devolvido para revisão?'
  },
  '请输入下线原因': {
    zh: '请输入下线原因',
    en: 'Please input the reason for offline',
    ar: 'من فضلك أدخل السبب',
    fa: 'لطفا دلیل را وارد کنید',
    pt: 'Insira o motivo do offline'
  },
  '请先下线影片:': {
    zh: '请先下线影片',
    en: 'Please offline the movie first',
    ar: 'يرجى أولا غير متصل على الانترنت فيلم',
    fa: 'لطفاً اول آفلاین فیلم سینما',
    pt: 'Por favor, offline o filme primeiro'
  },
  '影片名已上线:': {
    zh: '影片名: {list} 已上线,需下线才能删除',
    en: 'Movie name: {list} already online, can be deleted only after offline',
    ar: 'اسم الفيلم: {list} عبر الانترنت بحاجة إلى غير متصل حذف',
    fa: 'نام فیلم: {list} آنلاین است و می‌تواند فقط بعد از آنلاین حذف شود',
    pt: 'Título do filme: {list} foi lançado e precisa ser desligado para ser excluído'
  },
  '剧集名已上线:': {
    zh: '剧集名: {list} 已上线,需下线才能删除',
    en: 'TV Shows name: {list} already online, can be deleted only after offline',
    ar: 'اسم الفيلم: {list} عبر الانترنت بحاجة إلى غير متصل حذف',
    fa: 'نام فیلم: {list} آنلاین است و می‌تواند فقط بعد از آنلاین حذف شود',
    pt: 'Nome do episódio: {list} foi lançado e precisa ser desligado para ser excluído'
  },
  '请先勾选需要删除的影片': {
    zh: '请先勾选需要删除的影片',
    en: 'Please select the movie to delete first',
    ar: 'الرجاء اختيار الفيلم الذي تريد حذفه',
    fa: 'لطفاً فیلم را برای حذف اول انتخاب کنید',
    pt: 'Selecione o filme a ser excluído primeiro'
  },
  '确定删除所选数据吗?': {
    zh: '确定删除所选数据吗?',
    en: 'Are you sure to delete the selected data?',
    ar: 'هل أنت متأكد من أنك تريد حذف البيانات المختارة ؟',
    fa: 'مطمئنی که داده‌های برگزیده را حذف کنید؟',
    pt: 'Tem certeza de que deseja excluir os dados selecionados?'
  },
  '请上传封面图片': {
    zh: '请上传封面图片',
    en: 'Please upload the picture',
    ar: 'يرجى تحميل الصور',
    fa: 'لطفا یک عکس آپلود کنید',
    pt: 'Por favor, envie a imagem'
  },
  '列表': {
    zh: '列表',
    en: 'List',
    ar: 'قائمة',
    fa: 'فهرست',
    pt: 'Lista'
  },
  '确定添加': {
    zh: '确定添加',
    en: 'Add',
    ar: 'أضف إلى',
    fa: 'اضافه کردن به',
    pt: 'Adicionar'
  },
  '批量移除': {
    zh: '批量移除',
    en: 'Batch Remove',
    ar: 'حذف متعددة',
    fa: 'حذف چندین',
    pt: 'Remoção em Lote'
  },
  '是否要移除所选?': {
    zh: '是否要移除所选?',
    en: 'Do you want to remove the selected?',
    ar: 'هل تريد إزالة التحديد ؟',
    fa: 'می‌خواهید برگزیده را حذف کنید؟',
    pt: 'Deseja remover a seleção?'
  },
  '删除成功': {
    zh: '删除成功',
    en: 'Deleted successfully',
    ar: 'تمت الإزالة بنجاح',
    fa: 'با موفقیت حذف شد',
    pt: 'Apagar com Êxito'
  },
  '修改成功': {
    zh: '修改成功',
    en: 'Modify successfully',
    ar: 'تم تغییر بنجاح',
    fa: 'اصلاح با موفقیت انجام شد',
    pt: 'Modificar com Êxito'
  },
  '欢迎': {
    zh: '欢迎',
    en: 'Welcome',
    ar: 'خوش آمدید',
    fa: 'خوش آمدید',
    pt: 'Bem-Vindo'
  },
  '未激活': {
    zh: '未激活',
    en: 'Inactive',
    ar: 'غير فعال',
    fa: 'فعال نشده است',
    pt: 'Inactivado'
  },
  '不存在': {
    zh: '不存在',
    en: 'not exist',
    ar: 'غير موجود',
    fa: 'وجود ندارد',
    pt: 'Não Existe'
  },
  '账号': {
    zh: '账号',
    en: 'Account',
    ar: 'حساب',
    fa: 'حساب',
    pt: 'Número Conta'
  },
  '账号类型': {
    zh: '账号类型',
    en: 'Account Type',
    ar: 'نوع الحساب',
    fa: 'نوع حساب',
    pt: 'Tipo de Conta'
  },
  '激活时间': {
    zh: '激活时间',
    en: 'Active Time',
    ar: 'الوقت النشط',
    fa: 'زمان فعال',
    pt: 'Hora de Ativação'
  },
  '到期时间': {
    zh: '到期时间',
    en: 'Expiration Time',
    ar: 'وقت انتهاء الصلاحية',
    fa: 'زمان انقضا',
    pt: 'Tempo de Expiração'
  },
  '客户': {
    zh: '客户',
    en: 'Client',
    ar: 'عميل',
    fa: 'مشتری',
    pt: 'Cliente'
  },
  '平台': {
    zh: '平台',
    en: 'Platform',
    ar: 'منصة',
    fa: 'پلت فرم',
    pt: 'Plataforma'
  },
  '注册时间': {
    zh: '注册时间',
    en: 'Registration Time',
    ar: 'وقت التسجيل',
    fa: 'زمان ثبت نام',
    pt: 'Tempo de Registo'
  },
  'VIP等级': {
    zh: 'VIP等级',
    en: 'VIP Level',
    ar: 'مستوى VIP',
    fa: 'سطح VIP',
    pt: 'Nível VIP'
  },
  '关联SN': {
    zh: '关联SN',
    en: 'Associated SN',
    ar: 'الرقم التسلسلي المرتبط',
    fa: 'SN مرتبط',
    pt: 'SN Associado'
  },
  '手机': {
    zh: '手机',
    en: 'Phone',
    ar: 'موبيل فون',
    fa: 'تلفن موبایل',
    pt: 'Celular'
  },
  '邮箱': {
    zh: '邮箱',
    en: 'Email',
    ar: 'بريد إلكتروني',
    fa: 'ایمیل',
    pt: 'Caixa de Correio'
  },
  '未查询到数据': {
    zh: '未查询到数据',
    en: 'No data found',
    ar: 'لم يتم العثور على أي بيانات',
    fa: 'داده ای یافت نشد',
    pt: 'Nenhum dado encontrado'
  },
  '用户半停': {
    zh: '用户半停',
    en: 'User half stop',
    ar: 'المستخدم توقف نصفيا',
    fa: 'نیمه توقف کاربر',
    pt: 'User half stop'
  },
  '用户全停': {
    zh: '用户全停',
    en: 'User full stop',
    ar: 'نقطة توقف للمستخدم',
    fa: 'ایستگاه کامل کاربر',
    pt: 'User full stop'
  },
  '欠费半停': {
    zh: '欠费半停',
    en: 'Arrears are half stopped',
    ar: 'تم إيقاف المتأخرات إلى النصف',
    fa: 'معوقات نصف شده است',
    pt: 'Arrears are half stopped'
  },
  '欠费全停': {
    zh: '欠费全停',
    en: 'All arrears are stopped',
    ar: 'تم ايقاف جميع المتأخرات',
    fa: 'تمام معوقات متوقف شده است',
    pt: 'All arrears are stopped'
  },
  '预拆': {
    zh: '预拆',
    en: 'Pre Demolition',
    ar: 'قبل الهدم',
    fa: 'قبل از تخریب',
    pt: 'Pré Demolição'
  },
  '拆机': {
    zh: '拆机',
    en: 'Dismantle',
    ar: 'تفكيك',
    fa: 'از بین بردن',
    pt: 'Desmantelar'
  },
  '账号查询': {
    zh: '账号查询',
    en: 'Account Search',
    ar: 'البحث عن الحساب',
    fa: 'جستجوی حساب',
    pt: 'Consulta de Conta'
  },
  '日志查询': {
    zh: '日志查询',
    en: 'Log Search',
    ar: 'بحث السجل',
    fa: 'جستجوی گزارش',
    pt: 'Consulta de Log'
  },
  '模块': {
    zh: '模块',
    en: 'Model',
    ar: 'نموذج',
    fa: 'مدل',
    pt: 'Módulo'
  },
  '时间': {
    zh: '时间',
    en: 'Time',
    ar: 'وقت',
    fa: 'زمان',
    pt: 'Hora'
  },
  '请求链接': {
    zh: '请求链接',
    en: 'Request Url',
    ar: 'طلب رابط',
    fa: 'درخواست آدرس اینترنتی',
    pt: 'Solicitar Link'
  },
  '请求参数': {
    zh: '请求参数',
    en: 'Request Param',
    ar: 'طلب المعلمة',
    fa: 'درخواست Param',
    pt: 'Parâmetros de Solicitação'
  },
  '返回状态': {
    zh: '返回状态',
    en: 'Response Status',
    ar: 'حالة الاستجابة',
    fa: 'وضعیت پاسخگویی',
    pt: 'Status da Resposta'
  },
  '返回数据': {
    zh: '返回数据',
    en: 'Response Body',
    ar: 'نص الاستجابة',
    fa: 'بدنه پاسخگویی',
    pt: 'Dados de Retorno'
  },
  '今天': {
    zh: '今天',
    en: 'Today',
    ar: 'اليوم',
    fa: 'امروز',
    pt: 'Hoje'
  },
  '最近30分钟': {
    zh: '最近30分钟',
    en: 'Last 30 Minutes',
    ar: 'أخر 30 دقيقة',
    fa: '30 دقیقه آخر',
    pt: 'Últimos 30 Minutos'
  },
  '最近一小时': {
    zh: '最近一小时',
    en: 'Last hour',
    ar: 'الساعة الاخيرة',
    fa: 'ساعت گذشته',
    pt: 'Última Hora'
  },
  '请选择模块': {
    zh: '请选择模块',
    en: 'Please select model',
    ar: 'الرجاء اختيار النموذج',
    fa: 'لطفا مدل را انتخاب کنید',
    pt: 'Seleccione por favor um módulo'
  },
  '请输入账号': {
    zh: '请输入账号',
    en: 'Please input account',
    ar: 'الرجاء إدخال الحساب',
    fa: 'لطفا حساب را وارد کنید',
    pt: 'Introduza o número da sua conta'
  },
  '直播统计': {
    zh: '直播统计',
    en: 'Live Statistics',
    ar: 'إحصائيات مباشرة',
    fa: 'آمار زنده',
    pt: 'Estatísticas Live'
  },
  '客户端软件版本': {
    zh: '客户端软件版本',
    en: 'Client Software Version',
    ar: 'إصدار برنامج العميل',
    fa: 'نسخه نرم افزار مشتری',
    pt: 'Versão Software Cliente'
  },
  '活跃用户': {
    zh: '活跃用户',
    en: 'Active User',
    ar: 'المستخدم النشط',
    fa: 'کاربر فعال',
    pt: 'Utilizadores Activos'
  },
  '用户地区分布': {
    zh: '用户地区分布',
    en: 'User Region',
    ar: 'منطقة المستخدم',
    fa: 'منطقه کاربر',
    pt: 'Região Usuário'
  },
  '最近1周': {
    zh: '最近1周',
    en: 'Last week',
    ar: 'الأسبوع الماضي',
    fa: 'هفته گذشته',
    pt: 'As Últimas um semanas'
  },
  '最近2周': {
    zh: '最近2周',
    en: 'Last 2 weeks',
    ar: 'الاسبوعين الماضيين',
    fa: '2 هفته گذشته',
    pt: 'As Últimas duas semanas'
  },
  '最近1个月': {
    zh: '最近1个月',
    en: 'Last month',
    ar: 'الشهر الماضي',
    fa: 'ماه گذشته',
    pt: 'O Último Mês'
  },
  '设备类型': {
    zh: '设备类型',
    en: 'Device Type',
    ar: 'نوع الجهاز',
    fa: 'نوع دستگاه',
    pt: 'Tipo de Equipamento'
  },
  '机型': {
    zh: '机型',
    en: 'Model',
    ar: 'نموذج',
    fa: 'مدل',
    pt: 'Modelo'
  },
  '请选择设备类型': {
    zh: '请选择设备类型',
    en: 'Please select device type',
    ar: 'الرجاء تحديد نوع الجهاز',
    fa: 'لطفا نوع دستگاه را انتخاب کنید',
    pt: 'Seleccione por favor o tipo de dispositivo'
  },
  '请选择平台': {
    zh: '请选择平台',
    en: 'Please select platform',
    ar: 'الرجاء اختيار المنصة',
    fa: 'لطفا پلتفرم را انتخاب کنید',
    pt: 'Por favor, seleccione a plataforma'
  },
  '请选择机型': {
    zh: '请选择机型',
    en: 'Please select model',
    ar: 'الرجاء اختيار النموذج',
    fa: 'لطفا مدل را انتخاب کنید',
    pt: 'Seleccione por favor o modelo'
  },
  '注：鼠标按住拖动可以调整顺序': {
    zh: '注：鼠标按住拖动可以调整顺序',
    en: 'Note: The mouse can be held down and dragged to adjust the sequence',
    ar: 'ملاحظة: يمكن الضغط باستمرار على الماوس وسحبه لضبط التسلسل',
    fa: 'توجه: ماوس را می توان نگه داشت و برای تنظیم ترتیب آن را کشید',
    pt: 'Nota: Pressionar e arrastar o mouse pode ajustar a ordem'
  },
  '索引': {
    zh: '索引',
    en: 'Index',
    ar: 'فِهرِس',
    fa: 'شاخص',
    pt: 'Índice'
  },
  '节目列表 ': {
    zh: '节目列表',
    en: 'Channel List',
    ar: 'قائمة القنوات',
    fa: 'لیست کانال',
    pt: 'Lista de Canais'
  },
  '播放授权': {
    zh: '播放授权',
    en: 'Play Auth',
    ar: 'تشغيل المصادقة',
    fa: 'Play Auth',
    pt: 'Jogar Autenticação'
  },
  '功能': {
    zh: '功能',
    en: 'Function',
    ar: 'وظيفة',
    fa: 'تابع',
    pt: 'Função'
  },
  '在线用户': {
    zh: '在线用户',
    en: 'Online User',
    ar: 'مستخدم على الإنترنت',
    fa: 'کاربر آنلاین',
    pt: 'Usuário Online'
  },
  '分享': {
    zh: '分享',
    en: 'Share',
    ar: 'يشارك',
    fa: 'به اشتراک بگذارید',
    pt: 'Compartilhar'
  },
  '分享页面': {
    zh: '分享页面',
    en: 'Share Page',
    ar: 'مشاركة الصفحة',
    fa: 'اشتراک گذاری صفحه',
    pt: 'Compartilhar Página'
  },
  '链接': {
    zh: '链接',
    en: 'Link',
    ar: 'وصلة',
    fa: 'پیوند',
    pt: 'Link'
  },
  '下载二维码': {
    zh: '下载二维码',
    en: 'Download QRCode',
    ar: 'تنزيل QRCode',
    fa: 'QRCode را دانلود کنید',
    pt: 'Baixar QRCode'
  },
  '回看设置': {
    zh: '回看设置',
    en: 'Playback Setting',
    ar: 'إعداد التشغيل',
    fa: 'تنظیم پخش',
    pt: 'Configuração Retrospectiva'
  },
  '无回看': {
    zh: '无回看',
    en: 'None',
    ar: 'لا أحد',
    fa: 'هیچ کدام',
    pt: 'Nenhum'
  },
  '3天回看': {
    zh: '3天回看',
    en: '3 Days',
    ar: '3 أيام',
    fa: '3 روز',
    pt: '3 dias'
  },
  '7天回看': {
    zh: '7天回看',
    en: '7 Days',
    ar: '7 أيام',
    fa: '7 روز',
    pt: '7 dias'
  },
  '回看': {
    zh: '回看',
    en: 'Play Back',
    ar: 'تشغيل مرة أخرى',
    fa: 'پخش کن',
    pt: 'Reprodução'
  },
  '直播批量管理': {
    zh: '直播批量管理',
    en: 'Live Management',
    ar: 'الإدارة المباشرة',
    fa: 'مدیریت زنده',
    pt: 'Gerenciamento Live'
  },
  '需要先点击查询后，再点击替换': {
    zh: '需要先点击查询后，再点击替换',
    en: 'You need to click Search first, then click Replace',
    ar: 'تحتاج إلى انقر فوق الاستعلام ، ثم انقر فوق استبدال',
    fa: 'باید اول روی "سوال" فشار کنید، بعد "جایگزینی',
    pt: 'Você precisa clicar em Consultar primeiro e depois clicar em Substituir'
  },
  '请输入分类名称': {
    zh: '请输入分类名称',
    en: 'Please input category name',
    ar: 'الرجاء إدخال اسم الفئة',
    fa: 'لطفا نام دسته را وارد کنید',
    pt: 'Por favor insira o nome da categoria'
  },
  '分类名称的长度应在1到255字符之间': {
    zh: '分类名称的长度应在1到255字符之间',
    en: 'Category name should be between 1 and 255 characters in length',
    ar: 'يجب أن يكون اسم الفئة بين 1 و 255 حرفًا في الطول',
    fa: 'نام رده باید بین 1 تا 255 کاراکتر باشد',
    pt: 'Os nomes das categorias devem ter entre 1 e 255 caracteres de comprimento'
  },
  '时移最多允许设置120分钟': {
    zh: '时移最多允许设置120分钟',
    en: 'The maximum time shift can be set to 120 minutes',
    ar: 'يمكن ضبط الحد الأقصى لوقت التحول إلى 120 دقيقة',
    fa: 'حداکثر شیفت زمانی را می توان روی 120 دقیقه تنظیم کرد',
    pt: 'A mudança de horário pode ser definida em até 120 minutos'
  },
  '时移': {
    zh: '时移',
    en: 'Time Shift',
    ar: 'تحول الوقت',
    fa: 'تغییر زمان',
    pt: 'Mudança de Horário'
  },
  '时移设置': {
    zh: '时移设置',
    en: 'Time Shift Setting',
    ar: 'إعداد تحويل الوقت',
    fa: 'تنظیم تغییر زمان',
    pt: 'Configuração Mudança Horário'
  },
  '时移必须为数字': {
    zh: '时移必须为数字',
    en: 'Time shift must be a number',
    ar: 'يجب أن يكون تحول الوقت رقمًا',
    fa: 'شیفت زمانی باید یک عدد باشد',
    pt: 'A mudança de horário deve ser um número'
  },
  '播放鉴权IP配置': {
    zh: '播放鉴权IP配置',
    en: 'Play Authentication IP',
    ar: 'تشغيل مصادقة IP',
    fa: 'پخش IP احراز هویت',
    pt: 'Jogue a configuração de IP'
  },
  '起始IP': {
    zh: '起始IP',
    en: 'Start IP',
    ar: 'بدء IP',
    fa: 'شروع IP',
    pt: 'Inicie o IP'
  },
  '结束IP': {
    zh: '结束IP',
    en: 'End IP',
    ar: 'نهاية IP',
    fa: 'پایان IP',
    pt: 'IP Final'
  },
  '请输入起始IP': {
    zh: '请输入起始IP',
    en: 'Please input start IP',
    ar: 'الرجاء إدخال عنوان IP الأولي',
    fa: 'لطفا IP شروع را وارد کنید',
    pt: 'Por favor insira o IP inicial'
  },
  '请输入结束IP': {
    zh: '请输入结束IP',
    en: 'Please input end IP',
    ar: 'الرجاء إدخال عنوان IP النهائي',
    fa: 'لطفا IP پایان را وارد کنید',
    pt: 'Por favor, insira o IP final'
  },
  '请输入正确的IP': {
    zh: '请输入正确的IP',
    en: 'Please enter the correct IP address',
    ar: 'الرجاء إدخال عنوان IP الصحيح',
    fa: 'لطفا آدرس IP صحیح را وارد کنید',
    pt: 'Por favor, insira o endereço IP correto'
  },
  '起始IP的长度应在1到255字符之间': {
    zh: '起始IP的长度应在1到255字符之间',
    en: 'The length of the start IP address should be between 1 and 255 characters',
    ar: 'يجب أن يكون طول عنوان IP الأولي بين 1 و 255 حرفًا',
    fa: 'طول آدرس IP شروع باید بین 1 تا 255 کاراکتر باشد',
    pt: 'O comprimento do IP inicial deve estar entre 1 e 255 caracteres'
  },
  '结束的长度应在1到255字符之间': {
    zh: '结束的长度应在1到255字符之间',
    en: 'The length of the end IP address should be between 1 and 255 characters',
    ar: 'يجب أن يكون طول عنوان IP النهائي بين 1 و 255 حرفًا',
    fa: 'طول آدرس IP پایانی باید بین 1 تا 255 کاراکتر باشد',
    pt: 'O comprimento do final deve estar entre 1 e 255 caracteres'
  },
  '备注的长度应在1到50字符之间': {
    zh: '备注的长度应在1到50字符之间',
    en: 'The length of the remark should be between 1 and 50 characters',
    ar: 'يجب أن يكون طول الملاحظة بين 1 و 50 حرفًا',
    fa: 'طول تبصره باید بین 1 تا 50 کاراکتر باشد',
    pt: 'Os comentários devem ter entre 1 e 50 caracteres de comprimento'
  },
  '分组名称的长度应在1到50字符之间': {
    zh: '分组名称的长度应在1到50字符之间',
    en: 'The length of the group name should be between 1 and 50 characters',
    ar: 'يجب أن يكون طول اسم المجموعة بين 1 و 50 حرفًا',
    fa: 'طول نام گروه باید بین 1 تا 50 کاراکتر باشد',
    pt: 'A duração do nome do grupo deve estar entre 1 e 50 caracteres'
  },
  '服务器地址的长度应在1到300字符之间': {
    zh: '服务器地址的长度应在1到300字符之间',
    en: 'The length of the server address should be between 1 and 300 characters',
    ar: 'يجب أن يكون طول عنوان الخادم بين 1 و 300 حرف',
    fa: 'طول آدرس سرور باید بین 1 تا 300 کاراکتر باشد',
    pt: 'O endereço do servidor deve ter entre 1 e 300 caracteres'
  },
  '名称的长度应在1到50字符之间': {
    zh: '名称的长度应在1到50字符之间',
    en: 'The length of the name should be between 1 and 50 characters',
    ar: 'يجب أن يكون طول الاسم بين 1 و 50 حرفًا',
    fa: 'طول نام باید بین 1 تا 50 کاراکتر باشد',
    pt: 'O nome deve ter entre 1 e 50 caracteres'
  },
  '加密KEY的长度应在1到50字符之间': {
    zh: '加密KEY的长度应在1到50字符之间',
    en: 'The length of the encryption key should be between 1 and 50 characters',
    ar: 'يجب أن يكون طول مفتاح التشفير بين 1 و 50 حرفًا',
    fa: 'طول کلید رمزگذاری باید بین 1 تا 50 کاراکتر باشد',
    pt: 'O comprimento da chave criptografada deve estar entre 1 e 50 caracteres'
  },
  'Initial Vector的长度应在1到50字符之间': {
    zh: 'Initial Vector的长度应在1到50字符之间',
    en: 'The length of the Initial Vector should be between 1 and 50 characters',
    ar: 'يجب أن يكون طول المتجه الأولي بين 1 و50 حرفًا',
    fa: 'طول وکتور اولیه باید بین 1 تا 50 کاراکتر باشد',
    pt: 'A duração do vetor inicial deve estar entre 1 e 50 capas'
  },
  '默认code的长度应在1到50字符之间': {
    zh: '默认code的长度应在1到50字符之间',
    en: 'The length of the default code should be between 1 and 50 characters',
    ar: 'يجب أن يكون طول الكود الافتراضي بين 1 و 50 حرفًا',
    fa: 'طول کد پیش فرض باید بین 1 تا 50 کاراکتر باشد',
    pt: 'O comprimento do código padrão deve estar entre 1 e 50 caracteres'
  },
  'SN/账号长度应在1到255字符之间': {
    zh: 'SN/账号长度应在1到255字符之间',
    en: 'The SN/ account length should be between 1 and 255 characters',
    ar: 'يجب أن يكون طول الرقم التسلسلي/الحساب بين 1 و255 حرفًا',
    fa: 'طول حساب SN/ باید بین 1 تا 255 کاراکتر باشد',
    pt: 'A duração do SN/conta deve estar entre 1 e 255 caracteres'
  },
  '结束IP要大于起始IP': {
    zh: '结束IP要大于起始IP',
    en: 'The end IP address must be larger than the start IP address',
    ar: 'يجب أن يكون عنوان IP النهائي أكبر من عنوان IP الأولي',
    fa: 'آدرس IP پایانی باید بزرگتر از آدرس IP شروع باشد',
    pt: 'O IP final é maior que o IP inicial'
  },
  '确定删除这个IP吗': {
    zh: '确定删除这个IP吗',
    en: 'Confirm to delete this IP',
    ar: 'تأكيد لحذف هذا IP',
    fa: 'برای حذف این IP تأیید کنید',
    pt: 'Você tem certeza de excluir este IP'
  },
  '所选频道存在非dash传输协议，不允许设置时移': {
    zh: '所选频道存在非dash传输协议，不允许设置时移',
    en: 'The selected channel has a non-DASH transport protocol and cannot be time-shifted',
    ar: 'القناة المحددة لها بروتوكول نقل غير DASH ولا يمكن تحويلها زمنيًا',
    fa: 'کانال انتخاب شده دارای یک پروتکل انتقال غیر DASH است و نمی توان آن را به صورت زمانی تغییر داد',
    pt: 'O canal selecionado possui um protocolo de transporte não DASH e não pode ser alterado no tempo'
  },
  '第': {
    zh: '第',
    en: 'No ',
    ar: 'لا ',
    fa: 'نه ',
    pt: 'Não'
  },
  '周': {
    zh: '周',
    en: ' week',
    ar: 'أسابيع',
    fa: 'هفته',
    pt: 'Semana'
  },
  '快速双击排序序号,在输入框编辑排序': {
    zh: '快速双击排序序号,在输入框编辑排序',
    en: 'Double click the sort number to edit the sort in the input box.',
    ar: '.انقر نقرا مزدوجا فوق نوع الرقم المسلسل للتحرير',
    fa: '.برای ویرایش کردن شماره‌ی مجموعه دو بار فشار دهید',
    pt: 'Clique duas vezes no número de classificação para editar a classificação na caixa de entrada'
  },
  '双击可以编辑执行时间': {
    zh: '双击可以编辑执行时间',
    en: 'Double click to edit',
    ar: 'انقر نقرا مزدوجا فوق تحرير',
    fa: 'بر روی ویرایش دوبار کلیک کنید',
    pt: 'Dupla -clique para editar o tempo de execução'
  },
  '请选择运营国家': {
    zh: '请选择运营国家',
    en: 'Please select the region',
    ar: 'الرجاء اختيار منطقة العمليات',
    fa: 'لطفا منطقه عملیات را انتخاب کنید',
    pt: 'Seleccione por favor o país de operação'
  },
  '请输入主题名称': {
    zh: '请输入主题名称',
    en: 'Please input the topic name',
    ar: 'من فضلك أدخل اسم الموضوع',
    fa: 'لطفا نام موضوع را وارد کنید',
    pt: 'Por favor insira um nome de tópico'
  },
  '复制': {
    zh: '复制',
    en: 'Copy',
    ar: 'ينسخ',
    fa: 'کپی',
    pt: 'Copiar'
  },
  '已结束': {
    zh: '已结束',
    en: 'Closed',
    ar: 'انتهى',
    fa: 'بسته',
    pt: 'Terminar'
  },
  '执行': {
    zh: '执行',
    en: 'Executing',
    ar: 'في التنفيذ',
    fa: 'تحت عملکرد',
    pt: 'Implemento'
  },
  '确定停运该主题?': {
    zh: '确定停运该主题?',
    en: 'Are you sure to stop the topic?',
    ar: 'توقف عن تشغيل هذا الموضوع ؟',
    fa: 'این موضوع را متوقف کنید؟',
    pt: 'Tem certeza de que deseja interromper este tópico?'
  },
  '确定执行该主题?': {
    zh: '确定执行该主题?',
    en: 'Are you sure to implement the topic?',
    ar: 'هل أنت متأكد من تنفيذ هذا الموضوع ؟',
    fa: 'این موضوع را اجرا کنید؟',
    pt: 'Confirmar a execução do tema?'
  },
  'G-IPTV': {
    zh: '直播频道分类',
    en: 'G-IPTV',
    ar: 'G-IPTV',
    fa: 'G-IPTV',
    pt: 'G-IPTV'
  },
  'G-VOD': {
    zh: '点播分类',
    en: 'G-VOD',
    ar: 'G-VOD',
    fa: 'G-VOD',
    pt: 'G-VOD'
  },
  'RECOMMEND': {
    zh: '点播推荐运营',
    en: 'VOD-PLUS',
    ar: 'VOD-PLUS',
    fa: 'VOD-PLUS',
    pt: 'VOD-PLUS'
  },
  '服务器地址组': {
    zh: '服务器地址组',
    en: 'Server Group',
    ar: 'عنوان الخادم مجموعة',
    fa: 'گروه آدرس سرور',
    pt: 'Grupo de Endereços do Servidor'
  },
  '点播影片': {
    zh: '点播影片',
    en: 'On Demand',
    ar: 'فيلم',
    fa: 'فیلم سینما',
    pt: 'Sob Demanda'
  },
  '您还没有运营方案，点击 “创建” 按钮创建。': {
    zh: '您还没有运营方案，点击 “创建” 按钮创建。',
    en: 'You do not have an operation plan. Click the \'Create\' button to create it.',
    ar: 'أنت لم تقم بتشغيل البرنامج ، انقر فوق إنشاء لإنشاء .',
    fa: 'شما هنوز یک برنامه را اجرا نکرده اید ، برای ایجاد بر روی دکمه \'ایجاد\' کلیک کنید.',
    pt: 'Você ainda não tem um plano operacional. Clique no botão "Criar" para criá-lo.'
  },
  '添加方案': {
    zh: '添加方案',
    en: 'Create',
    ar: 'خلق',
    fa: 'ایجاد کنید',
    pt: 'Criar'
  },
  '推荐方案名称': {
    zh: '推荐方案名称',
    en: 'Plan Name',
    ar: 'اسم البرنامج',
    fa: 'نام برنامه ریزی',
    pt: 'Nome do Esquema Recomendado'
  },
  '请选择运营方案': {
    zh: '请选择运营方案',
    en: 'Please select an operation scheme',
    ar: 'الرجاء اختيار خطة التشغيل',
    fa: 'لطفا برگزیدن یک برنامه عملیات',
    pt: 'Seleccione um plano operacional'
  },
  '请输入': {
    zh: '请输入',
    en: 'Please input',
    ar: 'الرجاء الإدخال',
    fa: 'لطفا وارد کنید',
    pt: 'Por favor, introduza'
  },
  '切换设置': {
    zh: '切换设置',
    en: 'Switching Settings',
    ar: 'تبديل الإعدادات',
    fa: 'تغییر تنظیمات',
    pt: 'Alternando Configurações'
  },
  '大尺寸': {
    zh: '大尺寸',
    en: 'Big Size',
    ar: 'حجم كبير',
    fa: 'اندازه بزرگ',
    pt: 'Tamanho Grande'
  },
  '小尺寸': {
    zh: '小尺寸',
    en: 'Small Size',
    ar: 'حجم صغير',
    fa: 'سایز کوچک',
    pt: 'Tamanho Pequeno'
  },
  '请输入12位数字': {
    zh: '请输入12位数字',
    en: 'Please enter 12 digits',
    ar: 'الرجاء إدخال 12 رقمًا',
    fa: 'لطفا 12 رقم وارد کنید',
    pt: 'Por favor insira 12 dígitos'
  },
  '名称排序失败': {
    zh: '名称排序失败',
    en: 'Sort by name error',
    ar: 'خطأ في الفرز حسب الاسم',
    fa: 'مرتب سازی بر اساس خطای نام',
    pt: 'A classificação dos nomes falhou'
  },
  'inputRange': {
    zh: '请输入1到{maxValue}范围内的整数',
    en: 'Enter an integer between 1 and {maxValue}',
    ar: '',
    fa: '',
    pt: 'Digite um número inteiro entre 1 e {maxValue}'
  },
  '方案设置': {
    zh: '方案设置',
    en: 'Scheme Setting',
    ar: 'إعداد المخطط',
    fa: 'تنظیم طرح',
    pt: 'Configuração Esquema'
  },
  '缓存': {
    zh: '缓存',
    en: 'Cache',
    ar: 'مخبأ',
    fa: 'حافظه پنهان',
    pt: 'Cache'
  },
  '默认IPTV值': {
    zh: '默认IPTV值',
    en: 'Default IPTV Count',
    ar: 'عدد IPTV الافتراضي',
    fa: 'تعداد پیش فرض IPTV',
    pt: 'Contagem IPTV Padrão'
  },
  'IPTV应用运营': {
    zh: 'IPTV应用运营',
    en: 'IPTV Application',
    ar: 'تطبيق IPTV',
    fa: 'برنامه IPTV',
    pt: 'Aplicativo IPTV'
  },
  'IPTV管理': {
    zh: 'IPTV管理',
    en: 'IPTV Manage',
    ar: 'إدارة IPTV',
    fa: 'مدیریت IPTV',
    pt: 'Gerenciamento de IPTV'
  },
  '终端内容管理': {
    zh: '终端内容管理',
    en: 'Terminal Content Manage',
    ar: 'إدارة محتوى المحطة الطرفية',
    fa: 'مدیریت محتوای ترمینال',
    pt: 'Conteúdo Terminal'
  },
  '请输入正确的SN': {
    zh: '请输入正确的SN',
    en: 'Please enter the correct SN',
    ar: 'الرجاء إدخال الرقم التسلسلي الصحيح',
    fa: 'لطفا SN صحیح را وارد کنید',
    pt: 'Por favor, insira o SN correto'
  },
  '账号已存在': {
    zh: '账号已存在',
    en: 'Account already exists',
    ar: 'الحساب موجود بالفعل',
    fa: 'حساب از قبل وجود دارد',
    pt: 'Essa conta já existe'
  },
  '激活码已存在': {
    zh: '激活码已存在',
    en: 'The activation code already exists',
    ar: 'رمز التفعيل موجود بالفعل',
    fa: 'کد فعال سازی از قبل وجود دارد',
    pt: 'O código de ativação já existe'
  },
  '加密方式': {
    zh: '加密方式',
    en: 'Encryption Type',
    ar: 'نوع التشفير',
    fa: 'نوع رمزگذاری',
    pt: 'Método de Encriptação'
  },
  '请求类型': {
    zh: '请求类型',
    en: 'Request Type',
    ar: 'نوع الطلب',
    fa: 'نوع درخواست',
    pt: 'Tipo de Solicitação'
  },
  '加密KEY': {
    zh: '加密KEY',
    en: 'Encryption KEY',
    ar: 'مفتاح التشفير',
    fa: 'کلید رمزگذاری',
    pt: 'Chave de Encriptação'
  },
  '默认预置': {
    zh: '默认预置',
    en: 'Default Setting',
    ar: 'الإعداد الافتراضي',
    fa: 'تنظیمات پیش فرض',
    pt: 'Predefinição Padrão'
  },
  'IPTV详情': {
    zh: 'IPTV详情',
    en: 'IPTV Detail',
    ar: 'تفاصيل IPTV',
    fa: 'جزئیات IPTV',
    pt: 'Detalhes de IPTV'
  },
  '数据': {
    zh: '数据',
    en: 'Data',
    ar: 'بيانات',
    fa: 'داده ها',
    pt: 'Dados'
  },
  '是否默认': {
    zh: '是否默认',
    en: 'Default Setting',
    ar: 'الإعداد الافتراضي',
    fa: 'تنظیمات پیش فرض',
    pt: 'Se Deve Padrão'
  },
  '默认code': {
    zh: '默认code',
    en: 'Code',
    ar: 'شفرة',
    fa: 'کد',
    pt: 'Código Padrão'
  },
  'IPTV供应商': {
    zh: 'IPTV供应商',
    en: 'IPTV Provider',
    ar: 'مزود خدمة IPTV',
    fa: 'ارائه دهنده IPTV',
    pt: 'Provedor de IPTV'
  },
  '确认删除该IPTV': {
    zh: '确认删除该IPTV',
    en: 'Confirm to delete this IPTV',
    ar: 'تأكيد لحذف هذا IPTV',
    fa: 'برای حذف این IPTV تأیید کنید',
    pt: 'Confirme para excluir este IPTV'
  },
  '方案组': {
    zh: '方案组',
    en: 'Solution Team',
    ar: 'فريق الحلول',
    fa: 'تیم راه حل',
    pt: 'Grupo do Esquema'
  },
  '运营区域': {
    zh: '运营区域',
    en: 'Operating Area',
    ar: 'منطقة التشغيل',
    fa: 'منطقه عملیاتی',
    pt: 'Área Operacional'
  },
  '是否定制': {
    zh: '是否定制',
    en: 'Customized',
    ar: 'مخصص',
    fa: 'سفارشی',
    pt: 'Seja Para Personalizar'
  },
  'Model列表': {
    zh: 'Model列表',
    en: 'Model List',
    ar: 'قائمة النماذج',
    fa: 'لیست مدل',
    pt: 'Lista de Modelos'
  },
  'SN列表': {
    zh: 'SN列表',
    en: 'SN',
    ar: 'الرقم التسلسلي',
    fa: 'SN',
    pt: 'Lista SN'
  },
  'global': {
    zh: '全球',
    en: 'Global',
    ar: 'عالمي',
    fa: 'جهانی',
    pt: 'Global'
  },
  'SN组列表': {
    zh: 'SN组列表',
    en: 'SN Group',
    ar: 'مجموعة إس إن',
    fa: 'گروه SN',
    pt: 'Lista de grupos SN'
  },
  '定制IPTV': {
    zh: '定制IPTV',
    en: 'Custom IPTV',
    ar: 'IPTV مخصص',
    fa: 'IPTV سفارشی',
    pt: 'IPTV Personalizada'
  },
  '定制IPTV列表': {
    zh: '定制IPTV列表',
    en: 'Custom IPTV List',
    ar: 'قائمة IPTV مخصصة',
    fa: 'لیست IPTV سفارشی',
    pt: 'Lista IPTV Personalizada'
  },
  '配置': {
    zh: '配置',
    en: 'Settings',
    ar: 'إعدادات',
    fa: 'تنظیمات',
    pt: 'Configurações'
  },
  '黑名单': {
    zh: '黑名单',
    en: 'Black List',
    ar: 'القائمة السوداء',
    fa: 'لیست سیاه',
    pt: 'Lista Negra'
  },
  '全球': {
    zh: '全球',
    en: 'Global',
    ar: 'عالمي',
    fa: 'جهانی',
    pt: 'Global'
  },
  '批量': {
    zh: '批量',
    en: 'Batch',
    ar: 'حزمة',
    fa: 'دسته ای',
    pt: 'Lote'
  },
  '创建分组': {
    zh: '创建分组',
    en: 'Create Group',
    ar: 'إنشاء مجموعة',
    fa: 'ایجاد گروه',
    pt: 'Criar Grupo'
  },
  '分组名称': {
    zh: '分组名称',
    en: 'Group Name',
    ar: 'اسم المجموعة',
    fa: 'نام گروه',
    pt: 'Nome do Grupo'
  },
  'SN分组编辑': {
    zh: 'SN分组编辑',
    en: 'SN Group Edit',
    ar: 'تعديل مجموعة SN',
    fa: 'ویرایش گروه SN',
    pt: 'Edição de Grupo SN'
  },
  '确定移除SN': {
    zh: '确定移除SN',
    en: 'Confirm to remove the SN',
    ar: 'تأكيد لإزالة الرقم التسلسلي',
    fa: 'برای حذف SN تأیید کنید',
    pt: 'Confirme para remover SN'
  },
  '添加SN': {
    zh: '添加SN',
    en: 'Add SN',
    ar: 'إضافة الرقم التسلسلي',
    fa: 'SN را اضافه کنید',
    pt: 'Adicionar SN'
  },
  '双击单元格支持修改': {
    zh: '双击单元格支持修改',
    en: 'Double-click a cell to support modification',
    ar: 'انقر نقرًا مزدوجًا فوق خلية لدعم التعديل',
    fa: 'برای پشتیبانی از اصلاح روی یک سلول دوبار کلیک کنید',
    pt: 'Clique duas vezes em uma célula para suportar modificação'
  },
  '勾选选取IPTV可以显示在终端，勾选默认编辑排序IPTV可以按排序在终端默认位置显示IPTV，勾选黑名单IPTV设置为黑名单不显示在配置的终端': {
    zh: '勾选选取IPTV可以显示在终端，勾选默认编辑排序IPTV可以按排序在终端默认位置显示IPTV，勾选黑名单IPTV设置为黑名单不显示在配置的终端',
    en: 'Select Select IPTV to display IPTV in the terminal, select default Edit sort IPTV to display IPTV in the default position of the terminal, select blacklist IPTV to set the blacklist not to display in the configured terminal',
    ar: 'حدد تحديد IPTV لعرض IPTV في المحطة الطرفية، حدد الافتراضي تحرير فرز IPTV لعرض IPTV في الوضع الافتراضي للمحطة الطرفية، حدد القائمة السوداء IPTV لتعيين القائمة السوداء لعدم عرضها في المحطة الطرفية التي تم تكوينها',
    fa: 'انتخاب IPTV برای نمایش IPTV در ترمینال، انتخاب پیش فرض ویرایش مرتب سازی IPTV برای نمایش IPTV در موقعیت پیش فرض ترمینال، لیست سیاه IPTV را انتخاب کنید تا لیست سیاه در ترمینال پیکربندی شده نمایش داده نشود.',
    pt: 'Selecione Selecione IPT Para exibir IPTV No terminal, selecione EDIT PADEIDO Classificar IPTV para exibir IPTV Na posição padrão do terminal, selecione Blacklist IPTV para definir a lista negra para não exibir no terminal configurado'
  },
  'SN基础配置': {
    zh: 'SN基础配置',
    en: 'SN Basic Configuration',
    ar: 'التكوين الأساسي لـ SN',
    fa: 'پیکربندی پایه SN',
    pt: 'SN Configuração Básica'
  },
  '超出方案组设置的默认IPTV最大的数量': {
    zh: '超出方案组设置的默认IPTV最大的数量',
    en: 'The number of IPTV exceeds the default maximum set by the solution group',
    ar: 'يتجاوز عدد IPTV الحد الأقصى الافتراضي الذي تم تعيينه بواسطة مجموعة الحلول',
    fa: 'تعداد IPTV از حداکثر پیش فرض تعیین شده توسط گروه راه حل بیشتر است',
    pt: 'O número de IPTV excede o máximo padrão definido pelo grupo de soluções'
  },
  '默认排序不可重复': {
    zh: '默认排序不可重复',
    en: 'The default sort is not repeatable',
    ar: 'الفرز الافتراضي غير قابل للتكرار',
    fa: 'مرتب سازی پیش فرض قابل تکرار نیست',
    pt: 'A classificação padrão não é repetível'
  },
  '默认排序不可为空': {
    zh: '默认排序不可为空',
    en: 'The default sort cannot be empty',
    ar: 'لا يمكن أن يكون الفرز الافتراضي فارغًا',
    fa: 'مرتب سازی پیش فرض نمی تواند خالی باشد',
    pt: 'A classificação padrão não pode estar vazia'
  },
  '选中批量操作{type}定制信息不同，继续操作批量将会清空已有设置，确定继续操作？': {
    zh: '选中批量操作{type}定制信息不同，继续操作批量将会清空已有设置，确定继续操作？',
    en: 'Select Batch operation {type} customization information is different. Continuing batch operation will clear existing Settings. Are you sure to continue?',
    ar: 'تختلف معلومات تخصيص عملية الدفعة {type}. سيؤدي الاستمرار في عملية الدفعة إلى مسح الإعدادات الموجودة. هل أنت متأكد من الاستمرار؟',
    fa: 'اطلاعات سفارشی سازی عملیات دسته ای {type} را انتخاب کنید. ادامه عملیات دسته‌ای، تنظیمات موجود را پاک می‌کند. مطمئنی ادامه میدی؟',
    pt: 'As informações de personalização de seleção de operação em lote {tipo} são diferentes. Continuar a operação em lote limpará as configurações existentes. Tem certeza de que deseja continuar?'
  },
  '请选择任意一个Model': {
    zh: '请选择任意一个Model',
    en: 'Please select any Model',
    ar: 'الرجاء تحديد أي نموذج',
    fa: 'لطفاً هر مدلی را انتخاب کنید',
    pt: 'Seleccione qualquer modelo'
  },
  '选取': {
    zh: '选取',
    en: 'Select',
    ar: 'يختار',
    fa: 'انتخاب کنید',
    pt: 'Selecione'
  },
  '正在检验SN请稍等...': {
    zh: '正在检验SN请稍等...',
    en: 'Checking SN Please wait...',
    ar: 'جاري التحقق من الرقم التسلسلي يرجى الانتظار...',
    fa: 'در حال بررسی SN لطفا صبر کنید...',
    pt: 'Verificando SN Aguarde...'
  },
  '图片URL的长度应在1到500字符之间': {
    zh: '图片URL的长度应在1到500字符之间',
    en: 'Image url should be between 1 and 500 characters in length',
    ar: 'يجب أن يكون عنوان URL للصورة بين 1 و 500 حرف',
    fa: 'URL تصویر باید بین 1 تا 500 کاراکتر باشد',
    pt: 'O URL da imagem deve ter entre 1 e 500 caracteres'
  },
  '请上传图片类型的文件': {
    zh: '请上传图片类型的文件',
    en: 'Please upload an image type file',
    ar: 'الرجاء تحميل ملف نوع الصورة',
    fa: 'لطفا یک فایل نوع تصویر آپلود کنید',
    pt: 'Envie por favor um ficheiro do tipo de imagem'
  },
  '上传的图片不能超过100MB': {
    zh: '上传的图片不能超过100MB',
    en: 'Uploaded images cannot exceed 100MB',
    ar: 'لا يمكن أن يتجاوز حجم الصور المرفوعة 100 ميجا بايت',
    fa: 'تصاویر آپلود شده نمی توانند بیش از 100 مگابایت باشند',
    pt: 'As imagens enviadas não podem exceder 100 MB'
  },
  'IP已存在': {
    zh: 'IP已存在',
    en: 'IP already exists',
    ar: 'عنوان IP موجود بالفعل',
    fa: 'IP از قبل وجود دارد',
    pt: 'IP já existe'
  },
  '其他': {
    zh: '其他',
    en: 'Other',
    ar: 'آخر',
    fa: 'دیگر',
    pt: 'Outros'
  },
  '请检查数据信息': {
    zh: '请检查数据信息',
    en: 'Please check the data information',
    ar: 'يرجى التحقق من معلومات البيانات',
    fa: 'لطفا اطلاعات داده ها را بررسی کنید',
    pt: 'Por favor, verifique a informação dos dados'
  },
  '请检查基础信息': {
    zh: '请检查基础信息',
    en: 'Please check the basic information',
    ar: 'يرجى التحقق من المعلومات الأساسية',
    fa: 'لطفا اطلاعات اولیه را بررسی کنید',
    pt: 'Por favor, verifique as informações básicas'
  },
  '数据信息': {
    zh: '数据信息',
    en: 'Data Info',
    ar: 'معلومات البيانات',
    fa: 'اطلاعات داده ها',
    pt: 'Informação dos Dados'
  },
  'SN有误请修改后再提交': {
    zh: 'SN有误请修改后再提交',
    en: 'The SN is incorrect, please modify it and submit it again',
    ar: 'الرقم التسلسلي غير صحيح، يرجى تعديله وإرساله مرة أخرى',
    fa: 'SN نادرست است، لطفاً آن را اصلاح کنید و دوباره ارسال کنید',
    pt: 'O SN está incorreto, modifique-o e envie-o novamente'
  },
  '验证码有误请修改后再提交': {
    zh: '验证码有误请修改后再提交',
    en: 'Please modify the verification code and submit it again',
    ar: 'يرجى تعديل رمز التحقق وإرساله مرة أخرى',
    fa: 'لطفاً کد تأیید را تغییر دهید و دوباره ارسال کنید',
    pt: 'Modifique o código de verificação e envie-o novamente'
  },
  'IPTV已关联终端,确认删除该IPTV': {
    zh: 'IPTV已关联终端,确认删除该IPTV',
    en: 'The IPTV has been associated with a terminal and confirmed to delete the IPTV',
    ar: 'IPTV با یک پایانه مرتبط شده است و تأیید شده است که IPTV را حذف می کند',
    fa: 'تم ربط IPTV بجهاز طرفي وتم التأكد من حذف IPTV',
    pt: 'O IPTV tem sido associado a um terminal e confirmado para excluir o IPTV'
  },
  '创建IPTV': {
    zh: '创建IPTV',
    en: 'Create IPTV',
    ar: 'إنشاء IPTV',
    fa: 'IPTV ایجاد کنید',
    pt: 'Criar IPTV'
  },
  '编辑IPTV': {
    zh: '编辑IPTV',
    en: 'Edit IPTV',
    ar: 'تعديل IPTV',
    fa: 'IPTV را ویرایش کنید',
    pt: 'Editar IPTV'
  },
  'IPTV图标': {
    zh: 'IPTV图标',
    en: 'IPTV Logo',
    ar: 'شعار IPTV',
    fa: 'لوگوی IPTV',
    pt: 'Logotipo IPTV'
  },
  '正在校验SN请稍等...': {
    zh: '正在校验SN请稍等...',
    en: 'Checking SN Please wait...',
    ar: 'جاري التحقق من الرقم التسلسلي يرجى الانتظار...',
    fa: 'در حال بررسی SN لطفا صبر کنید...',
    pt: 'Verificando SN Aguarde...'
  },
  '请输入ID': {
    zh: '请输入ID',
    en: 'Please input ID',
    ar: 'الرجاء إدخال معرف',
    fa: 'لطفا شناسه را وارد کنید',
    pt: 'Por favor, digite ID'
  },
  '验证码': {
    zh: '验证码',
    en: 'Verification Code',
    ar: 'رمز التحقق',
    fa: 'کد تایید',
    pt: 'Código Verificação'
  },
  'ID重复': {
    zh: 'ID重复',
    en: 'ID duplication',
    ar: 'تكرار الهوية',
    fa: 'کپی شناسنامه',
    pt: 'ID Duplicado'
  },
  '鉴权IP配置': {
    zh: '鉴权IP配置',
    en: 'IP Authentication Setting',
    ar: 'إعداد مصادقة IP',
    fa: 'تنظیمات تایید هویت IP',
    pt: 'Configuração Autenticação IP'
  },
  '优先播放设置': {
    zh: '优先播放设置',
    en: 'Priority Play Setting',
    ar: 'إعداد اللعب حسب الأولوية',
    fa: 'تنظیمات پخش اولویتی',
    pt: 'Configurações Prioritárias de Reprodução'
  },
  '服务器': {
    zh: '服务器',
    en: 'Server',
    ar: 'الخادم',
    fa: 'سرور',
    pt: 'Servidor'
  },
  '确定移除SN/账号': {
    zh: '确定移除SN/账号',
    en: 'Confirm to delete SN/Account',
    ar: 'تأكيد حذف AN/الحساب',
    fa: 'برای حذف AN/Account تأیید کنید',
    pt: 'Confirme para excluir AN/Conta'
  },
  '服务器设置': {
    zh: '服务器设置',
    en: 'Server Setting',
    ar: 'إعدادات الخادم',
    fa: 'تنظیمات سرور',
    pt: 'Configuração do Servidor'
  },
  '服务器列表': {
    zh: '服务器列表',
    en: 'Server List',
    ar: 'قائمة الخوادم',
    fa: 'لیست سرور',
    pt: 'Lista de Servidores'
  },
  '确定删除这个服务吗?': {
    zh: '确定删除这个服务吗?',
    en: 'Confirm to delete this server',
    ar: 'تأكيد لحذف هذا الخادم',
    fa: 'برای حذف این سرور تأیید کنید',
    pt: 'Tem certeza de que deseja excluir este serviço?'
  },
  '请输入SN/账号': {
    zh: '请输入SN/账号',
    en: 'Please input SN/Account',
    ar: 'الرجاء إدخال الرقم التسلسلي/الحساب',
    fa: 'لطفا SN/Account را وارد کنید',
    pt: 'Por favor insira SN/Conta'
  },
  '请选择服务器': {
    zh: '请选择服务器',
    en: 'Please select server',
    ar: 'الرجاء تحديد الخادم',
    fa: 'لطفا سرور را انتخاب کنید',
    pt: 'Por favor selecione o servidor'
  },
  '请输入IP': {
    zh: '请输入IP',
    en: 'Please input IP',
    ar: 'الرجاء إدخال عنوان IP',
    fa: 'لطفا IP وارد کنید',
    pt: 'Por favor insira o IP'
  },
  '直播播放配置': {
    zh: '直播播放配置',
    en: 'Live Play Setting',
    ar: 'إعداد اللعب المباشر',
    fa: 'تنظیمات پخش زنده',
    pt: 'Configuração ao Vivo'
  },
  'SN已存在': {
    zh: 'SN已存在',
    en: 'SN exists',
    ar: 'الرقم التسلسلي موجود',
    fa: 'SN وجود دارد',
    pt: 'SN já existe'
  },
  '主品牌名称': {
    zh: '主品牌名称',
    en: 'Main Brand Name',
    ar: 'اسم العلامة التجارية',
    fa: 'نام برند',
    pt: 'Marca Principal'
  },
  '请输入主品牌名称': {
    zh: '请输入主品牌名称',
    en: 'Please input the main brand name',
    ar: 'الرجاء إدخال اسم العلامة التجارية',
    fa: 'لطفاً نام برند را وارد کنید',
    pt: 'Por favor insira o nome da marca principal'
  },
  '注: SN号和软件账号二选一填写': {
    zh: '注: SN号和软件账号二选一填写',
    en: 'Tips: Choose between SN number and software account to fill in',
    ar: 'ملاحظة: رقم SN ورقم حساب البرنامج حدد ملءًا واحدًا',
    fa: 'یادداشت: انتخاب بین شماره SN و حساب نرم‌افزار برای پر کردن',
    pt: 'Dicas: escolha entre o número SN e a conta de software para preencher'
  },
  'SN号和软件账号二选一填写': {
    zh: 'SN号和软件账号二选一填写',
    en: 'Choose between SN number and software account to fill in',
    ar: 'ملاحظة SN ورقم حساب البرنامج حدد ملءًا واحدًا',
    fa: 'یادداشت SN و حساب نرم‌افزار برای پر کردن',
    pt: 'Escolha um dos números SN e número da conta de software para preencher'
  },
  '使用人员名称': {
    zh: '使用人员名称',
    en: 'User Name',
    ar: 'اسم المستخدم',
    fa: 'نام کاربر',
    pt: 'Nome de Usuário'
  },
  '请输入使用人员名称': {
    zh: '请输入使用人员名称',
    en: 'Please input the user name',
    ar: 'الرجاء إدخال اسم المستخدم',
    fa: 'لطفا نام کاربر را وارد کنید',
    pt: 'Por favor insira o nome de usuário'
  },
  'SN': {
    zh: 'SN',
    en: 'SN',
    ar: 'SN',
    fa: 'SN',
    pt: 'SN'
  },
  'SN号': {
    zh: 'SN号',
    en: 'SN',
    ar: 'SN',
    fa: 'SN',
    pt: 'SN'
  },
  '软件账号': {
    zh: '软件账号',
    en: 'Software Account',
    ar: 'حساب البرمجيات',
    fa: 'حساب نرم‌افزار',
    pt: 'Conta de Software'
  },
  '使用开关': {
    zh: '使用开关',
    en: 'Switch',
    ar: 'استخدم التبديل',
    fa: 'از سوئیچ استفاده کنید',
    pt: 'Interruptor'
  },
  '终端审核权限': {
    zh: '终端审核权限',
    en: 'Terminal Permissions',
    ar: 'تدقيق نقاط النهاية',
    fa: 'مجوزهای بررسی ترمینال',
    pt: 'Permissões Terminal'
  },
  '导入中, 请稍等': {
    zh: '导入中, 请稍等',
    en: 'Importing, please wait',
    ar: 'لحظة من فضلك',
    fa: 'يه لحظه لطفا',
    pt: 'Importando, por favor, espere'
  },
  'Upload has been canceled': {
    zh: '取消上传',
    en: 'Upload has been canceled',
    ar: 'تم إلغاء التحميل',
    fa: 'آپلود لغو شده است',
    pt: 'O carregamento foi cancelado'
  },
  'Upload error, please upload again.': {
    zh: '上传失败, 请稍后重试',
    en: 'Upload error, please upload again.',
    ar: 'يرجى المحاولة مرة أخرى',
    fa: 'آپلود لغو شده است',
    pt: 'Erro de carregamento, por favor carregue novamente.'
  },
  '导入成功': {
    zh: '导入成功',
    en: 'Import successful',
    ar: 'استيراد بنجاح',
    fa: 'واردات موفقیت',
    pt: 'Importar com Sucesso'
  },
  '导入失败': {
    zh: '导入失败',
    en: 'Import failed',
    ar: 'فشل استيراد',
    fa: 'واردات شکست خورد',
    pt: 'Falha na Importação'
  },
  '关联同步': {
    zh: '关联同步',
    en: 'Associative',
    ar: 'مزامنة',
    fa: 'ارتباط',
    pt: 'Associado'
  },
  '关联信息': {
    zh: '关联信息',
    en: 'Associative',
    ar: 'مترابط',
    fa: 'ارتباط',
    pt: 'Associado'
  },
  '信息': {
    zh: '信息',
    en: 'Info',
    ar: 'معلومات',
    fa: 'اطلاعات',
    pt: 'Informação'
  },
  '登录方式': {
    zh: '登录方式',
    en: 'Login Type',
    ar: 'نوع تسجيل الدخول',
    fa: 'نوع ورود',
    pt: 'Método de Login'
  },
  '用户名': {
    zh: '用户名',
    en: 'Username',
    ar: 'اسم المستخدم',
    fa: 'نام کاربری',
    pt: 'Nome de Utilizador'
  },
  '密码': {
    zh: '密码',
    en: 'Password',
    ar: 'كلمة المرور',
    fa: 'رمز عبور',
    pt: 'Senha'
  },
  '客户端类型': {
    zh: '客户端类型',
    en: 'Client Type',
    ar: 'نوع العميل',
    fa: 'نوع مشتری',
    pt: 'Tipo de Cliente'
  },
  '直播接口调试': {
    zh: '直播接口调试',
    en: 'Live Interface Debugging',
    ar: 'تصحيح أخطاء الواجهة المباشرة',
    fa: 'اشکال زدایی رابط زنده',
    pt: 'Depuração interface Live'
  },
  '跟踪调试': {
    zh: '跟踪调试',
    en: 'Trace Debugging',
    ar: 'تتبع الأخطاء التصحيحية',
    fa: 'ردیابی اشکال زدایی',
    pt: 'Rastrear Depurar'
  },
  '请输入验证码': {
    zh: '请输入验证码',
    en: 'Please enter the verification code',
    ar: 'الرجاء إدخال رمز التحقق',
    fa: 'لطفا کد تایید را وارد کنید',
    pt: 'Introduza o código de verificação!'
  },
  '显示': {
    zh: '显示',
    en: 'Show',
    ar: 'يعرض',
    fa: 'نمایش دهید',
    pt: 'Mostrar'
  },
  '登录': {
    zh: '登录',
    en: 'Login',
    ar: 'تسجيل الدخول',
    fa: 'وارد شوید',
    pt: 'Iniciar Sessão'
  },
  '节目名称': {
    zh: '节目名称',
    en: 'Channel Name',
    ar: 'اسم القناة',
    fa: 'نام کانال',
    pt: 'Nome Programa'
  },
  '图标': {
    zh: '图标',
    en: 'Logo',
    ar: 'الشعار',
    fa: 'لوگو',
    pt: 'Ícones'
  },
  '是否要删除音频：': {
    zh: '是否要删除音频：',
    en: 'Confirm to delete the audio: ',
    ar: 'تأكيد حذف الصوت:',
    fa: 'برای حذف صدا تأیید کنید:',
    pt: 'Pretende apagar o áudio:'
  },
  '已取消': {
    zh: '已取消',
    en: 'Cancelled',
    ar: 'إلغاء',
    fa: 'کنسل شد',
    pt: 'Cancelado'
  },
  '更新成功': {
    zh: '更新成功',
    en: 'Update Success',
    ar: 'تم التحديث بنجاح',
    fa: 'به روز رسانی با موفقیت',
    pt: 'Atualização bem sucedida'
  },
  '添加成功': {
    zh: '添加成功',
    en: 'Add Success',
    ar: 'إضافة النجاح',
    fa: 'موفقیت را اضافه کنید',
    pt: 'Adicionar com Êxito'
  },
  'url的长度不能超过256': {
    zh: 'url的长度不能超过256',
    en: 'The url length cannot exceed 256 bytes',
    ar: 'لا يمكن أن يتجاوز طول عنوان URL 256 بايت',
    fa: 'طول url نمی تواند از 256 بایت تجاوز کند',
    pt: 'O comprimento do url não pode exceder 256'
  },
  'sid必须为0-65536之间的整数': {
    zh: 'sid必须为0-65536之间的整数',
    en: 'The sid must be an integer ranging from 0 to 65536',
    ar: 'يجب أن يكون sid عددًا صحيحًا يتراوح من 0 إلى 65536',
    fa: 'Sid باید یک عدد صحیح از 0 تا 65536 باشد',
    pt: 'SID tem de ser um número inteiro entre 0-65536'
  },
  'tp必须为1000-13000之间的整数': {
    zh: 'tp必须为1000-13000之间的整数',
    en: 'The tp must be an integer between 1000 and 13000',
    ar: 'يجب أن يكون tp عددًا صحيحًا بين 1000 و13000',
    fa: 'tp باید یک عدد صحیح بین 1000 و 13000 باشد',
    pt: 'TP tem de ser um número inteiro entre 1000-13000'
  },
  'sat必须为0-3600之间的整数': {
    zh: 'sat必须为0-3600之间的整数',
    en: 'The sat must be an integer ranging from 0 to 3600',
    ar: 'يجب أن يكون SAT عددًا صحيحًا يتراوح من 0 إلى 3600',
    fa: 'sat باید یک عدد صحیح از 0 تا 3600 باشد',
    pt: 'SAT tem de ser um número inteiro entre 0-3600'
  },
  'cid必须为大于0的整数': {
    zh: 'cid必须为大于0的整数',
    en: 'cid must be an integer greater than 0',
    ar: 'يجب أن يكون cid عددًا صحيحًا أكبر من 0',
    fa: 'cid باید یک عدد صحیح بزرگتر از 0 باشد',
    pt: 'CID tem de ser um número inteiro superior a 0'
  },
  '节目名称的长度不能超过50': {
    zh: '节目名称的长度不能超过50',
    en: 'The length of the channel name cannot exceed 50',
    ar: 'لا يمكن أن يتجاوز طول اسم القناة 50',
    fa: 'طول نام کانال نمی تواند از 50 تجاوز کند',
    pt: 'O comprimento do nome do programa não pode exceder 50'
  },
  '名称不能为空': {
    zh: '名称不能为空',
    en: 'The channel name cannot be empty',
    ar: 'لا يمكن أن يكون اسم القناة فارغًا',
    fa: 'نام کانال نمی تواند خالی باشد',
    pt: 'Name não pode ser nulo'
  },
  'cid不能为空': {
    zh: 'cid不能为空',
    en: 'The cid cannot be empty',
    ar: 'لا يمكن أن يكون ملف cid فارغًا',
    fa: 'cid نمی تواند خالی باشد',
    pt: 'CID must not be null'
  },
  '序号重复': {
    zh: '序号重复',
    en: 'Sequence repeat',
    ar: 'تكرار التسلسل',
    fa: 'تکرار توالی',
    pt: 'Números de série duplicados'
  },
  '新增音频': {
    zh: '新增音频',
    en: 'Add Audio',
    ar: 'إضافة الصوت',
    fa: 'افزودن صدا',
    pt: 'Adicionar áudio'
  },
  '编辑音频': {
    zh: '编辑音频',
    en: 'Edit Audio',
    ar: 'تحرير الصوت',
    fa: 'ویرایش صدا',
    pt: 'Editar áudio'
  },
  '公共频道序号': {
    zh: '公共频道序号',
    en: 'Public Channel Sort',
    ar: 'فرز القنوات العامة',
    fa: 'مرتب سازی کانال عمومی',
    pt: 'Classificação Canal Público'
  },
  '不在终端显示': {
    zh: '不在终端显示',
    en: 'Off-terminal display',
    ar: 'شاشة خارج المحطة',
    fa: 'نمایشگر خارج از ترمینال',
    pt: 'Não exibido no terminal'
  },
  '请输入节目名称': {
    zh: '请输入节目名称',
    en: 'Please input channel name',
    ar: 'الرجاء إدخال اسم القناة',
    fa: 'لطفا نام کانال را وارد کنید',
    pt: 'Introduza o nome do programa'
  },
  '公共频道序号必须为数字': {
    zh: '公共频道序号必须为数字',
    en: 'Public channel sort must be a number',
    ar: 'يجب أن يكون فرز القناة العامة رقمًا',
    fa: 'مرتب‌سازی کانال عمومی باید یک عدد باشد',
    pt: 'A classificação do canal público precisa ser um número'
  },
  '默认': {
    zh: '默认',
    en: 'Default',
    ar: 'خرق',
    fa: 'پیش‌فرض',
    pt: 'Predefinição'
  },
  '终端不显示': {
    zh: '终端不显示',
    en: 'Terminal does not display',
    ar: 'لا يتم عرض المحطة الطرفية',
    fa: 'ترمینال نمایش نمی‌کند',
    pt: 'Não exibido no termina'
  },
  'ID': {
    zh: 'ID',
    en: 'ID',
    ar: 'ID',
    fa: 'ID',
    pt: 'ID'
  },
  '主品牌名字已经存在': {
    zh: '主品牌名字已经存在',
    en: 'The main brand name already exists.',
    ar: 'اسم العلامة التجارية الرئيسية موجودة بالفعل.',
    fa: 'نام اصلی برند قبلا وجود دارد.',
    pt: 'A marca principal já existe'
  },
  '子品牌名字已经存在': {
    zh: '子品牌名字已经存在',
    en: 'The sub brand name already exists.',
    ar: 'اسم العلامة التجارية الفرعية موجودة بالفعل.',
    fa: 'اسم العلامة التجارية الفرعية موجود بالفعل.',
    pt: 'A sub marca já existe'
  },
  '角色': {
    zh: '角色',
    en: 'Role',
    ar: 'دور',
    fa: 'نقش',
    pt: 'Função'
  },
  '用户名_c': {
    zh: '用户名',
    en: 'User Name',
    ar: 'اسم المستخدم',
    fa: 'نام کاربر',
    pt: 'Nome utilizador'
  },
  '创建人': {
    zh: '创建人',
    en: 'Creator',
    ar: 'المنشئ',
    fa: 'ایجاد کننده',
    pt: 'Criado Por'
  },
  '启用中': {
    zh: '启用中',
    en: 'Enable',
    ar: 'فعال',
    fa: 'فعال کردن',
    pt: 'Ativado'
  },
  '已停用': {
    zh: '已停用',
    en: 'Disable',
    ar: 'معطل',
    fa: 'غیر فعال کردن',
    pt: 'Desativado'
  },
  '系统用户权限': {
    zh: '系统用户权限',
    en: 'User Permissions',
    ar: 'إذن مستخدم النظام',
    fa: 'اجازه‌های کاربر سیستم',
    pt: 'Permissões Usuário'
  },
  '关联权限': {
    zh: '关联权限',
    en: 'Associate Permissions',
    ar: 'ارتباط السلطة',
    fa: 'اجازه‌های مشترک',
    pt: 'Permissões Associadas'
  },
  '主品牌': {
    zh: '主品牌',
    en: 'Main Brand',
    ar: 'العلامة التجارية الرئيسية',
    fa: 'برندهای اصلی',
    pt: 'Marca Principal'
  },
  '子品牌': {
    zh: '子品牌',
    en: 'Sub Brand',
    ar: 'العلامة التجارية الفرعية',
    fa: 'برند ثانویه',
    pt: 'Sub Marca'
  },
  '下列主品牌先创建子品牌': {
    zh: '请先创建 { text } 的子品牌',
    en: 'Please create a sub brand for { text } first.',
    ar: 'إنشاء العلامة التجارية الفرعية { text } أولا',
    fa: 'لطفاً اول یک برند زیر برای { text } ایجاد کنید',
    pt: 'Por favor, crie uma sub marca para {text} primeiro.'
  },
  '请选择主品牌': {
    zh: '请选择主品牌',
    en: 'Please select the main brand',
    ar: 'الرجاء اختيار العلامة التجارية الرئيسية',
    fa: 'لطفا برند اصلی را انتخاب کنید',
    pt: 'Seleccione por favor a marca principal'
  },
  '请先选择主品牌': {
    zh: '请先选择主品牌',
    en: 'Please select the main brand first',
    ar: 'يرجى اختيار العلامة التجارية الرئيسية الأولى',
    fa: 'لطفا اول برند اصلی را انتخاب کنید',
    pt: 'Seleccione primeiro a marca principal'
  },
  '请先选择品牌': {
    zh: '请先选择品牌',
    en: 'Please select a brand first',
    ar: 'يرجى اختيار العلامة التجارية الأولى',
    fa: 'لطفا اول یک برند انتخاب کنید',
    pt: 'Seleccione a marca primeiro'
  },
  '成功': {
    zh: '成功!',
    en: 'Successful!',
    ar: 'نجاح !',
    fa: 'موفقیت!',
    pt: 'Sucesso!'
  },
  '失败': {
    zh: '失败',
    en: 'Fail',
    ar: 'يفشل',
    fa: 'شکست بخورد',
    pt: 'Fracasso'
  },
  '充值': {
    zh: '充值',
    en: 'Recharge',
    ar: 'إعادة الشحن',
    fa: 'شارژ مجدد',
    pt: 'Para recarregar'
  },
  '内容定价': {
    zh: '内容定价',
    en: 'Content Pricing',
    ar: 'تسعير المحتوى',
    fa: 'قیمت گذاری محتوا',
    pt: 'Preços do conteúdo'
  },
  '单片价格(Mango)': {
    zh: '单片价格(Mango)',
    en: 'Movie Price(Mango)',
    ar: 'سعر الفيلم(مانجو)',
    fa: 'قیمت فیلم (انبه)',
    pt: 'Preço do filme'
  },
  '剧集价格(Mango)': {
    zh: '剧集价格(Mango)',
    en: 'Episode Price (Mango)',
    ar: 'سعر الحلقة (مانجو)',
    fa: 'قیمت قسمت (انبه)',
    pt: 'Preço dos episódios (Mango)'
  },
  '单片有效期': {
    zh: '单片有效期',
    en: 'Movie Expiration Date',
    ar: 'تاريخ انتهاء صلاحية الفيلم',
    fa: 'تاریخ انقضای فیلم',
    pt: 'Data de validade do filme'
  },
  '剧集有效期': {
    zh: '剧集有效期',
    en: 'Episode Expiration Date',
    ar: 'تاريخ انتهاء صلاحية الحلقة',
    fa: 'تاریخ انقضای اپیزود',
    pt: 'Data de validade do episódios'
  },
  '请输入单片价格': {
    zh: '请输入单片价格',
    en: 'Please input movie price',
    ar: 'الرجاء إدخال سعر الفيلم',
    fa: 'لطفا قیمت فیلم را بنویسید',
    pt: 'Introduza o preço do filme'
  },
  '请输入剧集价格': {
    zh: '请输入剧集价格',
    en: 'Please input episode price',
    ar: 'الرجاء إدخال سعر الحلقة',
    fa: 'لطفا قیمت قسمت را وارد کنید',
    pt: 'Introduza o preço do episódio'
  },
  '单片价格最高为9999.999': {
    zh: '单片价格最高为9999.999',
    en: 'The highest price for a movie is 9999.999',
    ar: 'أعلى سعر للفيلم هو 9999.999',
    fa: 'بالاترین قیمت برای یک فیلم 9999.999 است',
    pt: 'O preço máximo do vídeo é 9999.999'
  },
  '剧集价格最高为9999.999': {
    zh: '剧集价格最高为9999.999',
    en: 'The highest episode price is 9999.999',
    ar: 'أعلى سعر للحلقة هو 9999.999',
    fa: 'بالاترین قیمت قسمت 9999.999 است',
    pt: 'O preço máximo da série é 9999.999'
  },
  '请选择单片有效期': {
    zh: '请选择单片有效期',
    en: 'Please select the movie expiration date',
    ar: 'الرجاء تحديد تاريخ انتهاء صلاحية الفيلم',
    fa: 'لطفا تاریخ انقضای فیلم را انتخاب کنید',
    pt: 'Selecione a data de validade do filme'
  },
  '请选择剧集有效期': {
    zh: '请选择剧集有效期',
    en: 'Please select the episode expiration date',
    ar: 'الرجاء تحديد تاريخ انتهاء صلاحية الحلقة',
    fa: 'لطفا تاریخ انقضای قسمت را انتخاب کنید',
    pt: 'Selecione a data de expiração do episódio'
  },
  '充值记录': {
    zh: '充值记录',
    en: 'Recharge Records',
    ar: 'سجلات إعادة الشحن',
    fa: 'سوابق شارژ مجدد',
    pt: 'Recarregar o registro'
  },
  '撤销': {
    zh: '撤销',
    en: 'Cancel',
    ar: 'يلغي',
    fa: 'لغو کنید',
    pt: 'Revogação'
  },
  '成功_s': {
    zh: '成功',
    en: 'Successful',
    ar: 'نجاح ',
    fa: 'موفقیت',
    pt: 'Sucesso'
  },
  '请输入用户名': {
    zh: '请输入用户名',
    en: 'Please input user name',
    ar: 'الرجاء ادخال اسم المستخدم',
    fa: 'لطفا نام کاربری را وارد کنید',
    pt: 'Introduza o nome de utilizador'
  },
  '菜单模块': {
    zh: '菜单模块',
    en: 'Menu Module',
    ar: 'وحدة القائمة',
    fa: 'ماژول منو',
    pt: 'Módulo de Menu'
  },
  '操作描述': {
    zh: '操作描述',
    en: 'Operation Desc',
    ar: 'وصف العملية',
    fa: 'شرح عملیات',
    pt: 'Descrição Operação'
  },
  '操作时间': {
    zh: '操作时间',
    en: 'Operation Time',
    ar: 'وقت العملية',
    fa: 'زمان عملیات',
    pt: 'Tempo da Operação'
  },
  '途径': {
    zh: '途径',
    en: 'Way',
    ar: 'طريق',
    fa: 'مسیر',
    pt: 'Rota'
  },
  '操作结果': {
    zh: '操作结果',
    en: 'Operation Result',
    ar: 'نتيجة العملية',
    fa: 'نتیجه عملیات',
    pt: 'Resultado'
  },
  'IP地址': {
    zh: 'IP地址',
    en: 'IP Address',
    ar: 'عنوان IP',
    fa: 'آدرس آی پی',
    pt: 'Endereço IP'
  },
  'VOD Category': {
    zh: '点播分类',
    en: 'VOD Category',
    ar: 'التصنيف حسب الطلب',
    fa: 'طبقه بندی بر روی تقاضا',
    pt: 'Categoria VOD'
  },
  '基础信息': {
    zh: '基础信息',
    en: 'Basic Info',
    ar: 'معلومات اساسية',
    fa: 'اطلاعات بنیادی',
    pt: 'Informação Básica'
  },
  '媒体内容': {
    zh: '媒体内容',
    en: 'Media Info',
    ar: 'محتوى وسائل الإعلام',
    fa: 'محتوای رسانه',
    pt: 'Informações Sobre Mídia'
  },
  '关联分类': {
    zh: '关联分类',
    en: 'Associative Classification',
    ar: 'التصنيف المرتبط',
    fa: 'طبقه بندی مرتبط',
    pt: 'Classificação Associada'
  },
  '批量通过': {
    zh: '批量通过',
    en: 'Batch Pass',
    ar: 'من خلال مراجعة الحسابات',
    fa: 'پاس دسته ای',
    pt: 'Passe em Lote'
  },
  '批量终端审核': {
    zh: '批量终端审核',
    en: 'Batch Terminal Review',
    ar: 'مراجعة الطرفية',
    fa: 'بررسی ترمینال',
    pt: 'Revisão Terminal Lote'
  },
  '批量退回审核': {
    zh: '批量退回审核',
    en: 'Batch Resume',
    ar: 'تدقيق المرتجعات',
    fa: 'حسابرسی را برمیگرداند',
    pt: 'Revisão Devolução Lote'
  },
  '直接退回审核修改': {
    zh: '直接退回审核修改',
    en: 'Direct resume for review',
    ar: 'العودة المباشرة مراجعة التعديلات',
    fa: 'برای بررسی و اصلاح مستقیماً برگردید',
    pt: 'Retornar diretamente à revisão e modificação'
  },
  '批量不通过': {
    zh: '批量不通过',
    en: 'Batch Failed',
    ar: 'من خلال الفشل',
    fa: 'رد نشده',
    pt: 'Falha no Lote'
  },
  '批量上线': {
    zh: '批量上线',
    en: 'Batch Online',
    ar: 'على الخط',
    fa: 'آنلاین',
    pt: 'Lote Online'
  },
  '批量下线': {
    zh: '批量下线',
    en: 'Batch Offline',
    ar: 'غير متصل',
    fa: 'خارج از خط',
    pt: 'Lote Offline'
  },
  '国家': {
    zh: '国家',
    en: 'Country',
    ar: 'البلد',
    fa: 'کشور',
    pt: 'País'
  },
  '添加方式': {
    zh: '添加方式',
    en: 'Adding Way',
    ar: 'طريقة إضافة',
    fa: 'روش اضافه کردن',
    pt: 'Adicionando Maneira'
  },
  '输入URL': {
    zh: '输入URL',
    en: 'Input URL',
    ar: 'أدخل رابط',
    fa: 'وارد کنید URL',
    pt: 'Digite URL'
  },
  '图片URL': {
    zh: '图片URL',
    en: 'Picture URL',
    ar: 'رابط الصورة',
    fa: 'URL تصویر',
    pt: 'Imagem URL'
  },
  '请输入URL': {
    zh: '请输入URL',
    en: 'Please input the URL',
    ar: 'الرجاء إدخال رابط',
    fa: 'لطفا URL را وارد کنید',
    pt: 'Por favor insira o URL'
  },
  '是': {
    zh: '是',
    en: 'YES',
    ar: 'نعم',
    fa: 'آره',
    pt: 'Sim'
  },
  '否': {
    zh: '否',
    en: 'NO',
    ar: 'لا',
    fa: 'نه',
    pt: 'Não'
  },
  '播放': {
    zh: '播放',
    en: 'Play',
    ar: 'بدء التشغيل',
    fa: 'شروع بازی کردن',
    pt: 'Jogar'
  },
  '上线': {
    zh: '上线',
    en: 'Online',
    ar: 'على الخط',
    fa: 'آنلاین',
    pt: 'Online'
  },
  '下线': {
    zh: '下线',
    en: 'Offline',
    ar: 'غير متصل',
    fa: 'خارج از خط',
    pt: 'Offline'
  },
  '未上线': {
    zh: '未上线',
    en: 'Not Online',
    ar: 'لا على الرف',
    fa: 'آنلاین نیست',
    pt: 'Não Online'
  },
  '已上线': {
    zh: '已上线',
    en: 'Online',
    ar: 'على الخط',
    fa: 'آنلاین',
    pt: 'Online'
  },
  '已下线': {
    zh: '已下线',
    en: 'Offline',
    ar: 'غير متصل',
    fa: 'خارج از خط',
    pt: 'Offline'
  },
  '无': {
    zh: '无',
    en: 'None',
    ar: 'لا',
    fa: 'هيچي',
    pt: 'Nenhum'
  },
  '请上传图片': {
    zh: '请上传图片',
    en: 'Please upload picture',
    ar: 'يرجى تحميل الصور',
    fa: 'لطفا عکسها را بارگذاری کنید',
    pt: 'Carregue uma imagem'
  },
  '上线节目数量': {
    zh: '上线节目数量',
    en: 'Online Count',
    ar: 'عدد البرامج عبر الإنترنت',
    fa: 'تعداد برنامه‌های آنلاین',
    pt: 'Contagem Online'
  },
  '下线节目数量': {
    zh: '下线节目数量',
    en: 'Offline Count',
    ar: 'عدد البرامج غير المتصلة بالإنترنت',
    fa: 'تعداد برنامه های آفلاین',
    pt: 'Contagem Offline'
  },
  '未上线节目数量': {
    zh: '未上线节目数量',
    en: 'Not Online Count',
    ar: 'عدد البرامج غير متصل',
    fa: 'آنلاین نیست تعداد',
    pt: 'Contagem Não Online'
  },
  '分类列表中未上线状态+已下线状态的总和': {
    zh: '分类列表中未上线状态+已下线状态的总和',
    en: 'The total of not online status and offline status in the category list.',
    ar: 'مجموع عدد غير متصل وغير متصل في قائمة الفئات .',
    fa: 'تعداد عمومی خارج از وضعیت آنلاین.',
    pt: 'A soma do status offline + status offline na lista de categorias'
  },
  '协议类型': {
    zh: '协议类型',
    en: 'Protocol Type',
    ar: '',
    fa: '',
    pt: 'Tipo de Protocolo'
  },
  '服务列表': {
    zh: '服务列表',
    en: 'Service List',
    ar: 'قائمة الخدمات',
    fa: 'لیست خدمات',
    pt: 'Lista de Serviços'
  },
  '服务列表名称': {
    zh: '服务列表名称',
    en: 'Service List',
    ar: 'قائمة الخدمات',
    fa: 'لیست خدمات',
    pt: 'Lista de Serviços'
  },
  '促销方案名称': {
    zh: '促销方案名称',
    en: 'Promotion Plan Name',
    ar: 'اسم خطة الترقية',
    fa: 'نام طرح ارتقاء',
    pt: 'Nome Promocional'
  },
  '促销周期': {
    zh: '促销周期',
    en: 'Promotion Period',
    ar: 'فترة الترقية',
    fa: 'دوره ارتقاء',
    pt: 'Período da Promoção'
  },
  '编辑时间': {
    zh: '编辑时间',
    en: 'Edit Time',
    ar: 'وقت التحرير',
    fa: 'زمان ویرایش',
    pt: 'Tempo de Edição'
  },
  '促销产品': {
    zh: '促销产品',
    en: 'Promotional Products',
    ar: 'المنتجات الترويجية',
    fa: 'محصولات فعالیت',
    pt: 'Produtos Promocionais'
  },
  '单价': {
    zh: '单价',
    en: 'Unit Price',
    ar: 'سعر الوحده',
    fa: 'قیمت واحد',
    pt: 'Preço Unitário'
  },
  '已关联子品牌': {
    zh: '已关联子品牌',
    en: 'Associated Sub Brands',
    ar: 'العلامة التجارية التابعة',
    fa: 'مارک مرتبط',
    pt: 'Submarcas Associadas'
  },
  '终端显示名称': {
    zh: '终端显示名称',
    en: 'Terminal Name',
    ar: 'عرض اسم المحطة الطرفية',
    fa: 'نام نمایش ترمینال',
    pt: 'Nome do Terminal'
  },
  '个月': {
    zh: '个月',
    en: 'Month',
    ar: 'شهر',
    fa: 'ماه',
    pt: 'Mês'
  },
  '价格(美元)': {
    zh: '价格(美元)',
    en: 'Price (US $)',
    ar: 'السعر (دولار أمريكي)',
    fa: 'قیمت (دلار آمریکا)',
    pt: 'Preço(USD)'
  },
  '服务期': {
    zh: '服务期',
    en: 'Service Period',
    ar: 'مدة الخدمة',
    fa: 'دوره خدمات',
    pt: 'Período de Serviço'
  },
  '至': {
    zh: '至',
    en: 'to',
    ar: 'ل',
    fa: 'به',
    pt: 'Para'
  },
  '定价方案': {
    zh: '定价方案',
    en: 'Pricing Scheme',
    ar: 'خطة التسعير',
    fa: 'نقشه قیمت',
    pt: 'Esquema de Preços'
  },
  '促销方案': {
    zh: '促销方案',
    en: 'Promotion Plan',
    ar: 'خطة الترويج',
    fa: 'نقشه فعالیت',
    pt: 'Programas Promocionais'
  },
  '新增定价方案': {
    zh: '新增定价方案',
    en: 'Add Pricing Scheme',
    ar: 'إضافة خطة التسعير',
    fa: 'افزودن نقشه',
    pt: 'Adicione Esquema Preços'
  },
  '选择主/子品牌': {
    zh: '选择主/子品牌',
    en: 'Select Main/Sub Brand',
    ar: 'اختيار العلامة التجارية الرئيسية / الفرعية',
    fa: 'برند اصلی/فرعی را انتخاب کنید',
    pt: 'Selecione Main/Sub Brand'
  },
  '单价设定': {
    zh: '单价设定',
    en: 'Unit Price Setting',
    ar: 'حدد سعر الوحدة',
    fa: 'تنظیم قیمت واحد',
    pt: 'Definição do Preço Unitário'
  },
  '内容数量': {
    zh: '内容数量',
    en: 'Content Quantity',
    ar: 'كمية المحتوى',
    fa: 'تعداد محتویات',
    pt: 'Quantidade Conteúdo'
  },
  '产品名称': {
    zh: '产品名称',
    en: 'Product Name',
    ar: 'اسم المنتج',
    fa: 'نام محصول',
    pt: 'Nome Produto'
  },
  '点播影片数量': {
    zh: '点播影片数量',
    en: 'VOD Quantity',
    ar: 'عدد الفيديو حسب الطلب',
    fa: 'تعداد ویدئو در خواست',
    pt: 'Quantidade VOD'
  },
  '直播频道数量': {
    zh: '直播频道数量',
    en: 'Live Channel Quantity',
    ar: 'عدد قنوات البث المباشر',
    fa: 'تعداد کانال های زنده',
    pt: 'Quantidade de Canais ao Vivo'
  },
  '请选择服务列表': {
    zh: '请选择服务列表',
    en: 'Please select service list',
    ar: 'الرجاء تحديد قائمة الخدمات',
    fa: 'لطفا لیست خدمات را انتخاب کنید',
    pt: 'Por favor, seleccione a lista de serviços'
  },
  '请选择服务期': {
    zh: '请选择服务期',
    en: 'Please select service period',
    ar: 'الرجاء تحديد فترة الخدمة',
    fa: 'لطفا دوره خدمات را انتخاب کنید',
    pt: 'Por favor, seleccione o período de serviço'
  },
  '请输入终端显示名称': {
    zh: '请输入终端显示名称',
    en: 'Please input terminal name',
    ar: 'الرجاء إدخال اسم عرض المحطة الطرفية',
    fa: 'لطفا نام نمایش ترمینال را وارد کنید',
    pt: 'Por favor, insira o nome da exibição do terminal'
  },
  '请输入价格': {
    zh: '请输入价格',
    en: 'Please input the price',
    ar: 'من فضلك أدخل السعر',
    fa: 'لطفا قیمت را وارد کنید',
    pt: 'Por favor insira o preço'
  },
  '美元': {
    zh: '美元',
    en: 'Dollar',
    ar: 'دولار',
    fa: 'دلار',
    pt: 'USD'
  },
  '只允许输入数字': {
    zh: '只允许输入数字,如: xxx.xx',
    en: 'Only numbers are allow input, E.g:xxx.xx',
    ar: 'يُسمح فقط للأرقام بالدخول ، على سبيل المثال: xxx.xx',
    fa: 'فقط اعداد مجاز به ورود هستند، به عنوان مثال:xxx.xx',
    pt: 'Só são permitidos números, por exemplo: xxx.xx'
  },
  '音轨设置': {
    zh: '音轨设置',
    en: 'Audio Track',
    ar: 'المسار الصوتي',
    fa: 'آهنگ صوتی',
    pt: 'Configurações de Trilho'
  },
  '详情描述': {
    zh: '详情描述',
    en: 'Detail Description',
    ar: 'الوصف التفصيلي',
    fa: 'شرح جزئیات',
    pt: 'Detalhes Descrição'
  },
  '字幕设置': {
    zh: '字幕设置',
    en: 'Subtitle Setting',
    ar: 'إعداد الترجمة',
    fa: 'تنظیمات زیرنویس',
    pt: 'Configurações de Legenda'
  },
  '选择类型': {
    zh: '选择类型',
    en: 'Select type',
    ar: 'حدد النوع',
    fa: 'نوع را انتخاب کنید',
    pt: 'Escolha um Tipo'
  },
  '字幕类型': {
    zh: '字幕类型',
    en: 'Subtitle Type',
    ar: 'نوع الترجمة',
    fa: 'نوع زیرنویس',
    pt: 'Tipo de Legenda'
  },
  '客户图标': {
    zh: '客户图标',
    en: 'Agent Logo',
    ar: 'شعار الوكيل',
    fa: 'لوگوی نماینده',
    pt: 'Ícone do Cliente'
  },
  '排列顺序': {
    zh: '排列顺序',
    en: 'Sequence',
    ar: 'تسلسل',
    fa: 'دنباله',
    pt: 'Sequência'
  },
  '激活码设置': {
    zh: '激活码设置',
    en: 'Activation Code Setting',
    ar: 'إعداد رمز التنشيط',
    fa: 'تنظیم کد فعال سازی',
    pt: 'Configurações do Código Ativação'
  },
  '确定修改卫星角度': {
    zh: '确定修改卫星角度',
    en: 'Confirm to modify the satellite angle',
    ar: 'تأكيد لتعديل زاوية القمر الصناعي',
    fa: 'برای تغییر زاویه ماهواره تأیید کنید',
    pt: 'Determinar e modificar o ângulo do satélite'
  },
  '确定修改视频解密key': {
    zh: '确定修改视频解密key',
    en: 'Confirm to modify the video decryption key',
    ar: 'تأكيد تعديل مفتاح فك تشفير الفيديو',
    fa: 'برای تغییر کلید رمزگشایی ویدیو تأیید کنید',
    pt: 'Confirme para modificar a chave de descriptografia de vídeo'
  },
  '激活码查询': {
    zh: '激活码查询',
    en: 'Activation Code',
    ar: 'رمز التفعيل',
    fa: 'کد فعال سازی',
    pt: 'Consulta Código Ativação'
  },
  'Google播放授权': {
    zh: 'Google播放授权',
    en: 'Google Play Auth',
    ar: 'مصادقة جوجل بلاي',
    fa: 'Google Play Auth',
    pt: 'Licenciamento do Google Play'
  },
  'AWS播放授权': {
    zh: 'AWS播放授权',
    en: 'AWS Play Auth',
    ar: 'مصادقة AWS Play',
    fa: 'AWS Play Auth',
    pt: 'Autorização do AWS Play'
  },
  '播放授权Key': {
    zh: '播放授权Key',
    en: 'Play Auth Key',
    ar: 'تشغيل مفتاح المصادقة',
    fa: 'Play Auth Key',
    pt: 'Reproduzir Chave Autenticação'
  },
  '播放授权Value': {
    zh: '播放授权Value',
    en: 'Play Auth Value',
    ar: 'تشغيل قيمة المصادقة',
    fa: 'Play Auth Value',
    pt: 'Valor de Autenticação do Play'
  },
  '请求格式': {
    zh: '请求格式',
    en: 'Request Format',
    ar: 'نموذج الطلب',
    fa: 'فرمت درخواست',
    pt: 'Formato de Solicitação'
  },
  '响应格式': {
    zh: '响应格式',
    en: 'Response Format',
    ar: 'تنسيق الرد',
    fa: 'فرمت پاسخ',
    pt: 'Formato de Resposta'
  },
  '激活码解绑记录': {
    zh: '激活码解绑记录',
    en: 'Activation Code Unbinding Record',
    ar: 'سجل إلغاء ربط رمز التنشيط',
    fa: 'کد فعال سازی بدون اتصال رکورد',
    pt: 'Registro de Desvinculação do Código Ativação'
  },
  '激活码': {
    zh: '激活码',
    en: 'Activation Code',
    ar: 'رمز التفعيل',
    fa: 'کد فعال سازی',
    pt: 'Código de Ativação'
  },
  '有效期': {
    zh: '有效期',
    en: 'Expiration Date',
    ar: 'تاريخ انتهاء الصلاحية',
    fa: 'تاریخ انقضا',
    pt: 'Data de Validade'
  },
  '销售时间': {
    zh: '销售时间',
    en: 'Sales Time',
    ar: 'وقت المبيعات',
    fa: 'زمان فروش',
    pt: 'Hora de Venda'
  },
  '客户名': {
    zh: '客户名',
    en: 'Client Name',
    ar: 'اسم العميل',
    fa: 'نام مشتری',
    pt: 'Nome do Cliente'
  },
  '设备ID': {
    zh: '设备ID',
    en: 'Device ID',
    ar: 'معرف الجهاز',
    fa: 'شناسه دستگاه',
    pt: 'ID do Dispositivo'
  },
  '解绑时间': {
    zh: '解绑时间',
    en: 'Unbind Time',
    ar: 'وقت فك الارتباط',
    fa: 'Unbind Time',
    pt: 'Tempo Desvinculação'
  },
  '解绑': {
    zh: '解绑',
    en: 'Unbind',
    ar: 'فك الارتباط',
    fa: 'باز کردن',
    pt: 'Desvincular'
  },
  '已添加': {
    zh: '已添加',
    en: 'added',
    ar: 'تمت الإضافة',
    fa: 'اضافه شده است',
    pt: 'Adicionado'
  },
  '过期': {
    zh: '过期',
    en: 'Expired',
    ar: 'منتهي الصلاحية',
    fa: 'منقضی شده است',
    pt: 'Expirado'
  },
  '销售中': {
    zh: '销售中',
    en: 'On Sale',
    ar: 'معروض للبيع',
    fa: 'در فروش',
    pt: 'À Venda'
  },
  '域名': {
    zh: '域名',
    en: 'Domain Name',
    ar: 'اسم المجال',
    fa: 'نام دامنه',
    pt: 'Nome do Domínio'
  },
  '请输入域名': {
    zh: '请输入域名',
    en: 'Please enter domain name',
    ar: 'الرجاء إدخال اسم المجال',
    fa: 'لطفا نام دامنه را وارد کنید',
    pt: 'Por favor insira o nome de domínio'
  },
  '请输入正确的域名': {
    zh: '请输入正确的域名',
    en: 'Please enter the correct domain name',
    ar: 'الرجاء إدخال اسم النطاق الصحيح',
    fa: 'لطفا نام دامنه صحیح را وارد کنید',
    pt: 'Por favor, insira o nome de domínio correto'
  },
  '域名的长度应在1到255字符之间': {
    zh: '域名的长度应在1到255字符之间',
    en: 'The length of the domain name should be between 1 and 255 characters',
    ar: 'يجب أن يكون طول اسم النطاق بين 1 و 255 حرفًا',
    fa: 'طول نام دامنه باید بین 1 تا 255 کاراکتر باشد',
    pt: 'O nome de domínio deve ter entre 1 e 255 caracteres'
  },
  '域名已存在': {
    zh: '域名已存在',
    en: 'Domain name already exists',
    ar: 'اسم المجال موجود بالفعل',
    fa: 'نام دامنه از قبل وجود دارد',
    pt: 'O nome de domínio já existe'
  },
  '激活': {
    zh: '激活',
    en: 'Active',
    ar: 'نشيط',
    fa: 'فعال',
    pt: 'Ativação'
  },
  '天': {
    zh: '天',
    en: 'days',
    ar: 'أيام',
    fa: 'روز',
    pt: 'Dias'
  },
  '月': {
    zh: '月',
    en: 'months',
    ar: 'شهور',
    fa: 'ماه ها',
    pt: 'Mensal'
  },
  '服务管理': {
    zh: '服务管理',
    en: 'Service Manage',
    ar: 'إدارة الخدمة',
    fa: 'مدیریت خدمات',
    pt: 'Gestão Serviços'
  },
  '服务器组': {
    zh: '服务器组',
    en: 'Service Group',
    ar: 'مجموعة الخدمات',
    fa: 'گروه خدمات',
    pt: 'Grupo Servidores'
  },
  '测试配置': {
    zh: '测试配置',
    en: 'Test Config',
    ar: 'اختبار التكوين',
    fa: 'پیکربندی تست',
    pt: 'Configuração Teste'
  },
  '服务器信息': {
    zh: '服务器信息',
    en: 'Service Info',
    ar: 'معلومات الخدمة',
    fa: 'اطلاعات خدمات',
    pt: 'Informação Servidor'
  },
  '对象': {
    zh: '对象',
    en: 'Objcet',
    ar: 'هدف',
    fa: 'شیء',
    pt: 'Objecto'
  },
  'IP范围': {
    zh: 'IP范围',
    en: 'IP Range',
    ar: 'نطاق IP',
    fa: 'محدوده IP',
    pt: 'Intervalo IP'
  },
  '是否删除该服务列表': {
    zh: '是否删除该服务列表',
    en: 'Confirm to delete this service list',
    ar: 'تأكيد لحذف قائمة الخدمات هذه',
    fa: 'برای حذف این لیست خدمات تأیید کنید',
    pt: 'Se deve excluir a lista de serviços'
  },
  '是否删除该服务器': {
    zh: '是否删除该服务器',
    en: 'Confirm to delete this server',
    ar: 'تأكيد لحذف هذا الخادم',
    fa: 'برای حذف این سرور تأیید کنید',
    pt: 'Deseja apagar este servidor'
  },
  '解绑失败': {
    zh: '解绑失败',
    en: 'Unbind Fail',
    ar: 'فشل إلغاء الربط',
    fa: 'Unbind Fail',
    pt: 'Falha na Desvinculação'
  },
  '用户数据': {
    zh: '用户数据',
    en: 'User Data',
    ar: 'بيانات المستخدم',
    fa: 'داده های کاربر',
    pt: 'Dados do Usuário'
  },
  '用户': {
    zh: '用户',
    en: 'User',
    ar: 'مستخدم',
    fa: 'کاربر',
    pt: 'Utilizadores'
  },
  '解绑成功': {
    zh: '解绑成功',
    en: 'Unbind Success',
    ar: 'نجاح فك الارتباط',
    fa: 'گسست موفقیت',
    pt: 'Desvinculação com Sucesso'
  },
  '未查询到激活码': {
    zh: '未查询到激活码',
    en: 'The activation code is not queried',
    ar: 'لم يتم الاستعلام عن رمز التفعيل',
    fa: 'کد فعال سازی استعلام نشده است',
    pt: 'Nenhum código de ativação encontrado'
  },
  '请选择字幕类型': {
    zh: '请选择字幕类型',
    en: 'Please select a subtitle type',
    ar: 'الرجاء تحديد نوع الترجمة',
    fa: 'لطفا یک نوع زیرنویس انتخاب کنید',
    pt: 'Selecione o tipo de legenda'
  },
  '播放链接': {
    zh: '播放链接',
    en: 'PlayUrl',
    ar: 'تشغيل الرابط',
    fa: 'PlayUrl',
    pt: 'Ligação de Reprodução'
  },
  '请选择一个频道支持的传输协议': {
    zh: '请选择一个频道支持的传输协议',
    en: 'Please select a transport protocol supported by a channel',
    ar: 'الرجاء تحديد بروتوكول النقل الذي تدعمه القناة',
    fa: 'لطفاً یک پروتکل حمل و نقل را انتخاب کنید که توسط یک کانال پشتیبانی می شود',
    pt: 'Selecione um protocolo de transporte suportado pelo canal'
  },
  '传输协议正在被使用': {
    zh: '该传输协议正在被 { bindingCategoryText } 使用,请先修改配置,再操作',
    en: 'The transfer Protocol has been used by { bindingCategoryText }, modify the configuration before delete',
    ar: 'تم استخدام بروتوكول النقل بواسطة { bindingCategoryText }، قم بتعديل التكوين قبل الحذف',
    fa: 'پروتکل انتقال توسط { bindingCategoryText } استفاده شده است، قبل از حذف، پیکربندی را تغییر دهید',
    pt: 'O protocolo de transferência foi usado por {bindingCategoryText}, modifique a configuração antes de excluir'
  },
  '个频道修改为HLS协议': {
    zh: '个频道修改为HLS协议',
    en: ' channel change to HLS protocol',
    ar: ' تغيير القناة إلى بروتوكول HLS',
    fa: ' تغییر کانال به پروتکل HLS',
    pt: ' Mudança de canal para o protocolo HLS'
  },
  '个频道修改为DASH协议': {
    zh: '个频道修改为DASH协议',
    en: ' channel change to DASH protocol',
    ar: ' تغيير القناة إلى بروتوكول DASH',
    fa: ' تغییر کانال به پروتکل DASH',
    pt: ' mudança de canal para protocolo DASH'
  },
  '个频道修改为P2P协议': {
    zh: '个频道修改为P2P协议',
    en: ' channel change to P2P protocol',
    ar: ' تغيير القناة إلى بروتوكول P2P',
    fa: ' تغییر کانال به پروتکل P2P',
    pt: ' mudança de canal para protocolo P2P'
  },
  '个频道修改为HTTP协议': {
    zh: '个频道修改为HTTP协议',
    en: ' channel change to HTTP protocol',
    ar: ' تغيير القناة إلى بروتوكول HTTP',
    fa: ' تغییر کانال به پروتکل HTTP',
    pt: ' mudança de canal para protocolo HTTP'
  },
  '个频道修改为DASH+PDASH协议': {
    zh: '个频道修改为DASH+PDASH协议',
    en: ' channel change to DASH+PDASH protocol',
    ar: ' تغيير القناة إلى بروتوكول DASH+PDASH',
    fa: ' تغییر کانال به پروتکل DASH+PDASH',
    pt: ' mudança de canal para protocolo DASH+PDASH'
  },
  'DASH+PDASH选项优先PDASH，不支持PDASH使用DASH': {
    zh: 'DASH+PDASH选项优先PDASH，不支持PDASH使用DASH',
    en: 'The DASH+PDASH option takes precedence over PDASH and does not support DASH for PDASH',
    ar: 'الخيار DASH+PDASH له الأولوية على PDASH ولا يدعم DASH لـ PDASH',
    fa: 'گزینه DASH+PDASH بر PDASH اولویت دارد و از DASH برای PDASH پشتیبانی نمی کند',
    pt: 'A opção DASH+PDASH tem precedência sobre PDASH e não suporta DASH para PDASH'
  },
  '个频道保留之前的设置': {
    zh: '个频道保留之前的设置',
    en: ' channel remain as before',
    ar: ' القناة تظل كما كانت من قبل',
    fa: ' کانال مثل قبل باقی می ماند',
    pt: ' As configurações anteriores são retidas pelo canal'
  },
  '直播节目统计': {
    zh: '直播节目统计',
    en: 'Live Statistics',
    ar: 'إحصائيات مباشرة',
    fa: 'آمار زنده',
    pt: 'Estatísticas Live'
  },
  '上线频道': {
    zh: '上线频道',
    en: 'Online Channel',
    ar: 'قناة على الانترنت',
    fa: 'کانال آنلاین',
    pt: 'Canal Online'
  },
  '下线频道': {
    zh: '下线频道',
    en: 'Offline Channel',
    ar: 'قناة غير متصلة بالإنترنت',
    fa: 'کانال آفلاین',
    pt: 'Canal Offline'
  },
  '删除频道': {
    zh: '删除频道',
    en: 'Deleted Channel',
    ar: 'القناة المحذوفة',
    fa: 'کانال حذف شده',
    pt: 'Excluir Canal'
  },
  '频道总数': {
    zh: '频道总数',
    en: 'Channel Total',
    ar: 'مجموع القناة',
    fa: 'مجموع کانال',
    pt: 'Total do Canal'
  },
  '昨日上线频道数': {
    zh: '昨日上线频道数',
    en: 'Online Yesterday',
    ar: 'متصل بالأمس',
    fa: 'دیروز آنلاین',
    pt: 'Online Ontem'
  },
  '昨日下线频道数': {
    zh: '昨日下线频道数',
    en: 'Offline Yesterday',
    ar: 'غير متصل بالأمس',
    fa: 'دیروز آفلاین',
    pt: 'Offline Ontem'
  },
  '本月上线频道数': {
    zh: '本月上线频道数',
    en: 'Online This Month',
    ar: 'متصل هذا الشهر',
    fa: 'آنلاین این ماه',
    pt: 'Online Este Mês'
  },
  '本月下线频道数': {
    zh: '本月下线频道数',
    en: 'Offline This Month',
    ar: 'غير متصل هذا الشهر',
    fa: 'این ماه آفلاین',
    pt: 'Offline Este Mês'
  },
  '上线频道总数': {
    zh: '上线频道总数',
    en: 'Online Total',
    ar: 'المجموع الإجمالي عبر الإنترنت',
    fa: 'مجموع آنلاین',
    pt: 'Total Online'
  },
  '下线频道总数': {
    zh: '下线频道总数',
    en: 'Offline Total',
    ar: 'المجموع غير المتصل',
    fa: 'مجموع آفلاین',
    pt: 'Total Offline'
  },
  '请勿重复添加编码标准、传输协议、分辨率一样的频道': {
    zh: '请勿重复添加编码标准、传输协议、分辨率一样的频道',
    en: 'Do not add multiple channels with the same program type, transfer protocol, and resolution',
    ar: 'لا تقم بإضافة قنوات متعددة بنفس نوع البرنامج وبروتوكول النقل والدقة',
    fa: 'چندین کانال با نوع برنامه، پروتکل انتقال و وضوح یکسان اضافه نکنید',
    pt: 'Não adicione vários canais com o mesmo tipo de programa, protocolo de transferência e resolução'
  },
  '为频道被操作的次数，例如频道被操作2次上线，数据即为2': {
    zh: '为频道被操作的次数，例如频道被操作2次上线，数据即为2',
    en: 'Indicates the number of times the channel has been operated. For example, if the channel has been operated to go online twice, the data is 2',
    ar: 'يشير إلى عدد المرات التي تم فيها تشغيل القناة. على سبيل المثال، إذا تم تشغيل القناة للاتصال بالإنترنت مرتين، تكون البيانات 2',
    fa: 'تعداد دفعاتی که کانال کار کرده است را نشان می دهد. به عنوان مثال، اگر کانال دو بار آنلاین شود، داده ها 2 است',
    pt: 'É o número de vezes que o canal foi operado. Por exemplo, o canal foi operado online 2 vezes e os dados são 2.'
  },
  '为节目被操作的次数，例如节目被操作2次下线，数据即为2。': {
    zh: '为节目被操作的次数，例如节目被操作2次下线，数据即为2。',
    en: 'Indicates the number of times the program has been operated. For example, if the program has been operated to go offline twice, the data is 2',
    ar: 'يشير إلى عدد المرات التي تم فيها تشغيل البرنامج. على سبيل المثال، إذا تم تشغيل البرنامج لإيقاف تشغيله مرتين، فإن البيانات هي 2',
    fa: 'تعداد دفعات اجرای برنامه را نشان می دهد. به عنوان مثال، اگر برنامه دو بار آفلاین شود، داده 2 است',
    pt: 'É o número de vezes que o programa foi operado. Por exemplo, se o programa foi operado offline duas vezes, os dados são 2.'
  },
  '为频道在平台上数据，以频道最终状态为统计结果，例如频道操作上线再操作下线，那么上线-1，下线+1。': {
    zh: '为频道在平台上数据，以频道最终状态为统计结果，例如频道操作上线再操作下线，那么上线-1，下线+1。',
    en: 'Channel data on the platform, the final state of the channel is the statistical result. For example, if the channel operation goes online and then goes offline, then go online -1 and go offline +1.',
    ar: 'بيانات القناة على المنصة، الحالة النهائية للقناة هي النتيجة الإحصائية. على سبيل المثال، إذا كانت عملية القناة متصلة بالإنترنت ثم غير متصلة، فإن الاتصال بالإنترنت -1 ثم غير متصل بالإنترنت +1.',
    fa: 'داده های کانال در پلت فرم، وضعیت نهایی کانال نتیجه آماری است. به عنوان مثال، اگر عملیات کانال آنلاین شد و سپس آفلاین شد، سپس -1 آنلاین شوید و +1 آفلاین شوید.',
    pt: 'São os dados do canal na plataforma, e o status final do canal é usado como resultado estatístico.Por exemplo, se o canal for operado online e depois offline, então -1 para online e +1 para offline.'
  },
  '操作统计': {
    zh: '操作统计',
    en: 'Operational Statistics',
    ar: 'إحصائيات التشغيل',
    fa: 'آمار عملیاتی',
    pt: 'Estatísticas Operacionais'
  },
  '频道统计': {
    zh: '频道统计',
    en: 'Channel Statistics',
    ar: 'إحصائيات القناة',
    fa: 'آمار کانال',
    pt: 'Estatísticas do Canal'
  },
  '自动化测试': {
    zh: '自动化测试',
    en: 'Automated Testing',
    ar: 'الاختبار الآلي',
    fa: 'تست خودکار',
    pt: 'Teste Automatizado'
  },
  'SN/账号': {
    zh: 'SN/账号',
    en: 'SN/Account',
    ar: 'الرقم التسلسلي/الحساب',
    fa: 'SN / حساب',
    pt: 'SN/Conta'
  },
  '测试任务': {
    zh: '测试任务',
    en: 'Test Task',
    ar: 'مهمة الاختبار',
    fa: 'وظیفه تست',
    pt: 'Tarefa'
  },
  '测试设备': {
    zh: '测试设备',
    en: 'Test Device',
    ar: 'جهاز الاختبار',
    fa: 'دستگاه تست',
    pt: 'Equipamento'
  },
  '测试状态': {
    zh: '测试状态',
    en: 'Test State',
    ar: 'حالة الاختبار',
    fa: 'وضعیت آزمون',
    pt: 'Status do Teste'
  },
  '添加测试设备': {
    zh: '添加测试设备',
    en: 'Add Test Device',
    ar: 'إضافة جهاز اختبار',
    fa: 'افزودن دستگاه تست',
    pt: 'Adicionar Dispositivo de Teste'
  },
  '测试节目总数': {
    zh: '测试节目总数',
    en: 'Test Channel Total',
    ar: 'إجمالي قناة الاختبار',
    fa: 'مجموع کانال تست',
    pt: 'Total do Canal de Teste'
  },
  '正常节目数量': {
    zh: '正常节目数量',
    en: 'Success Channel Count',
    ar: 'عدد قنوات النجاح',
    fa: 'تعداد کانال های موفقیت',
    pt: 'Número Normal de Programas'
  },
  '异常节目数量': {
    zh: '异常节目数量',
    en: 'Fail Channel Count',
    ar: 'عدد القنوات الفاشلة',
    fa: 'تعداد کانال های ناموفق',
    pt: 'Número de Programas Anormais'
  },
  '测试时长': {
    zh: '测试时长',
    en: 'Test Duration',
    ar: 'مدة الاختبار',
    fa: 'مدت زمان آزمون',
    pt: 'Duração do Teste'
  },
  '开始测试时间': {
    zh: '开始测试时间',
    en: 'Start Test Time',
    ar: 'بدء وقت الاختبار',
    fa: 'شروع زمان تست',
    pt: 'Hora Início Teste'
  },
  '测试时间': {
    zh: '测试时间',
    en: 'Test Time',
    ar: 'وقت الاختبار',
    fa: 'زمان تست',
    pt: 'Tempo Teste'
  },
  '手动开始测试': {
    zh: '手动开始测试',
    en: 'Manual Start Test',
    ar: 'اختبار البدء اليدوي',
    fa: 'تست شروع دستی',
    pt: 'Teste Início Manual'
  },
  '停用': {
    zh: '停用',
    en: 'Stop',
    ar: 'قف',
    fa: 'توقف کنید',
    pt: 'Desativar'
  },
  '错误码': {
    zh: '错误码',
    en: 'Error Code',
    ar: 'رمز الخطأ',
    fa: 'کد خطا',
    pt: 'Erro Código'
  },
  '错误信息': {
    zh: '错误信息',
    en: 'Error Message',
    ar: 'رسالة الخطأ',
    fa: 'پیغام خطا',
    pt: 'Mensagem Erro'
  },
  '播放URL': {
    zh: '播放URL',
    en: 'Play URL',
    ar: 'رابط التشغيل',
    fa: 'پخش URL',
    pt: 'URL Reprodução'
  },
  '测试报告': {
    zh: '测试报告',
    en: 'Test Report',
    ar: 'تقرير الاختبار',
    fa: 'گزارش تست',
    pt: 'Relatório Teste'
  },
  '任务未开始': {
    zh: '任务未开始',
    en: 'Task Not Start',
    ar: 'المهمة لم تبدأ',
    fa: 'کار شروع نمی شود',
    pt: 'Tarefa Não Iniciada'
  },
  '正常停止': {
    zh: '正常停止',
    en: 'Normal Stop',
    ar: 'توقف عادي',
    fa: 'توقف عادی',
    pt: 'Parada Normal'
  },
  '手动停止': {
    zh: '手动停止',
    en: 'Manual Stop',
    ar: 'الإيقاف اليدوي',
    fa: 'توقف دستی',
    pt: 'Pare Manualmente'
  },
  '手动开始': {
    zh: '手动开始',
    en: 'Manual Start',
    ar: 'بدء التشغيل يدويا',
    fa: 'شروع دستی',
    pt: 'Início Manual'
  },
  '异常停止': {
    zh: '异常停止',
    en: 'Abnormal Stop',
    ar: 'توقف غير طبيعي',
    fa: 'توقف غیر عادی',
    pt: 'Parada Anormal'
  },
  '自动任务正常停止': {
    zh: '自动任务正常停止',
    en: 'Automatic Task Normal Stop',
    ar: 'إيقاف تلقائي للمهمة بشكل طبيعي',
    fa: 'توقف عادی کار خودکار',
    pt: 'Parada Normal de Tarefa Automática'
  },
  '确定开始测试当前设备': {
    zh: '确定开始测试当前设备',
    en: 'Confirm to start testing the current device',
    ar: 'تأكيد لبدء اختبار الجهاز الحالي',
    fa: 'برای شروع آزمایش دستگاه فعلی تأیید کنید',
    pt: 'Confirme para começar a testar o dispositivo atual'
  },
  '确定停用当前设备': {
    zh: '确定停用当前设备',
    en: 'Confirm to deactivate the current device',
    ar: 'تأكيد لإلغاء تنشيط الجهاز الحالي',
    fa: 'غیرفعال کردن دستگاه فعلی را تأیید کنید',
    pt: 'Confirme para desativar o dispositivo atual'
  },
  '确定删除当前设备': {
    zh: '确定删除当前设备',
    en: 'Confirm to delete the current device',
    ar: 'تأكيد لحذف الجهاز الحالي',
    fa: 'برای حذف دستگاه فعلی تأیید کنید',
    pt: 'Confirme para excluir o dispositivo atual'
  },
  '关键字的长度应在1到255字符之间': {
    zh: '关键字的长度应在1到255字符之间',
    en: 'The length of keyword should be between 1 and 255 characters in length',
    ar: 'يجب أن يكون طول الكلمة الأساسية بين 1 و 255 حرفًا',
    fa: 'طول کلمه کلیدی باید بین 1 تا 255 کاراکتر باشد',
    pt: 'A duração da palavra chave deve ter entre 1 e 255 caracteres de comprimento'
  },
  'ID的长度应在1到100字符之间': {
    zh: 'ID的长度应在1到100字符之间',
    en: 'The length of id should be between 1 and 100 characters in length',
    ar: 'يجب أن يكون طول المعرف بين 1 و 100 حرف',
    fa: 'طول شناسه باید بین 1 تا 100 کاراکتر باشد',
    pt: 'A duração do ID deve ter entre 1 e 100 caracteres'
  },
  'SN/账号的长度应在1到100字符之间': {
    zh: 'SN/账号的长度应在1到100字符之间',
    en: 'The length of SN or Account should be between 1 and 100 characters in length',
    ar: 'يجب أن يكون طول الرقم التسلسلي أو الحساب بين 1 و100 حرف',
    fa: 'طول SN یا Account باید بین 1 تا 100 کاراکتر باشد',
    pt: 'O comprimento do SN/número da conta deve estar entre 1 e 100 caracteres'
  },
  '备注的长度应在1到100字符之间': {
    zh: '备注的长度应在1到100字符之间',
    en: 'The length of remark should be between 1 and 100 characters in length',
    ar: 'يجب أن يكون طول الملاحظة بين 1 و 100 حرف',
    fa: 'طول یادداشت باید بین 1 تا 100 کاراکتر باشد',
    pt: 'O comprimento da nota deve estar entre 1 e 100 caracteres'
  },
  '备注的长度应在1到500字符之间': {
    zh: '备注的长度应在1到500字符之间',
    en: 'The length of remark should be between 1 and 500 characters in length',
    ar: 'يجب أن يكون طول الملاحظة بين 1 و 500 حرف',
    fa: 'طول یادداشت باید بین 1 تا 500 کاراکتر باشد',
    pt: 'O comprimento da nota deve estar entre 1 e 500 caracteres'
  },
  '账号状态': {
    zh: '账号状态',
    en: 'Account State',
    ar: 'حالة الحساب',
    fa: 'وضعیت حساب',
    pt: 'Estado da Conta'
  },
  '账号空闲中': {
    zh: '账号空闲中',
    en: 'Account Idle',
    ar: 'الحساب خامل',
    fa: 'حساب بیکار',
    pt: 'Conta Inativa'
  },
  '账号正在测试': {
    zh: '账号正在测试',
    en: 'Account Testing',
    ar: 'اختبار الحساب',
    fa: 'تست حساب',
    pt: 'Teste de Conta'
  },
  '测试等待中': {
    zh: '测试等待中',
    en: 'Test pending',
    ar: 'اختبار معلق',
    fa: 'تست در انتظار',
    pt: 'Teste em espera'
  },
  '启用': {
    zh: '启用',
    en: 'Enable',
    ar: 'يُمكَِن',
    fa: 'فعال کردن',
    pt: 'Ativar'
  },
  '开始测试': {
    zh: '开始测试',
    en: 'Start Testing',
    ar: 'بدء الاختبار',
    fa: 'شروع تست',
    pt: 'comece a testar'
  },
  '停用成功': {
    zh: '停用成功',
    en: 'Successful Deactivation',
    ar: 'تم التعطيل بنجاح',
    fa: 'غیرفعال سازی موفقیت آمیز',
    pt: 'Desativação bem Sucedida'
  },
  '启用成功': {
    zh: '启用成功',
    en: 'Enabled Successfully',
    ar: 'تم التمكين بنجاح',
    fa: 'با موفقیت فعال شد',
    pt: 'Ativado com Sucesso'
  },
  '保存为图片': {
    zh: '保存为图片',
    en: 'Save As Image',
    ar: 'حفظ كصورة',
    fa: 'ذخیره به عنوان تصویر',
    pt: 'Salvar como Imagem'
  },
  '确定启用当前设备': {
    zh: '确定启用当前设备',
    en: 'Confirm that the current device is enabled',
    ar: 'تأكد من تمكين الجهاز الحالي',
    fa: 'تأیید کنید که دستگاه فعلی فعال است',
    pt: 'Confirmar a activação do dispositivo actual'
  },
  '清除缓存': {
    zh: '清除缓存',
    en: 'Clear Cache',
    ar: 'مسح ذاكرة التخزين المؤقت',
    fa: 'کش را پاک کنید',
    pt: 'Limpar a Cache'
  },
  '是否删除该SN黑名单': {
    zh: '是否删除该SN黑名单',
    en: 'Confirm to delete the SN blacklist',
    ar: 'تأكيد حذف القائمة السوداء للرقم التسلسلي',
    fa: 'برای حذف لیست سیاه SN تأیید کنید',
    pt: 'Remover esta lista negra do SN ou não'
  },
  '清除缓存成功': {
    zh: '清除缓存成功',
    en: 'Clear Cache Succeeded',
    ar: 'تم مسح ذاكرة التخزين المؤقت بنجاح',
    fa: 'پاک کردن کش با موفقیت انجام شد',
    pt: 'Limpar a Cache com Sucesso'
  },
  'SN黑名单': {
    zh: 'SN黑名单',
    en: 'SN Blacklist',
    ar: 'القائمة السوداء SN',
    fa: 'لیست سیاه SN',
    pt: 'Lista negra SN'
  },
  '已设置回看,EPG参数不能为空': {
    zh: '已设置回看,EPG参数不能为空',
    en: 'The playback is set, EPG Parameter can not be null',
    ar: 'تم ضبط التشغيل، لا يمكن أن تكون معلمة EPG فارغة',
    fa: 'پخش تنظیم شده است، پارامتر EPG نمی تواند تهی باشد',
    pt: 'Foi configurado para voltar a ver, O parâmetro EPG não pode ser nulo'
  },
  '输入频道名称、节目识别号（原台标）、备注': {
    zh: '输入频道名称、节目识别号（原台标）、备注',
    en: 'Input Channel Name、Callsign、Remark',
    ar: 'اسم قناة الإدخال، علامة النداء، الملاحظة',
    fa: 'نام کانال، Callsign، Remark را وارد کنید',
    pt: 'Insira o nome do canal, número de identificação do programa (logotipo original da estação) e comentários'
  },
  '点播分类属性': {
    zh: '点播分类属性',
    en: 'VOD Property',
    ar: 'الطلب على الممتلكات',
    fa: 'ویژگی VOD',
    pt: 'Propriedade VOD'
  },
  '新增点播分类属性': {
    zh: '新增点播分类属性',
    en: 'Add Property',
    ar: 'إضافة خاصية تصنيف الطلب',
    fa: 'اضافه کردن خصوصیت تنظیم',
    pt: 'Adicionar Propriedade'
  },
  '添加语言': {
    zh: '添加语言',
    en: 'Add Language',
    ar: 'إضافة لغة',
    fa: 'افزودن زبان',
    pt: 'Adicionar a Língua'
  },
  '分类属性名称': {
    zh: '分类属性名称',
    en: 'Property Name',
    ar: 'اسم الفئة',
    fa: 'نام ویژگی طبقه بندی',
    pt: 'Nome da Propriedade'
  },
  '请输入分类属性名称': {
    zh: '请输入分类属性名称',
    en: 'Please input property name',
    ar: 'الرجاء إدخال النص',
    fa: 'لطفا وارد شوید',
    pt: 'Indique por favor o nome da propriedade'
  },
  '演职人员': {
    zh: '演职人员',
    en: 'Director and Actor',
    ar: 'المخرج والممثل',
    fa: 'کارگردان و بازیگر',
    pt: 'Director and Actor'
  },
  '新增导演': {
    zh: '新增导演',
    en: 'Add Director',
    ar: 'إضافة المخرج',
    fa: 'اضافه کردن به کارگردان',
    pt: 'Adicionar Director'
  },
  '新增演员': {
    zh: '新增演员',
    en: 'Add Actor',
    ar: 'أضف ممثلًا',
    fa: 'یک بازیگر اضافه کنید',
    pt: 'Adicionar Actores'
  },
  '编辑导演': {
    zh: '编辑导演',
    en: 'Edit Director',
    ar: 'محرر',
    fa: 'ویرایشگر',
    pt: 'Director Editorial'
  },
  '编辑演员': {
    zh: '编辑演员',
    en: 'Edit Actor',
    ar: 'محرر',
    fa: 'ویرایشگر',
    pt: 'Editar Actores'
  },
  '姓名': {
    zh: '姓名',
    en: 'Name',
    ar: 'الإسم',
    fa: 'نام',
    pt: 'Nome'
  },
  '职业': {
    zh: '职业',
    en: 'Occupation',
    ar: 'مهنة',
    fa: 'شغل',
    pt: 'Profissão'
  },
  '出生': {
    zh: '出生',
    en: 'Born',
    ar: 'ولد',
    fa: 'تولد',
    pt: 'Nascimento'
  },
  '传记': {
    zh: '传记',
    en: 'Biography',
    ar: 'سيرة شخصية',
    fa: 'بیولوگرافی',
    pt: 'Biografia'
  },
  '奖项': {
    zh: '奖项',
    en: 'Awards',
    ar: 'الجوائز',
    fa: 'جوایز',
    pt: 'Prémios'
  },
  '上映时间': {
    zh: '上映时间',
    en: 'Release Date',
    ar: 'تاريخ الإصدار',
    fa: 'زمان انتشار',
    pt: 'Data Lançamento'
  },
  '预告片': {
    zh: '预告片ID',
    en: 'Trailer ID',
    ar: 'مقطورة معرف',
    fa: 'هویت تریلر',
    pt: 'ID Reboque'
  },
  '按日期': {
    zh: '按日期',
    en: 'Date',
    ar: 'تواريخ',
    fa: 'تاریخ',
    pt: 'Data'
  },
  '按月份': {
    zh: '按月份',
    en: 'Month',
    ar: 'شهر',
    fa: 'ماه',
    pt: 'Mês'
  },
  '按年': {
    zh: '按年',
    en: 'Year',
    ar: 'سنة',
    fa: 'سال',
    pt: 'Ano'
  },
  '是否删除历史或收藏': {
    zh: '是否删除 {list} ?',
    en: 'Do you want to delete {list} ?',
    ar: 'حذف { list } ؟',
    fa: 'می‌خواهید { list }راحذف کنید؟',
    pt: 'Deseja apagar o {list}?'
  },
  '删除全部': {
    zh: '删除全部',
    en: 'Delete All',
    ar: 'حذف جميع',
    fa: 'حذف همه‌ی',
    pt: 'Apagar Tudo'
  },
  '确认删除全部?': {
    zh: '确认删除全部?',
    en: 'Are you sure to delete all?',
    ar: 'تأكيد حذف جميع ؟',
    fa: 'مطمئني همه چيز رو پاک کني؟',
    pt: 'Tem a certeza de apagar tudo?'
  },
  '今日': {
    zh: '今日',
    en: 'Today',
    ar: 'اليوم',
    fa: 'امروز',
    pt: 'Hoje'
  },
  '昨天': {
    zh: '昨天',
    en: 'Yesterday',
    ar: 'البارحة',
    fa: 'دیروز',
    pt: 'Ontem'
  },
  '一周': {
    zh: '一周',
    en: 'Week',
    ar: 'أسبوع',
    fa: 'یک هفته',
    pt: 'Semana'
  },
  '更早': {
    zh: '更早',
    en: 'Earlier',
    ar: 'في وقت سابق',
    fa: 'زودتر',
    pt: 'Mais Cedo'
  },
  '删除分类': {
    zh: '删除分类',
    en: 'Delete Category',
    ar: 'حذف التصنيف',
    fa: 'حذف گروه',
    pt: 'Excluir Categoria'
  },
  '搜索': {
    zh: '搜索',
    en: 'Search',
    ar: 'يبحث',
    fa: 'جستجو کردن',
    pt: 'Pesquisa'
  },
  '提交翻译': {
    zh: '提交翻译',
    en: 'Submit Translation',
    ar: 'ترجمة',
    fa: 'ترجمه کردن',
    pt: 'Enviar Tradução'
  },
  '调用翻译接口失败': {
    zh: '调用翻译接口失败',
    en: 'Translation Failed.',
    ar: 'فشل الترجمة',
    fa: 'ترجمه شکست خورد',
    pt: 'Não foi possível chamar a interface de tradução'
  },
  '请先勾选需要翻译的影片': {
    zh: '请先勾选需要翻译的影片',
    en: 'Please check the movie that needs to be translated first.',
    ar: 'الرجاء اختيار الفيلم الذي تريد ترجمته',
    fa: 'لطفا فیلم را انتخاب کنید که باید ترجمه شود',
    pt: 'Por favor, verifique o filme que precisa ser traduzido primeiro'
  },
  '导入续集': {
    zh: '导入续集',
    en: 'Import Sequel',
    ar: 'استيرادها',
    fa: 'واردات',
    pt: 'Importar a Sequência'
  },
  '上传中': {
    zh: '上传中',
    en: 'Uploading',
    ar: 'تحميل',
    fa: 'در حال آپلود',
    pt: 'Enviando'
  },
  '已上传': {
    zh: '已上传',
    en: 'Uploaded',
    ar: 'تم الرفع',
    fa: 'کامل',
    pt: 'Carregado'
  },
  '文件名称': {
    zh: '文件名称',
    en: 'File Name',
    ar: 'اسم الملف',
    fa: 'نام پرونده',
    pt: 'Nome do Ficheiro'
  },
  '文件大小': {
    zh: '文件大小',
    en: 'File Size',
    ar: 'حجم الملف',
    fa: 'اندازه پرونده',
    pt: 'Tamanho Ficheiro'
  },
  '进度': {
    zh: '进度',
    en: 'Progress',
    ar: 'شريط التقدم',
    fa: 'نوار پیشرفت',
    pt: 'Progresso'
  },
  '上传用户': {
    zh: '上传用户',
    en: 'Upload User',
    ar: 'اسم المستخدم',
    fa: 'آپلود کاربر',
    pt: 'Carregar Usuário'
  },
  '上传': {
    zh: '上传',
    en: 'Upload',
    ar: 'تحميل',
    fa: 'بارگذاری',
    pt: 'Carregar'
  },
  '已停止': {
    zh: '已停止',
    en: 'Stopped',
    ar: 'توقف',
    fa: 'متوقف شده',
    pt: 'Parado'
  },
  '上传中...': {
    zh: '上传中...',
    en: 'Uploading...',
    ar: '...تحميل',
    fa: '...در حال پیشرفت',
    pt: 'Carregar...'
  },
  '上传成功': {
    zh: '上传成功',
    en: 'Complete',
    ar: 'اكتمل',
    fa: 'کامل',
    pt: 'O envio foi bem Sucedido'
  },
  '等待上传': {
    zh: '等待上传',
    en: 'Waiting',
    ar: 'في انتظار',
    fa: 'منتظر',
    pt: 'Aguardando Upload'
  },
  '上传错误': {
    zh: '上传错误',
    en: 'Upload Error',
    ar: 'تحميل خطأ',
    fa: 'خطای بارگذاری',
    pt: 'Erro de Envio'
  },
  'Add to': {
    zh: '添加到影片',
    en: 'Add to',
    ar: 'إضافة فيلم',
    fa: 'افزودن به',
    pt: 'Adicionar Vídeo'
  },
  '转码': {
    zh: '转码',
    en: 'Transcode',
    ar: 'ترانسكودي',
    fa: 'ترنسکود',
    pt: 'Transcodificação'
  },
  '重传': {
    zh: '重传',
    en: 'Retransmission',
    ar: 'إعادة تحميل',
    fa: 'بازگرداندن',
    pt: 'Retransmissão'
  },
  '是否转码': {
    zh: '是否转码',
    en: 'Transcode',
    ar: 'ترانسكودي',
    fa: 'ترنسکود',
    pt: 'Transcodificação'
  },
  'Tip: Please do not refresh the page during uploading, otherwise the upload will be cancelled!': {
    zh: '提示：上传过程中请不要刷新页面，否则上传将被取消!',
    en: 'Tip: Please do not refresh the page during uploading, otherwise the upload will be cancelled!',
    ar: 'نصيحة : الرجاء عدم تحديث الصفحة أثناء التحميل ، وإلا سيتم إلغاء التحميل !',
    fa: 'اخطار: لطفاً در حال بارگذاری صفحه را تازگی نکنید، وگرنه بارگذاری کنسل می شود!',
    pt: 'Dica: Por favor, não atualize a página durante o processo de upload, caso contrário, o upload será cancelado!'
  },
  '确定删除已选数据吗?': {
    zh: '确定删除已选数据吗?',
    en: 'Are you sure to delete the selected data?',
    ar: 'هل أنت متأكد من أنك تريد حذف البيانات المختارة ؟',
    fa: 'مطمئنی که داده‌های برگزیده را حذف کنید؟',
    pt: 'Tem a certeza de apagar os dados seleccionados?'
  },
  '该文件已在上传列表中': {
    zh: '该文件已在上传列表中',
    en: 'The file is already in the uploading list.',
    ar: '.الملف موجود بالفعل في قائمة التحميل',
    fa: '.پرونده قبلا در فهرست بارگذاری است',
    pt: 'O arquivo já está na lista de upload.'
  },
  '该文件已在取消列表中': {
    zh: '该文件已在取消列表中',
    en: 'The file is already in the cancelled list.',
    ar: '.الملف موجود بالفعل في قائمة إلغاء',
    fa: '.این پرونده لیست را لغو کرده است',
    pt: 'O arquivo já está na lista de cancelamento.'
  },
  '请先勾选需要删除的数据': {
    zh: '请先勾选需要删除的数据',
    en: 'Please check the data that needs to be deleted first.',
    ar: '.يرجى التحقق من البيانات التي تحتاج إلى حذف',
    fa: 'لطفاً ابتدا داده ها را انتخاب کنید.',
    pt: 'Por favor, verifique os dados que precisam ser excluídos primeiro.'
  },
  '请选择相同文件上传': {
    zh: '请选择相同文件上传',
    en: 'Please select the same file to upload.',
    ar: '.الرجاء اختيار نفس الملف',
    fa: '.لطفاً همان پرونده را انتخاب کنید',
    pt: 'Seleccione por favor o mesmo ficheiro a enviar.'
  },
  '请选择文件': {
    zh: '请选择文件',
    en: 'Please select a file.',
    ar: '.الرجاء اختيار الملف',
    fa: '.لطفا یک پرونده انتخاب کنید',
    pt: 'Seleccione por favor um ficheiro.'
  },
  '该信息源ID不存在,请新增影片': {
    zh: '该信息源ID不存在,请新增影片',
    en: 'The information source ID does not exist. Please add a new film.',
    ar: '.مصدر المعلومات رقم غير موجود ، يرجى إضافة فيلم جديد',
    fa: '.شناسۀ منبع اطلاعات وجود ندارد. لطفاً یک فیلم جدید اضافه کنید',
    pt: 'O ID da fonte de informação não existe. Por favor, adicione um novo filme.'
  },
  '关联影片': {
    zh: '关联影片',
    en: 'Associated',
    ar: 'مترابط',
    fa: 'ارتباط',
    pt: 'Associada'
  },
  '转码URL': {
    zh: '转码URL',
    en: 'Transcode URL',
    ar: 'رابط ترانسكودي',
    fa: 'نشانی ترنسکود',
    pt: 'URL de Transcodificação'
  },
  '确定取消这条数据吗?': {
    zh: '确定取消这条数据吗?',
    en: 'Are you sure to cancel this data?',
    ar: 'هل أنت متأكد من أنك تريد إلغاء هذه البيانات ؟',
    fa: 'مطمئني که اين داده ها رو کنسل کني؟',
    pt: 'Tem a certeza de cancelar estes dados?'
  },
  '该信息源ID不存在电影中,请新增电影': {
    zh: '该信息源ID不存在电影中,请新增电影',
    en: 'The information source ID does not exist in the movie. Please add a new movie.',
    ar: '.مصدر المعلومات معرف غير موجود في الفيلم ، يرجى إضافة فيلم جديد',
    fa: '.شناسۀ منبع اطلاعات در فیلم وجود ندارد. لطفاً یک فیلم جدید اضافه کنید',
    pt: 'O ID da fonte de informação não existe no filme, por favor adicione um novo filme.'
  },
  '该信息源ID不存在剧集中,请新增剧集': {
    zh: '该信息源ID不存在剧集中,请新增剧集',
    en: 'The information source ID does not exist in the TV Shows. Please add a new TV Shows.',
    ar: '.معرف مصدر هذه المعلومات غير موجود في المسلسل التلفزيوني ، يرجى إضافته',
    fa: '.شناسه منبع این اطلاعات در سریال های تلویزیونی وجود ندارد ، لطفاً آن را اضافه کنید',
    pt: 'O ID da fonte de informação não existe no episódio. Por favor, adicione um novo episódio.'
  },
  '码率 (H.264)': {
    zh: '码率 (H.264)',
    en: 'Code Rate (H.264)',
    ar: '( H.264 ) معدل الترميز',
    fa: '(H.264) نرخ کد',
    pt: 'Taxa de Bits (H.264)'
  },
  '码率 (H.265)': {
    zh: '码率 (H.265)',
    en: 'Code Rate (H.265)',
    ar: '( H.265 ) معدل الترميز',
    fa: '(H.265) نرخ کد',
    pt: 'Taxa de Bits (H.265)'
  },
  '4K视频转码参数设置': {
    zh: '4K视频转码参数设置',
    en: '4K Video Transcoding Parameter Settings',
    ar: '4K ترميز الفيديو إعدادات المعلمة',
    fa: '4K تنظیمات پارامتر انتقال فیلم',
    pt: 'Parâmetro de Transferência Vídeo em 4K'
  },
  '2K视频转码参数设置': {
    zh: '2K视频转码参数设置',
    en: '2K Video Transcoding Parameter Settings',
    ar: '2K ترميز الفيديو إعدادات المعلمة',
    fa: '2K تنظیمات پارامتر انتقال فیلم',
    pt: 'Parâmetro de Transferência Vídeo em 2K'
  },
  '超清视频转码参数设置': {
    zh: '超清视频转码参数设置',
    en: 'Ultra Clear Video Transcoding Parameter Settings',
    ar: 'سوبر نظيفة ترميز الفيديو إعدادات المعلمة',
    fa: 'تنظیمات پارامتر رمزگذاری ویدیویی فوق العاده تمیز',
    pt: 'Parâmetro de Transferência Vídeo em Ultra Clara'
  },
  '高清视频转码参数设置': {
    zh: '高清视频转码参数设置',
    en: 'HD Video Transcoding Parameter Settings',
    ar: 'إعدادات الفيديو عالية الوضوح',
    fa: 'تنظیمات پارامتر رمزگذاری ویدئو HD',
    pt: 'Parâmetro de Transferência Vídeo em HD'
  },
  '标清视频转码参数设置': {
    zh: '标清视频转码参数设置',
    en: 'SD Video Transcoding Parameter Settings',
    ar: 'SD فيديو المعلمة التكوين',
    fa: 'SD پیکربندی پارامتر ویدئو',
    pt: 'Parâmetro de Transferência Vídeo em SD'
  },
  '流畅视频转码参数设置': {
    zh: '流畅视频转码参数设置',
    en: 'Smooth Video Transcoding Parameter Settings',
    ar: 'إعدادات معلمة ترميز الفيديو السلس',
    fa: 'تنظیمات پارامتر رمزگذاری ویدیویی صاف',
    pt: 'Parâmetro de Transferência Vídeo em Vídeo Suave'
  },
  '运营商管理': {
    zh: '运营商管理',
    en: 'Operator',
    ar: 'إدارة المشغل',
    fa: 'مدیریت اپراتور',
    pt: 'Operador'
  },
  '父节点': {
    zh: '父节点',
    en: 'Parent Node',
    ar: 'عقدة متفوقة',
    fa: 'سطح قبلی',
    pt: 'Nó Pai'
  },
  '选择数据中包含父节点': {
    zh: '选择数据中包含父节点',
    en: 'Select data containing parent nodes.',
    ar: '.حدد البيانات التي تحتوي على العقدة الأصل',
    fa: '.انتخاب داده‌های شامل گره‌های والدین',
    pt: 'Selecione dados contendo nós pais.'
  },
  '勾选数据大于一': {
    zh: '勾选数据大于一',
    en: 'Selected data cannot be greater than one.',
    ar: '.اختيار البيانات لا يمكن أن يكون أكبر من واحد',
    fa: '.داده‌های برگزیده نمی‌توانند بیشتر از یک باشند',
    pt: 'Os dados selecionados não podem ser maiores que um.'
  },
  '运营商': {
    zh: '运营商',
    en: 'Operator',
    ar: 'مشغّل',
    fa: 'اپراتور',
    pt: 'Operadores'
  },
  '请选择运营商': {
    zh: '请选择运营商',
    en: 'Please select an operator',
    ar: 'الرجاء اختيار المشغل',
    fa: 'لطفا اپراتور را انتخاب کنید',
    pt: 'Seleccione por favor um operador'
  },
  '复制成功': {
    zh: '复制成功',
    en: 'Copy success',
    ar: 'نسخ بنجاح',
    fa: 'کپی موفقیت',
    pt: 'Copiar com Sucesso'
  },
  '复制失败': {
    zh: '复制失败',
    en: 'Copy failed',
    ar: 'فشل النسخ',
    fa: 'کپی شکست خورد',
    pt: 'alha na Cópia'
  },
  '不包含': {
    zh: '不包含',
    en: 'Not Include',
    ar: 'لا تحتوي على',
    fa: 'شامل نمی شود',
    pt: 'Excluindo'
  },
  '季': {
    zh: '季',
    en: 'Season',
    ar: 'الموسم',
    fa: 'فصل',
    pt: 'Temporada'
  },
  '请输入季': {
    zh: '请输入季',
    en: 'Please input season',
    ar: 'الرجاء إدخال الموسم',
    fa: 'لطفاً فصل وارد شوید',
    pt: 'Por favor insira o trimestre'
  },
  '未转码': {
    zh: '未转码',
    en: 'Not Transcoded',
    ar: 'لا تحويل رمز',
    fa: 'ترنسکود نشده',
    pt: 'Não Transcodificado'
  },
  '已转码': {
    zh: '已转码',
    en: 'Transcoded',
    ar: 'تحويل رمز',
    fa: 'رمز تبدیل شده',
    pt: 'Transcodificado'
  },
  '转码中': {
    zh: '转码中',
    en: 'Transcoding',
    ar: 'في تَقَدم',
    fa: 'در حال پیشرفت',
    pt: 'Transcodificação'
  },
  '无需转码': {
    zh: '无需转码',
    en: 'No Need Transcoding',
    ar: 'لا حاجة',
    fa: 'لازم نيست',
    pt: 'Não Necessária Transcodificação'
  },
  '上传字幕': {
    zh: '上传字幕',
    en: 'Upload Subtitles',
    ar: 'الترجمة',
    fa: 'زیر عنوان',
    pt: 'Carregar Legendas'
  },
  '无字幕': {
    zh: '无字幕',
    en: 'No Subtitles',
    ar: 'بدون ترجمة',
    fa: 'بدون زیرنویس',
    pt: 'Sem Legenda'
  },
  '翻译字幕': {
    zh: '翻译字幕',
    en: 'Translate Subtitles',
    ar: 'قائمة الترجمة',
    fa: 'زیرنویس ترجمه',
    pt: 'Traduzir Legendas'
  },
  '未翻译': {
    zh: '未翻译',
    en: 'Untranslated',
    ar: 'غير مترجمة',
    fa: 'بدون ترجمه',
    pt: 'Não Traduzido'
  },
  '翻译中': {
    zh: '翻译中',
    en: 'Translating',
    ar: 'في الترجمة',
    fa: 'در ترجمه',
    pt: 'Em Tradução'
  },
  '已完成': {
    zh: '已完成',
    en: 'Completed',
    ar: 'اكتمل',
    fa: 'کامل',
    pt: 'Concluído'
  },
  '文件MD5校验中 请稍后...': {
    zh: '文件MD5校验中 请稍后...',
    en: 'File MD5 verification in progress, please wait...',
    ar: '...التحقق من ملف MD5  يرجى الانتظار',
    fa: '...ثابت پرونده MD5 در حال حاضر ، لطفا صبر کنید',
    pt: 'Verificação do arquivo MD5 em andamento, por favor aguarde...'
  },
  '视频播放失败,请': {
    zh: '视频播放失败,请',
    en: 'Play error, Please',
    ar: 'فشل تشغيل الفيديو ، من فضلك',
    fa: 'بازی ویدئو شکست خورد،',
    pt: 'A reprodução do vídeo falhou, por favor'
  },
  '刷新_s': {
    zh: '刷新',
    en: 'refresh',
    ar: 'ينعش',
    fa: 'تازه کردن',
    pt: 'atualizar'
  },
  '重试_s': {
    zh: '重试',
    en: 'and retry',
    ar: 'إعادة المحاولة',
    fa: 'دوباره امتحان کنید',
    pt: 'tentar novamente'
  },
  '评分': {
    zh: '评分',
    en: 'Rating',
    ar: 'كسري',
    fa: 'امتیاز',
    pt: 'Avaliação'
  },
  '认证': {
    zh: '认证',
    en: 'Certification',
    ar: 'يثبت',
    fa: 'ثابت کن',
    pt: 'Autenticação'
  },
  '请输入大于0且不大于10的正整数或一位小数': {
    zh: '请输入大于0且不大于10的正整数或一位小数',
    en: 'Please input a positive integer or one decimal place that is greater than 0 and not greater than 10',
    ar: 'الرجاء إدخال رقم أكبر من 0 و لا أكثر من 10',
    fa: 'لطفاً یک عدد بزرگتر از ۰ وارد کنید و نه بزرگتر از ۱۰',
    pt: 'Insira um número inteiro positivo ou uma casa decimal maior que 0 e não maior que 10'
  },
  '品牌分类': {
    zh: '品牌分类',
    en: 'Brand Category',
    ar: 'تصنيف العلامة التجارية',
    fa: 'دسته برند',
    pt: 'Categoria de Marca'
  },
  '节目': {
    zh: '节目',
    en: 'Program',
    ar: 'برنامج',
    fa: 'برنامه',
    pt: 'Programa'
  },
  '目标地址': {
    zh: '目标地址',
    en: 'Target URL',
    ar: 'عنوان الوجهة',
    fa: 'نشانی هدف',
    pt: 'Endereço de Destino'
  },
  '替换地址': {
    zh: '替换地址',
    en: 'Replace URL',
    ar: 'استبدال العنوان',
    fa: 'آدرس را جایگزین کنید',
    pt: 'Substitua o Endereço'
  },
  '替换': {
    zh: '替换',
    en: 'Replace',
    ar: 'استبدال',
    fa: 'جایگزینی',
    pt: 'Substituir'
  },
  '查询节目数量结果': {
    zh: '查询结果: {num}个节目数量',
    en: 'Query result: {num} number of programs.',
    ar: '.نتيجة الاستعلام : {num} عدد البرامج',
    fa: 'نتیجه سؤال: {num} تعداد برنامه‌ها.',
    pt: 'Resultado da consulta: {num} número de programas.'
  },
  '查询图片数量结果': {
    zh: '查询结果: {num}个图片数量',
    en: 'Query result: {num} number of pictures.',
    ar: '.نتيجة الاستعلام : { num } عدد الصور',
    fa: 'نتیجه سؤال: {num} تعداد تصاویر.',
    pt: 'Resultados da consulta: {num} número de fotos'
  },
  '查询字幕数量结果': {
    zh: '查询结果: {num}个字幕数量',
    en: 'Query result: {num} number of subtitles.',
    ar: '.نتيجة الاستعلام : { num } عدد ترجمات',
    fa: 'نتیجه سؤال: {num} تعداد زیر عنوان.',
    pt: 'Resultados da consulta: {num} número de legendas'
  },
  '请输入目标地址': {
    zh: '请输入目标地址',
    en: 'Please input the target URL',
    ar: 'الرجاء إدخال عنوان الوجهة',
    fa: 'لطفاً نشانی هدف را وارد کنید',
    pt: 'Por favor, insira o endereço de destino'
  },
  '请输入替换地址': {
    zh: '请输入替换地址',
    en: 'Please input the replace URL',
    ar: 'أدخل عنوان بديل',
    fa: 'لطفاً یک نشانی جایگزینی وارد کنید',
    pt: 'Por favor insira um endereço alternativo'
  },
  '请先输入目标地址': {
    zh: '请先输入目标地址',
    en: 'Please input the replace URL first',
    ar: 'الرجاء إدخال العنوان المستهدف أولاً',
    fa: 'لطفاً ابتدا آدرس هدف را وارد کنید',
    pt: 'Por favor, insira o endereço de destino primeiro'
  },
  '目标地址和替换地址相同': {
    zh: '目标地址和替换地址相同',
    en: 'The target URL is the same as replace URL',
    ar: 'عنوان الوجهة هو نفس استبدال عنوان',
    fa: 'آدرس هدف و آدرس جایگزینی یکسان است',
    pt: 'O endereço de destino e o endereço de substituição são os mesmos'
  },
  '日_s': {
    zh: '日',
    en: 'Day',
    ar: 'أيام',
    fa: 'روز',
    pt: 'Dia'
  },
  '周_s': {
    zh: '周',
    en: 'Week',
    ar: 'أسابيع',
    fa: 'هفته',
    pt: 'Semana'
  },
  '月_s': {
    zh: '月',
    en: 'Month',
    ar: 'شهر',
    fa: 'ماه',
    pt: 'Mês'
  },
  '年_s': {
    zh: '年',
    en: 'year',
    ar: 'سنة',
    fa: 'سال',
    pt: 'Ano'
  },
  '最近一周': {
    zh: '最近一周',
    en: 'Last week',
    ar: 'الأسبوع الأخير',
    fa: 'هفته گذشته',
    pt: 'Semana Passada'
  },
  '最近一个月': {
    zh: '最近一个月',
    en: 'Last month',
    ar: 'في الشهر الماضي',
    fa: 'ماه گذشته',
    pt: 'Mês Passado'
  },
  '最近一年': {
    zh: '最近一年',
    en: 'Last year',
    ar: 'السنة الأخيرة',
    fa: 'سال گذشته',
    pt: 'Ano Passado'
  },
  '时间维度': {
    zh: '时间维度',
    en: 'Time Dimension',
    ar: 'البعد الزمني',
    fa: 'اندازه زمان',
    pt: 'Dimensão Tempo'
  },
  '时间范围': {
    zh: '时间范围',
    en: 'Time Frame',
    ar: 'نطاق الزمن',
    fa: 'فاصله زمان',
    pt: 'Intervalo de Tempo'
  },
  '电影': {
    zh: '电影',
    en: 'Movie',
    ar: 'فيلم',
    fa: 'فیلم سینما',
    pt: 'Filme'
  },
  '电视剧 (部)': {
    zh: '电视剧 (部)',
    en: 'TV Shows (Section)',
    ar: 'الدراما التلفزيونية ( قسم )',
    fa: 'سریال تلویزیونی (بخش)',
    pt: 'Série de TV (Seção)'
  },
  '电视剧剧集': {
    zh: '电视剧剧集',
    en: 'TV Shows Series',
    ar: 'عدد الحلقات التلفزيونية',
    fa: 'تعداد قسمت تلویزیون',
    pt: 'Série de TV'
  },
  '上线节目': {
    zh: '上线节目',
    en: 'Online Program',
    ar: 'برنامج على الانترنت',
    fa: 'برنامه‌ی آنلاین',
    pt: 'Programa Online'
  },
  '新增节目': {
    zh: '新增节目',
    en: 'New Program',
    ar: 'إضافة برنامج',
    fa: 'برنامه‌های جدید',
    pt: 'Novo Programa'
  },
  '下线节目': {
    zh: '下线节目',
    en: 'Offline Program',
    ar: 'برنامج غير متصل',
    fa: 'برنامه‌های خارج از خط',
    pt: 'Programa Offline'
  },
  '删除节目': {
    zh: '删除节目',
    en: 'Delete Program',
    ar: 'حذف البرنامج',
    fa: 'حذف برنامه',
    pt: 'Excluir Programa'
  },
  '更新节目信息': {
    zh: '更新节目信息',
    en: 'Update Program',
    ar: 'تحديث البرنامج',
    fa: 'نمایش به روزرسانی',
    pt: 'Programa Atualização'
  },
  '更新图片': {
    zh: '更新图片',
    en: 'Update Image',
    ar: 'تحديث الصور',
    fa: 'تصاویر را به روز کنید',
    pt: 'Actualizar Imagem'
  },
  '影片总数': {
    zh: '影片总数',
    en: 'Films Total',
    ar: 'إجمالي عدد الأفلام',
    fa: 'تعداد کلی فیلم',
    pt: 'Total de Filmes'
  },
  '电影总数': {
    zh: '电影总数',
    en: 'Movies Total',
    ar: 'مجموع الأفلام',
    fa: 'تعداد کلی فیلم',
    pt: 'Número Total Filmes'
  },
  '电视剧总数': {
    zh: '电视剧总数',
    en: 'TV Shows (Section) Total',
    ar: 'مجموع الدراما التلفزيونية',
    fa: 'تعداد کلی نمایش تلویزیون',
    pt: 'Total Série de TV (Seção)'
  },
  '电视剧剧集总数': {
    zh: '电视剧剧集总数',
    en: 'TV Shows Series Total',
    ar: 'مجموع عدد المسلسلات التلفزيونية',
    fa: 'تعداد عمومی قسمت‌ها',
    pt: 'Total Séries Programas TV'
  },
  '昨日上线节目数': {
    zh: '昨日上线节目数',
    en: 'Online Yesterday',
    ar: 'عدد البرامج عبر الإنترنت أمس',
    fa: 'تعداد آغاز دیروز',
    pt: 'Online Ontem'
  },
  '昨日下线节目数': {
    zh: '昨日下线节目数',
    en: 'Offline Yesterday',
    ar: 'أمس قبالة خط البرنامج',
    fa: 'تعداد برنامه های آفلاین دیروز',
    pt: 'Offline Ontem'
  },
  '本月上线节目数': {
    zh: '本月上线节目数',
    en: 'Online This Month',
    ar: 'عدد البرامج على الانترنت هذا الشهر',
    fa: 'تعداد برنامه‌های این ماه آغاز شده',
    pt: 'Online Este Mês'
  },
  '本月下线节目数': {
    zh: '本月下线节目数',
    en: 'Offline This Month',
    ar: 'عدد البرامج غير المتصلة بالإنترنت هذا الشهر',
    fa: 'تعداد برنامه های آفلاین در این ماه',
    pt: 'Offline Este Mês'
  },
  '上线节目总数': {
    zh: '上线节目总数',
    en: 'Online Total',
    ar: 'مجموع عدد البرامج على الانترنت',
    fa: 'تعداد کلی برنامه‌های آنلاین',
    pt: 'Total Online'
  },
  '下线节目总数': {
    zh: '下线节目总数',
    en: 'Offline Total',
    ar: 'إجمالي عدد البرامج غير المتصلة بالإنترنت',
    fa: 'تعداد کل برنامه های آفلاین',
    pt: 'Total Offline'
  },
  '(电影总数 + 电视剧剧集总数)': {
    zh: '(电影总数 + 电视剧剧集总数)',
    en: '(Total number of movies + Total number of TV Shows series)',
    ar: '( مجموع الأفلام + مجموع المسلسلات التلفزيونية )',
    fa: '(تعداد کل فیلم + تعداد کل تلویزیون)',
    pt: '(Número total de filmes + Número total de séries de programas de TV)'
  },
  '加载中...': {
    zh: '加载中...',
    en: 'Loading...',
    ar: '...أرجوك إنتظر',
    fa: 'لطفا صبر کن...',
    pt: 'Carregando...'
  },
  '合计': {
    zh: '合计',
    en: ' Total',
    ar: ' المجموع',
    fa: ' جمع',
    pt: 'Total'
  },
  '数量': {
    zh: '数量',
    en: 'Number',
    ar: 'الكمية',
    fa: 'تعداد',
    pt: 'Número'
  },
  '文件读取已取消': {
    zh: '文件读取已取消',
    en: 'File read cancelled.',
    ar: '.قراءة الملف إلغاء',
    fa: '.خواندن پرونده کنسل شد',
    pt: 'Leitura do arquivo cancelada.'
  },
  '任务ID': {
    zh: '任务ID',
    en: 'Task ID',
    ar: 'معرف المهمة',
    fa: 'شناسۀ کاری',
    pt: 'ID Tarefa'
  },
  '影片源路径': {
    zh: '影片源路径',
    en: 'Source Path',
    ar: 'مسار الفيلم المصدر',
    fa: 'منبع',
    pt: 'Caminho de Origem'
  },
  '输出信息': {
    zh: '输出信息',
    en: 'Output Info',
    ar: 'معلومات الإخراج',
    fa: 'اطلاعات خروجی',
    pt: 'Informações de Saída'
  },
  '转码设备': {
    zh: '转码设备',
    en: 'Device',
    ar: 'معدات',
    fa: 'دستگاه',
    pt: 'Dispositivo'
  },
  '下发时间': {
    zh: '下发时间',
    en: 'Issue Time',
    ar: 'الوقت القادم',
    fa: 'زمان تنظیم',
    pt: 'Hora de Lançamento'
  },
  '转码状态': {
    zh: '转码状态',
    en: 'Status',
    ar: 'حالة الشفرة',
    fa: 'حالت',
    pt: 'Estado'
  },
  '转码成功': {
    zh: '转码成功',
    en: 'Successful',
    ar: 'النجاح في الترميز',
    fa: 'موفقیت آمیز',
    pt: 'Sucesso'
  },
  '转码失败': {
    zh: '转码失败',
    en: 'Failed',
    ar: 'هزم',
    fa: 'شکست خورد',
    pt: 'Fracassado'
  },
  '日志': {
    zh: '日志',
    en: 'Log',
    ar: 'سجل',
    fa: 'روزنامه',
    pt: 'Log'
  },
  '服务器类型': {
    zh: '服务器类型',
    en: 'Server Type',
    ar: 'نوع الخادم',
    fa: 'نوع سرور',
    pt: 'Tipo de servidor'
  },
  '存储名称': {
    zh: '存储名称',
    en: 'Storage Name',
    ar: 'اسم المخزن',
    fa: 'نام ذخیره سازی',
    pt: 'Nome Armazenamento'
  },
  '转码模板': {
    zh: '转码模板',
    en: 'Template',
    ar: 'قالب الشفرة',
    fa: 'نمونه',
    pt: 'Modelo'
  },
  '输出参数': {
    zh: '输出参数',
    en: 'Output Parameters',
    ar: 'معلمات الإخراج',
    fa: 'پارامترهای خروج',
    pt: 'Parâmetros de Saída'
  },
  '码率': {
    zh: '码率',
    en: 'Code Rate',
    ar: 'معدل بت',
    fa: 'نرخ کد',
    pt: 'Taxa de Código'
  },
  '请选择存储桶': {
    zh: '请选择存储桶',
    en: 'Please select a storage bucket',
    ar: 'الرجاء اختيار دلو التخزين',
    fa: 'لطفا یک بسته ذخیره را انتخاب کنید',
    pt: 'Selecione um bucket de armazenamento'
  },
  '请选择码率': {
    zh: '请选择码率',
    en: 'Please select the code rate',
    ar: 'الرجاء اختيار معدل بت',
    fa: 'لطفاً نرخ کد را انتخاب کنید',
    pt: 'Selecione a taxa do código'
  },
  '文件列表': {
    zh: '文件列表',
    en: 'File List',
    ar: 'قائمة الملفات',
    fa: 'فهرست پرونده',
    pt: 'Lista de Ficheiros'
  },
  '批量处理': {
    zh: '批量处理',
    en: 'Batch Processing',
    ar: 'دفعة تجهيز',
    fa: 'پردازش دسته ای',
    pt: 'Processamento em Lote'
  },
  '请选择编码标准': {
    zh: '请选择编码标准',
    en: 'Please select an encoding',
    ar: 'الرجاء اختيار الترميز',
    fa: 'لطفا کد را انتخاب کنید',
    pt: 'Seleccione por favor o padrão de codificação'
  },
  '请选择分辨率': {
    zh: '请选择分辨率',
    en: 'Please select a resolution',
    ar: 'الرجاء اختيار الوضوح',
    fa: 'لطفاً وضوح را انتخاب کنید',
    pt: 'Seleccione por favor uma resolução'
  },
  '输出文件名': {
    zh: '输出文件名',
    en: 'Output File Name',
    ar: 'اسم الملف الناتج',
    fa: 'نام فایل خروجی',
    pt: 'Nome Arquivo Saída'
  },
  '视频编码类型': {
    zh: '视频编码类型',
    en: 'Encoding',
    ar: 'ترميز',
    fa: 'رمز استاندارد',
    pt: 'Codificação '
  },
  '视频码率': {
    zh: '视频码率',
    en: 'Code Rate',
    ar: 'معدل بت',
    fa: 'نرخ کد',
    pt: 'Taxa de Código'
  },
  '视频分辨率': {
    zh: '视频分辨率',
    en: 'Resolution',
    ar: 'وضوح',
    fa: 'وضوح',
    pt: 'Resolução'
  },
  '等待中': {
    zh: '等待中',
    en: 'Waiting',
    ar: 'في انتظار',
    fa: 'منتظر',
    pt: 'À Espera'
  },
  '手动配置': {
    zh: '手动配置',
    en: 'Manual',
    ar: 'التكوين اليدوي',
    fa: 'پیکربندی دستی',
    pt: 'Manual'
  },
  '请选择服务器名称': {
    zh: '请选择服务器名称',
    en: 'Please select a server name',
    ar: 'الرجاء اختيار اسم الخادم',
    fa: 'لطفاً نام سرور را انتخاب کنید',
    pt: 'Seleccione por favor um nome de servidor'
  },
  '请选择转码设备': {
    zh: '请选择转码设备',
    en: 'Please select a device',
    ar: 'الرجاء اختيار الجهاز',
    fa: 'لطفا یک دستگاه را انتخاب کنید',
    pt: 'Seleccione por favor um dispositivo de transcodificação'
  },
  '请选择转码模板': {
    zh: '请选择转码模板',
    en: 'Please select a template',
    ar: 'الرجاء اختيار قالب',
    fa: 'لطفاً الگوی را انتخاب کنید',
    pt: 'Seleccione por favor um modelo de transcodificação'
  },
  '模板名称': {
    zh: '模板名称',
    en: 'Template Name',
    ar: 'اسم القالب',
    fa: 'نام الگو',
    pt: 'Nome do Modelo'
  },
  '模板描述': {
    zh: '模板描述',
    en: 'Template Description',
    ar: 'قالب الوصف',
    fa: 'شرح الگو',
    pt: 'Descrição do Modelo'
  },
  '模板输出路数': {
    zh: '模板输出路数',
    en: 'Number of Output',
    ar: 'قالب الإخراج',
    fa: 'تعداد مسیر خروجی قالب',
    pt: 'Número de Saída'
  },
  '请输入模板名称': {
    zh: '请输入模板名称',
    en: 'Please input template name',
    ar: 'الرجاء إدخال اسم القالب',
    fa: 'لطفاً نام الگوی را وارد کنید',
    pt: 'Indique por favor o nome do modelo'
  },
  '请输入模板描述': {
    zh: '请输入模板描述',
    en: 'Please input template description',
    ar: 'الرجاء إدخال قالب الوصف',
    fa: 'لطفاً توضیحات الگو را وارد کنید',
    pt: 'Indique por favor a descrição do modelo'
  },
  '日志文件': {
    zh: '日志文件',
    en: 'Log File',
    ar: 'ملف السجل',
    fa: 'پرونده ثبت',
    pt: 'Arquivo de Log'
  },
  '日志大小': {
    zh: '日志大小',
    en: 'Log Size',
    ar: 'حجم السجل',
    fa: 'اندازه ثبت',
    pt: 'Tamanho do Log'
  },
  '存储桶名称': {
    zh: '存储桶名称',
    en: 'Bucket Name',
    ar: 'اسم المخزن',
    fa: 'نام ذخیره سازی',
    pt: 'Nome Armazenamento'
  },
  '区域': {
    zh: '区域',
    en: 'Region',
    ar: 'منطقة',
    fa: 'منطقه',
    pt: 'Área'
  },
  '路径': {
    zh: '路径',
    en: 'Path',
    ar: 'مسار',
    fa: 'مسیر',
    pt: 'Caminho'
  },
  '访问秘钥': {
    zh: '访问秘钥',
    en: 'Access Key',
    ar: 'مفتاح الوصول',
    fa: 'کلید دسترسی',
    pt: 'Chave de Acesso'
  },
  '加密秘钥': {
    zh: '加密秘钥',
    en: 'Encryption Key',
    ar: 'مفتاح التشفير',
    fa: 'راز رمزگذاری',
    pt: 'Chave de Encriptação'
  },
  '请输入存储桶名称': {
    zh: '请输入存储桶名称',
    en: 'Please input the bucket name',
    ar: 'الرجاء إدخال اسم التخزين',
    fa: 'لطفاً نام ذخیره را وارد کنید',
    pt: 'Indique por favor o nome do armazenamento'
  },
  '请选择区域': {
    zh: '请选择区域',
    en: 'Please select region',
    ar: 'الرجاء اختيار المنطقة',
    fa: 'لطفاً یک منطقه را انتخاب کنید',
    pt: 'Por favor, seleccione a região'
  },
  '请输入访问秘钥': {
    zh: '请输入访问秘钥',
    en: 'Please input the access key',
    ar: 'أدخل مفتاح الوصول',
    fa: 'لطفا کلید دسترسی را وارد کنید',
    pt: 'Indique por favor a chave de acesso'
  },
  '请输入加密秘钥': {
    zh: '请输入加密秘钥',
    en: 'Please input the encryption key',
    ar: 'أدخل مفتاح التشفير',
    fa: 'لطفا کلید رمزبندی را وارد کنید',
    pt: 'Indique por favor a chave de encriptação'
  },
  'S3服务器访问地址': {
    zh: 'S3服务器访问地址',
    en: 'Cloud Front',
    ar: 'عنوان الوصول إلى الخادم',
    fa: 'نشانی دسترسی کارساز',
    pt: 'Endereço de Acesso ao Servidor'
  },
  'US East (Ohio)': {
    zh: '美国东部（俄亥俄）',
    en: 'US East (Ohio)',
    ar: 'US East (Ohio)',
    fa: 'US East (Ohio)',
    pt: 'US East (Ohio)'
  },
  'US East (N. Virginia)': {
    zh: '美国东部（弗吉尼亚北部）',
    en: 'US East (N. Virginia)',
    ar: 'US East (N. Virginia)',
    fa: 'US East (N. Virginia)',
    pt: 'US East (N. Virginia)'
  },
  'US West (Oregon)': {
    zh: '美国西部（俄勒冈）',
    en: 'US West (Oregon)',
    ar: 'US West (Oregon)',
    fa: 'US West (Oregon)',
    pt: 'US West (Oregon)'
  },
  'South America (São Paulo)': {
    zh: '南美洲（圣保罗）',
    en: 'South America (São Paulo)',
    ar: 'South America (São Paulo)',
    fa: 'South America (São Paulo)',
    pt: 'South America (São Paulo)'
  },
  'Asia Pacific (Mumbai)': {
    zh: '亚太地区（孟买）',
    en: 'Asia Pacific (Mumbai)',
    ar: 'Asia Pacific (Mumbai)',
    fa: 'Asia Pacific (Mumbai)',
    pt: 'Asia Pacific (Mumbai)'
  },
  'Asia Pacific (Seoul)': {
    zh: '亚太地区（首尔）',
    en: 'Asia Pacific (Seoul)',
    ar: 'Asia Pacific (Seoul)',
    fa: 'Asia Pacific (Seoul)',
    pt: 'Asia Pacific (Seoul)'
  },
  'Asia Pacific (Singapore)': {
    zh: '亚太地区（新加坡）',
    en: 'Asia Pacific (Singapore)',
    ar: 'Asia Pacific (Singapore)',
    fa: 'Asia Pacific (Singapore)',
    pt: 'Asia Pacific (Singapore)'
  },
  'Asia Pacific (Sydney)': {
    zh: '亚太地区（悉尼）',
    en: 'Asia Pacific (Sydney)',
    ar: 'Asia Pacific (Sydney)',
    fa: 'Asia Pacific (Sydney)',
    pt: 'Asia Pacific (Sydney)'
  },
  'Asia Pacific (Tokyo)': {
    zh: '亚太地区（东京）',
    en: 'Asia Pacific (Tokyo)',
    ar: 'Asia Pacific (Tokyo)',
    fa: 'Asia Pacific (Tokyo)',
    pt: 'Asia Pacific (Tokyo)'
  },
  'Canada (Central)': {
    zh: '加拿大（中部）',
    en: 'Canada (Central)',
    ar: 'Canada (Central)',
    fa: 'Canada (Central)',
    pt: 'Canada (Central)'
  },
  'China (Beijing) Region': {
    zh: '中国（北京）区域',
    en: 'China (Beijing) Region',
    ar: 'China (Beijing) Region',
    fa: 'China (Beijing) Region',
    pt: 'China (Beijing) Region'
  },
  'China (Ningxia)': {
    zh: '中国（宁夏）',
    en: 'China (Ningxia)',
    ar: 'China (Ningxia)',
    fa: 'China (Ningxia)',
    pt: 'China (Ningxia)'
  },
  'Europe (Frankfurt)': {
    zh: '欧洲（法兰克福）',
    en: 'Europe (Frankfurt)',
    ar: 'Europe (Frankfurt)',
    fa: 'Europe (Frankfurt)',
    pt: 'Europe (Frankfurt)'
  },
  'Europe (Ireland)': {
    zh: '欧洲（爱尔兰）',
    en: 'Europe (Ireland)',
    ar: 'Europe (Ireland)',
    fa: 'Europe (Ireland)',
    pt: 'Europe (Ireland)'
  },
  'Europe (London)': {
    zh: '欧洲（伦敦）',
    en: 'Europe (London)',
    ar: 'Europe (London)',
    fa: 'Europe (London)',
    pt: 'Europe (London)'
  },
  'Europe (Milan)': {
    zh: '欧洲（米兰）',
    en: 'Europe (Milan)',
    ar: 'Europe (Milan)',
    fa: 'Europe (Milan)',
    pt: 'Europe (Milan)'
  },
  'Europe (Paris)': {
    zh: '欧洲（巴黎）',
    en: 'Europe (Paris)',
    ar: 'Europe (Paris)',
    fa: 'Europe (Paris)',
    pt: 'Europe (Paris)'
  },
  '上传队列已满': {
    zh: '上传队列已满',
    en: 'Upload queue is full',
    ar: 'تحميل طابور كامل',
    fa: 'خط پر است',
    pt: 'A fila de upload está cheia'
  },
  '密钥，桶，或者区域填写错误': {
    zh: '密钥，桶，或者区域填写错误',
    en: 'Key, bucket, or area filled incorrectly',
    ar: 'مفتاح ، دلو ، أو منطقة الخطأ',
    fa: 'کلید، سطل یا منطقه به اشتباه پر شده است',
    pt: 'Chave, balde ou área preenchida incorretamente'
  },
  '模板名重复': {
    zh: '模板名重复',
    en: 'Duplicate template name',
    ar: 'تكرار اسم القالب',
    fa: 'تکرار نام الگوی',
    pt: 'Nome do modelo duplicado'
  },
  '服务器名重复': {
    zh: '服务器名重复',
    en: 'Duplicate server name',
    ar: 'تكرار اسم الخادم',
    fa: 'تکرار نام سرور',
    pt: 'Nome de servidor duplicado'
  },
  '模板类型错误': {
    zh: '模板类型错误',
    en: 'Template type error',
    ar: 'قالب نوع الخطأ',
    fa: 'نوع قالب اشتباه',
    pt: 'Erro de tipo de modelo'
  },
  '没有可替换目标': {
    zh: '没有可替换目标',
    en: 'No replaceable targets',
    ar: 'لا هدف بديل',
    fa: 'هدف جایگزینی نیست',
    pt: 'Não há alvos substituíveis'
  },
  '文件无需转码': {
    zh: '文件无需转码',
    en: 'Files do not require transcoding.',
    ar: 'الملف لا يحتاج إلى الشفرة',
    fa: 'پرونده‌ها نیاز به تغییر رمزبندی نیستند',
    pt: 'Os arquivos não precisam ser transcodificados'
  },
  '该批量文件已转码': {
    zh: '该批量文件已转码',
    en: 'This batch of files has been transcoded.',
    ar: 'الكثير من الملفات تم تحويلها',
    fa: 'این گروه پرونده‌ها ترنسکود شده‌اند',
    pt: 'O arquivo em lote foi transcodificado'
  },
  '无权创建桶': {
    zh: '无权创建桶',
    en: 'No permission to create bucket.',
    ar: 'لا يحق إنشاء',
    fa: 'بدون ایجاد مجوز',
    pt: 'Sem permissão para criar o balde.'
  },
  'cloudfront 输入错误': {
    zh: 'Cloudfront 输入错误',
    en: 'CloudFront input error.',
    ar: 'خطأ في إدخال عنوان الوصول إلى الملقم',
    fa: 'خطای ورودی آدرس دسترسی سرور',
    pt: 'Erro de entrada do cloudfront'
  },
  '字幕列表': {
    zh: '字幕列表',
    en: 'Subtitle List',
    ar: 'قائمة الترجمة',
    fa: 'فهرست زیر عنوان',
    pt: 'Lista de Legenda'
  },
  '字幕预览': {
    zh: '字幕预览',
    en: 'Subtitle Preview',
    ar: 'معاينة الترجمة',
    fa: 'پیش‌نمایش عنوان زیر عنوان',
    pt: 'Visualização de Legenda'
  },
  '编辑字幕': {
    zh: '编辑字幕',
    en: 'Edit Subtitle',
    ar: 'تحرير الترجمة',
    fa: 'ویرایش عنوان زیر',
    pt: 'Editar Legendas'
  },
  '字幕编辑': {
    zh: '字幕编辑',
    en: 'Edit Subtitle',
    ar: 'تحرير الترجمة',
    fa: 'ویرایش عنوان زیر',
    pt: 'Editar Legendas'
  },
  '保存': {
    zh: '保存',
    en: 'Save',
    ar: 'حفظ',
    fa: 'محافظت',
    pt: 'Salvar'
  },
  '非视频文件': {
    zh: '非视频文件',
    en: 'Non video files',
    ar: 'غير ملف الفيديو',
    fa: 'پرونده ویدئو نیست',
    pt: 'Arquivo não Video'
  },
  '数据异常,请联系管理员': {
    zh: '数据异常,请联系管理员',
    en: 'Data is abnormal. Please contact the administrator',
    ar: 'البيانات غير طبيعية. الرجاء الاتصال بالمدير',
    fa: 'داده ها غیر طبیعی است. لطفا با مدیر تماس بگیرید',
    pt: 'Anomalia de dados, contactar o administrador'
  },
  '缺少必要参数': {
    zh: '缺少必要参数',
    en: 'Missing required parameters',
    ar: 'عدم وجود المعلمات المطلوبة',
    fa: 'عدم وجود پارامترهای مورد نیاز',
    pt: 'Parâmetros necessários em falta'
  },
  '导入的文件为空,请按下载文档校正再导入': {
    zh: '导入的文件为空,请按下载文档校正再导入',
    en: 'The imported file is empty. Please correct according to the downloaded document before importing',
    ar: 'استيراد ملف فارغ ، اضغط على تحميل ملف تصحيح ثم استيراد',
    fa: 'پرونده وارد شده خالی است. لطفاً قبل از وارد کردن بر اساس سند بارگذاری درست کنید',
    pt: 'O ficheiro importado está vazio, transfira o documento para o corrigir antes de o importar'
  },
  '导入的表头信息错误,请按下载文档校正再导入': {
    zh: '导入的表头信息错误,请按下载文档校正再导入',
    en: 'The header information imported is incorrect. Please correct according to the downloaded document before importing',
    ar: 'استيراد معلومات رأس خطأ ، اضغط على تحميل الوثيقة لتصحيح الخطأ قبل الاستيراد',
    fa: 'اطلاعات عنوان وارد شده اشتباه است. لطفاً قبل از وارد کردن توسط سند بارگیری را درست کنید',
    pt: 'As informações de cabeçalho da tabela importada estão erradas, corrija-as descarregando o documento e importando-o em seguida'
  },
  'excel文件里面的数据项错误,请按下载文档校正再导入': {
    zh: 'excel文件里面的数据项错误,请按下载文档校正再导入',
    en: 'The data item in the Excel file is incorrect. Please correct it according to the downloaded document before importing it',
    ar: 'ملف اكسل داخل عنصر البيانات خطأ ، اضغط على تحميل الوثيقة تصحيح ثم استيراد',
    fa: 'عنوان داده در پرونده Excel اشتباه است. لطفاً درستش کنید بر اساس سند بارگذاری قبل از وارد کردنش',
    pt: 'Os itens de dados no ficheiro Excel estão errados, transfira o documento para corrigir e depois importe'
  },
  '提示：修改保存后要等待两分钟可以同步到终端。': {
    zh: '提示：修改保存后要等待两分钟可以同步到终端。',
    en: 'Tip: After modifying and saving, you need to wait for two minutes to synchronize to the terminal.',
    ar: '.نصيحة : بعد تعديل حفظ الانتظار دقيقتين لمزامنة المحطة',
    fa: 'نکته: بعد از تغییر و ذخیره، باید برای دو دقیقه صبر کنید تا با ترمینال همزمان کنید.',
    pt: 'Dica: Depois de modificar e salvar, aguarde dois minutos para sincronizar com o terminal.'
  },
  '请输入内容': {
    zh: '请输入内容',
    en: 'Please input content.',
    ar: '.الرجاء إدخال المحتوى',
    fa: 'لطفاً محتوای را وارد کنید.',
    pt: 'Indique por favor o conteúdo'
  },
  '字幕路径': {
    zh: '字幕路径',
    en: 'Subtitle Path',
    ar: 'ترجمة المسار',
    fa: 'مسیر زیر عنوان',
    pt: 'Localização das Legendas'
  },
  '转码任务': {
    zh: '转码任务',
    en: 'Transcode',
    ar: 'الشفرة المهمة',
    fa: 'وظیفه رمزگذاری',
    pt: 'Transcodificar'
  },
  '任务列表': {
    zh: '任务列表',
    en: 'Task List',
    ar: 'قائمة المهام',
    fa: 'فهرست کار',
    pt: 'Lista Tarefas'
  },
  '任务名称': {
    zh: '任务名称',
    en: 'Task Name',
    ar: 'اسم المهمة',
    fa: 'نام کار',
    pt: 'Nome da Tarefa'
  },
  '文件路径': {
    zh: '文件路径',
    en: 'Path',
    ar: 'مسار',
    fa: 'مسیر',
    pt: 'Caminho de Arquivo'
  },
  '开启': {
    zh: '开启',
    en: 'Start',
    ar: 'فتح',
    fa: 'باز',
    pt: 'Abrir'
  },
  '暂停': {
    zh: '暂停',
    en: 'Pause',
    ar: 'وقفة',
    fa: 'مکث',
    pt: 'Suspender'
  },
  '请输入任务名称': {
    zh: '请输入任务名称',
    en: 'Please input task name',
    ar: 'من فضلك أدخل اسم المهمة',
    fa: 'لطفا نام کاری را وارد کنید',
    pt: 'Indique por favor o nome da tarefa'
  },
  '确定开启该任务?': {
    zh: '确定开启该任务?',
    en: 'Are you sure to start this task?',
    ar: 'هل أنت متأكد من أن المهمة بدأت ؟',
    fa: 'مطمئني اين کار رو شروع کني؟',
    pt: 'Tem a certeza que quer iniciar esta tarefa?'
  },
  '确定暂停该任务?': {
    zh: '确定暂停该任务?',
    en: 'Are you sure to pause this task?',
    ar: 'هل أنت متأكد من تعليق هذه المهمة ؟',
    fa: 'مطمئني اين کار رو متوقف کني؟',
    pt: 'Tens a certeza que vais pausar esta tarefa?'
  },
  '为节目被操作的次数，例如节目被操作2次上线，数据即为2。': {
    zh: '为节目被操作的次数，例如节目被操作2次上线，数据即为2。',
    en: 'The number of times the program has been operated, for example, if the program has been operated twice and is launched, the data is 2.',
    ar: '. عدد المرات التي يتم تشغيل البرنامج ، على سبيل المثال ، يتم تشغيل البرنامج مرتين على الانترنت ، البيانات هي 2',
    fa: '.تعداد بار برنامه عملیات شده، برای مثال، اگر برنامه دو بار عملیات شده و آغاز شده باشد، داده‌ها ۲ است',
    pt: 'O número de vezes que o programa é operado, por exemplo, se o programa é operado duas vezes e fica online, os dados são 2.'
  },
  '为节目在平台上数据，以节目最终状态为统计结果，例如节目操作上线再操作下线，那么上线-1，下线+1。': {
    zh: '为节目在平台上数据，以节目最终状态为统计结果，例如节目操作上线再操作下线，那么上线-1，下线+1。',
    en: 'For the data of the program on the platform, the final status of the program is taken as the statistical result. For example, if the program is operated online and then offline, then online -1, offline+1.',
    ar: '.بالنسبة للبرنامج الموجود على النظام الأساسي ، فإن الحالة النهائية للبرنامج هي النتيجة الإحصائية ، مثل تشغيل البرنامج عبر الإنترنت ثم يتم تشغيلها ، ثم عبر الإنترنت -1 غير متصل +1',
    fa: '.برای برنامه روی سیستم عامل ، وضعیت نهایی برنامه نتیجه آماری است ، مانند عملکرد برنامه به صورت آنلاین و سپس به کار می رود ، سپس آنلاین -1 ، آفلاین +1',
    pt: 'Para os dados do programa na plataforma, o status final do programa é tomado como resultado estatístico. Por exemplo, se o programa é operado online e depois offline, então online -1, offline+1.'
  },
  '电影操作统计': {
    zh: '电影操作统计',
    en: 'Movie Operation Statistics',
    ar: 'إحصائيات تشغيل الفيلم',
    fa: 'آمار عملیات فیلم',
    pt: 'Estatísticas Operação Filme'
  },
  '电影节目统计': {
    zh: '电影节目统计',
    en: 'Movie Program Statistics',
    ar: 'فيلم برنامج إحصائيات',
    fa: 'آمار نمایش فیلم',
    pt: 'Estatísticas Programa Cinema'
  },
  '电视剧操作统计': {
    zh: '电视剧操作统计',
    en: 'TV Shows Operation Statistics',
    ar: 'إحصاءات عن تشغيل التلفزيون',
    fa: 'آمار عملیات درام تلویزیونی',
    pt: 'Estatísticas Operação Drama TV'
  },
  '电视剧节目统计': {
    zh: '电视剧节目统计',
    en: 'TV Shows (Section) Programs Statistics',
    ar: 'برنامج تلفزيوني إحصائيات',
    fa: 'نمایش برنامه‌های تلویزیون',
    pt: 'Drama TV (seção) Estatísticas Programas'
  },
  '电视剧剧集操作统计': {
    zh: '电视剧剧集操作统计',
    en: 'TV Shows Series Operation Statistics',
    ar: 'إحصاءات عملية الدراما الدرامية التلفزيونية',
    fa: 'آمار عملیات دراما',
    pt: 'Estatísticas Operação Séries TV'
  },
  '电视剧剧集节目统计': {
    zh: '电视剧剧集节目统计',
    en: 'TV Shows Series Programs Statistics',
    ar: 'إحصائيات برنامج الدراما الدرامية التلفزيونية',
    fa: 'آمار برنامه دراما',
    pt: 'Estatísticas Programas Séries TV'
  },
  '昨日上线次数': {
    zh: '昨日上线次数',
    en: 'Online Yesterday',
    ar: 'عدد الأمس على الانترنت',
    fa: 'تعداد آغاز دیروز',
    pt: 'Online Ontem'
  },
  '昨日下线次数': {
    zh: '昨日下线次数',
    en: 'Offline Yesterday',
    ar: 'دوونلين أمس',
    fa: 'تعداد سعی های خارج از خط دیروز',
    pt: 'Offline Ontem'
  },
  '本月上线次数': {
    zh: '本月上线次数',
    en: 'Online This Month',
    ar: 'عدد مرات هذا الشهر على الانترنت',
    fa: 'تعداد آغاز این ماه',
    pt: 'Online Este Mês'
  },
  '本月下线次数': {
    zh: '本月下线次数',
    en: 'Offline This Month',
    ar: 'دوونلين مرات هذا الشهر',
    fa: 'تعداد زمان خارج از خط این ماه',
    pt: 'Offline Este Mês'
  },
  '路径或者服务名重复': {
    zh: '路径或者服务名重复',
    en: 'Duplicate path or service name',
    ar: 'تكرار المسار أو اسم الخدمة',
    fa: 'جبران کردن مسیر یا نام خدمت',
    pt: 'Caminho ou nome de serviço repita'
  },
  '添加定制': {
    zh: '添加定制',
    en: 'Add Customized',
    ar: 'إضافة التخصيص',
    fa: 'افزودن تنظیم',
    pt: 'Adicione Cusomizado'
  },
  '定制品牌': {
    zh: '定制品牌',
    en: 'Add Customized Brand',
    fa: 'اضافه کردن',
    ar: 'يضيف',
    pt: 'Marca Personalizada'
  },
  '编辑定制品牌': {
    zh: '编辑定制品牌',
    en: 'Eidt Customized Brand',
    ar: 'حرر',
    fa: 'ویرایش',
    pt: 'Editar Marca Personalizada'
  },
  '定制主品牌名称': {
    zh: '定制主品牌名称',
    en: 'Customized Main Brand Name',
    ar: 'تخصيص اسم العلامة التجارية الرئيسية',
    fa: 'نام اصلی برند',
    pt: 'Nome Marca Personalizado'
  },
  '定制子品牌名称': {
    zh: '定制子品牌名称',
    en: 'Customized Sub Brand Name',
    ar: 'تخصيص اسم العلامة التجارية الفرعية',
    fa: 'اسم برند زیر',
    pt: 'Nome Submarca Personalizado'
  },
  '定制名称': {
    zh: '定制名称',
    en: 'Customized Name',
    ar: 'اسم مخصص',
    fa: 'نام سفارشی',
    pt: 'Nome Personalizado'
  },
  '主品牌UI': {
    zh: '主品牌UI',
    en: 'Main Brand UI',
    ar: 'العلامة التجارية الرئيسية واجهة المستخدم',
    fa: 'UI برند اصلی',
    pt: 'UI da Marca Principal'
  },
  '请输入定制主品牌名称': {
    zh: '请输入定制主品牌名称',
    en: 'Please input custom main brand name',
    ar: 'من فضلك أدخل اسم العلامة التجارية الرئيسية المخصصة',
    fa: 'لطفاً نام اصلی برند را وارد کنید',
    pt: 'Indique por favor a marca principal personalizada'
  },
  '请输入定制子品牌名称': {
    zh: '请输入定制子品牌名称',
    en: 'Please input custom sub brand name',
    ar: 'من فضلك أدخل اسم العلامة التجارية المخصصة',
    fa: 'لطفاً نام زیر برند را وارد کنید',
    pt: 'Indique por favor o nome personalizado da sub marca'
  },
  '您还没有定制风格，点击 “创建” 按钮创建。': {
    zh: '您还没有定制风格，点击 “创建” 按钮创建。',
    en: 'You do not have a customized style yet. Click the \'Create\' button to create it.',
    ar: '.لم يكن لديك نمط مخصص ، انقر على زر إنشاء لإنشاء',
    fa: 'هنوز یک سبک تنظیم نکردید. برای ایجاد آن دکمه \'ایجاد کنید\' را فشار دهید.',
    pt: 'Você ainda não personalizou um estilo, clique no botão "Criar" para criá-lo.'
  },
  '创建': {
    zh: '创建',
    en: 'Create',
    ar: 'خلق',
    fa: 'ایجاد کنید',
    pt: 'Criar'
  },
  '请选择主品牌UI': {
    zh: '请选择主品牌UI',
    en: 'Please select the main brand UI',
    ar: 'الرجاء اختيار العلامة التجارية الرئيسية واجهة المستخدم',
    fa: 'لطفاً UI برند اصلی را انتخاب کنید',
    pt: 'Seleccione por favor a interface principal da marca'
  },
  '请先创建子品牌': {
    zh: '请先创建子品牌',
    en: 'Please create a sub brand first',
    ar: 'يرجى إنشاء العلامة التجارية الفرعية الأولى',
    fa: 'لطفا اول یک برند زیر',
    pt: 'Por favor, crie uma sub marca primeiro'
  },
  '海报类型': {
    zh: '海报类型',
    en: 'Poster Type',
    ar: 'نوع الصورة',
    fa: 'نوع پوستر',
    pt: 'Tipo de Cartaz'
  },
  '通用海报': {
    zh: '通用海报',
    en: 'Default Poster',
    ar: 'ملصقات عامة',
    fa: 'تصویر پیش‌فرض',
    pt: 'Pôster Universal'
  },
  '安卓海报': {
    zh: '安卓海报',
    en: 'Android Poster',
    ar: 'ملصق الروبوت',
    fa: 'پوستر اندروید',
    pt: 'Pôster Andróide'
  },
  '请选择海报类型': {
    zh: '请选择海报类型',
    en: 'Please select a poster type',
    ar: 'الرجاء اختيار نوع الصورة',
    fa: 'لطفا یک نوع پوستر را انتخاب کنید',
    pt: 'Seleccione por favor o tipo de cartaz'
  },
  '通用': {
    zh: '通用',
    en: 'Default',
    ar: 'افتراضي',
    fa: 'پیش‌فرض',
    pt: 'Padrão'
  },
  '安卓': {
    zh: '安卓',
    en: 'Android',
    ar: 'Android',
    fa: 'Android',
    pt: 'Android'
  },
  'Preview Image': {
    zh: '无法显示图片',
    en: 'Unable to display image',
    ar: 'لا يمكن عرض الصورة',
    fa: 'نمایش تصویر نیست',
    pt: 'Não foi possível exibir a imagem'
  },
  '剧集数量不能超过100': {
    zh: '剧集数量不能超过100',
    en: 'The number of TV Shows cannot exceed 100',
    ar: 'الكمية لا تتجاوز 100',
    fa: 'تعداد نمی تواند از 100 تجاوز کند',
    pt: 'O número de episódios não pode exceder 100'
  },
  '请输入有效地址': {
    zh: '请输入有效地址',
    en: 'Please input a valid URL',
    ar: 'الرجاء إدخال عنوان صحيح',
    fa: 'لطفاً یک URL معتبر وارد کنید',
    pt: 'Por Favor insira um endereço válido'
  },
  '网络异常': {
    zh: '网络异常',
    en: 'Network Exception',
    ar: 'استثناء الشبكة',
    fa: 'استثنای شبکه',
    pt: 'Anomalia na Rede'
  },
  '剧集状态': {
    zh: '剧集状态',
    en: 'Content Status',
    ar: 'حالة المحتوى',
    fa: 'وضعیت محتوا',
    pt: 'Status Conteúdo'
  },
  '审核中': {
    zh: '审核中',
    en: 'In Review',
    ar: 'استعراض',
    fa: 'در بازرسی',
    pt: 'Sob Revisão'
  },
  '剧集状态未审核提示': {
    zh: '未审核：影片剧集含有未审核状态',
    en: 'Unaudited: All films and episodes are in an unaudited status',
    ar: 'غير مدقق : جميع حلقات الفيديو غير مدقق',
    fa: 'ناپذیر: تمام فیلم‌ها و قسمت‌ها در وضعیت ناپذیر هستند',
    pt: 'Não revisado: o episódio de vídeo tem status de não revisado'
  },
  '剧集状态已审核提示': {
    zh: '已审核：影片剧集全部状态为已审核通过',
    en: 'Approved: All films and episodes are in the approved status',
    ar: 'مراجعة : جميع حلقات الفيديو في حالة مراجعة الحسابات',
    fa: 'تصدیق شد: تمام فیلم‌ها و قسمتی‌ها در وضعیت تصدیق شده‌اند',
    pt: 'Aprovado: Todos os filmes e episódios estão com status de aprovados'
  },
  '剧集状态审核中提示': {
    zh: '审核中：影片剧集中包含多种状态，如已审核，退回审核、终端审核，不包括未审核、未通过',
    en: 'In Review: The film series includes multiple statuses, such as approved, resume, and terminal, excluding unaudited and failed',
    ar: 'أثناء التدقيق: تشمل حلقات الفيلم والدراما مجموعة متنوعة من الحالات ، مثل المراجعة ، مراجعة الإرجاع ، مراجعة الطرفية ، باستثناء عدم الراحة ، وليس الممر',
    fa: 'در حین حسابرسی: قسمت های فیلم و درام شامل موارد مختلفی از جمله بررسی ، بررسی بازگشت ، بررسی ترمینال ، به استثنای ناراحت کننده و نه عبور نیست',
    pt: 'Sob Revisão: A série de filmes inclui vários estados, como revistos, devolvidos para revisão e revisão terminal, excluindo não aprovados e não aprovados'
  },
  '剧集状态未通过提示': {
    zh: '未通过：影片剧集状态含有未通过',
    en: 'Failed: All films and episodes have a status of failed',
    ar: 'لم يمر : الفيلم لم يمر',
    fa: 'نمی توان عبور کرد: کل وضعیت فیلم و قسمت در حال عبور نیست',
    pt: 'Não Passou: O status da série de filmes contém Não Passou'
  },
  'System Error': {
    zh: '系统错误',
    en: 'System Error',
    ar: 'خطأ في النظام',
    fa: 'خطای سیستم',
    pt: 'Erro do Sistema'
  },
  '系统错误': {
    zh: '系统错误',
    en: 'System Error',
    ar: 'خطأ في النظام',
    fa: 'خطای سیستم',
    pt: 'Erro do Sistema'
  },
  '剧集状态已上线提示': {
    zh: '已上线：影片剧集全部状态为已上线',
    en: 'Online: All films and episodes are in the online status',
    ar: 'بالفعل على الانترنت : الفيلم سلسلة كاملة من الدولة بالفعل على الانترنت',
    fa: 'آنلاین: همه فیلم‌ها و قسمت‌ها در وضعیت آنلاین هستند',
    pt: 'Online: Todos os filmes e episódios estão no status online'
  },
  '剧集状态已下线提示': {
    zh: '已下线：影片剧集状态包含已下线，不包含未上线',
    en: 'Not Online: The status of the film series includes offline and does not include not online',
    ar: 'دوونلين : فيلم مركز يحتوي على دوونلين ، لا تحتوي على غير متصل',
    fa: 'آفلاین: وضعیت قسمت ویدیو شامل آفلاین است، اما شامل عدم دسترسی آنلاین نیست',
    pt: 'Offline: O status da série de filmes inclui offline, mas não inclui offline'
  },
  '剧集状态未上线提示': {
    zh: '未上线：影片剧集状态中含有未上线状态，按未上线显示',
    en: 'Offline: The status of the film series includes an offline status, which is displayed as offline',
    ar: 'لا على الانترنت : فيلم سلسلة تحتوي على حالة غير متصل ، اضغط على لا تظهر على الانترنت',
    fa: 'آنلاین نیست: وضعیت قسمت ویدیو شامل وضعیت آنلاین نبودن است و به عنوان آنلاین نبودن نمایش داده می شود',
    pt: 'Not Online: O status da série de filmes contém um status Not Online, que é exibido como Not Online'
  },
  '修改排序号重复': {
    zh: '修改排序号重复',
    en: 'The sorting number cannot be duplicated',
    ar: 'لا يمكن تكرار الرقم التسلسلي',
    fa: 'شماره دنباله قابل تکرار نیست',
    pt: 'Modifique a duplicação do número de sequência'
  },
  '': {
    zh: '',
    en: '',
    ar: '',
    fa: '',
    pt: ''
  },
  '请求频繁': {
    zh: '请求频繁',
    en: 'Frequent Requests',
    ar: 'طلبات متكررة',
    fa: 'درخواست های مکرر',
    pt: 'Pedidos Frequentes'
  },
  '1、未勾选内容点击排序，可以将全部内容按名称重新排序；': {
    zh: '1、未勾选内容点击排序，可以将全部内容按名称重新排序；',
    en: '1. Unchecked content can be reordered by name by clicking sort;',
    ar: ' 1 ، انقر فوق نوع من دون التحقق من المحتوى ، يمكنك إعادة ترتيب جميع المحتوى حسب الاسم . ',
    fa: '۱. محتوای غیر بررسی می‌تواند با اسم با فشار تنظیم کند.',
    pt: '1. Se o conteúdo não for verificado, clique em Classificar, você poderá classificar todo o conteúdo de acordo com o nome;'
  },
  '2、连续选中多个内容点击排序，只对选中内容按名称重新排序；': {
    zh: '2、连续选中多个内容点击排序，只对选中内容按名称重新排序；',
    en: '2. Continuously select multiple contents and click sort, only reordering the selected contents by name;',
    ar: ' 2 ، باستمرار اختيار عدد من المحتوى انقر فوق نوع ، فقط اختيار المحتوى حسب الاسم إلى إعادة ترتيب . ',
    fa: '۲. محتویات چندین را به طور دائمی انتخاب کنید و تنظیم کنید، فقط محتویات برگزیده را به عنوان نام دوباره تنظیم کنید.',
    pt: '2. Selecione vários conteúdos em uma linha e clique em classificar, classifique apenas o conteúdo selecionado de acordo com o nome;'
  },
  '注意：选中内容不满足连续选中无法排序。': {
    zh: '注意：选中内容不满足连续选中无法排序。',
    en: 'Note: The selected content does not meet the requirement of continuous selection and cannot be sorted.',
    ar: 'ملاحظة : الاختيار لا يرضي استمرار الاختيار لا يمكن فرزها .',
    fa: 'یادداشت: محتوای انتخاب نیازی انتخاب پایدار نیست و نمی‌تواند تنظیم شود.',
    pt: 'Nota: O conteúdo selecionado não poderá ser classificado se não atender à seleção contínua.'
  },
  '不满足连续选中': {
    zh: '不满足连续选中',
    en: 'Not meeting continuous selection criteria',
    ar: 'لا يرضي الاختيار المستمر',
    fa: 'داده ها باید پیوسته باشند',
    pt: 'Não satisfaz os critérios de selecção contínua'
  },
  '盒端截图': {
    zh: '盒端截图',
    en: 'Box Screenshot',
    ar: 'لقطة شاشة للصندوق',
    fa: 'اسکرین شات جعبه',
    pt: 'Imagem Set-top Box'
  },
  '请输入SN': {
    zh: '请输入SN',
    en: 'Input SN',
    ar: 'الرجاء إدخال SN',
    fa: 'لطفا SN را وارد کنید',
    pt: 'Entrada SN'
  },
  '任务已下发': {
    zh: '任务已下发',
    en: 'Task has been issued',
    ar: 'تم إصدار المهمة',
    fa: 'تکلیف صادر شده است',
    pt: 'Um tarefa foi emitida'
  },
  '指令发送失败': {
    zh: '指令发送失败',
    en: 'Command sending failed',
    ar: 'فشل إرسال التعليمات',
    fa: 'فرستادن فرمان شکست خورد',
    pt: 'Falha no envio do comando'
  },
  '截图': {
    zh: '截图',
    en: 'Screenshot',
    ar: 'لقطة',
    fa: 'تصویر پرده',
    pt: 'Captura Ecrã'
  },
  '更新时间': {
    zh: '更新时间',
    en: 'Update Time',
    ar: 'وقت التحديث',
    fa: 'زمان بروزرسانی',
    pt: 'Tempo Atualização'
  },
  'APP Download': {
    zh: 'APP 下载',
    en: 'APP Download',
    ar: 'تحميل التطبيق',
    fa: 'دانلود APP',
    pt: 'Descarregar APP'
  },
  'last': {
    zh: '最后',
    en: 'Last',
    ar: 'آخر',
    fa: 'آخرین',
    pt: 'O último'
  },
  'first': {
    zh: '首个',
    en: 'First',
    ar: 'أولاً',
    fa: 'اول',
    pt: 'primeira'
  },
  '直播': {
    zh: '直播',
    en: 'Live',
    ar: 'يعيش',
    fa: 'زندگی کنید',
    pt: 'Ao vivo'
  },
  '点播': {
    zh: '点播',
    en: 'Vod',
    ar: 'فود',
    fa: 'Vod',
    pt: 'O"'
  },
  '横版': {
    zh: '横版',
    en: 'Horizontal',
    ar: 'أفقي',
    fa: 'افقی',
    pt: 'Um nível de'
  },
  '竖版': {
    zh: '竖版',
    en: 'Vertical',
    ar: 'رَأسِيّ',
    fa: 'عمودی',
    pt: 'Versão vertical'
  },
  'Model设置': {
    zh: 'Model设置',
    en: 'Data Service Model',
    ar: 'نموذج خدمة البيانات',
    fa: 'مدل سرویس داده',
    pt: 'Modelo de serviço de dados'
  },
  '方案': {
    zh: '方案',
    en: 'Platform',
    ar: 'منصة',
    fa: 'پلت فرم',
    pt: 'plataforma'
  },
  '平台管理': {
    zh: '平台管理',
    en: 'Platform Manage',
    ar: 'إدارة المنصة',
    fa: 'مدیریت پلتفرم',
    pt: 'Gestão da plataforma'
  },
  '档次': {
    zh: '档次',
    en: 'Level',
    ar: 'مستوى',
    fa: 'سطح',
    pt: 'nível'
  },
  '请输入平台名称': {
    zh: '请输入平台名称',
    en: 'Please enter the Platform',
    ar: 'الرجاء الدخول إلى المنصة',
    fa: 'لطفا پلتفرم را وارد کنید',
    pt: 'Digite o nome da plataforma'
  },
  '平台名称的长度应在1到50字符之间': {
    zh: '平台名称的长度应在1到50字符之间',
    en: 'The Platform Name should be between 1 and 50 characters',
    ar: 'يجب أن يكون اسم المنصة بين 1 و 50 حرفًا',
    fa: 'نام پلتفرم باید بین 1 تا 50 کاراکتر باشد',
    pt: 'O nome da plataforma deve ter entre 1 e 50 caracteres'
  },
  '请选择档次': {
    zh: '请选择档次',
    en: 'Please select Level',
    ar: 'الرجاء تحديد المستوى',
    fa: 'لطفا سطح را انتخاب کنید',
    pt: 'Por favor, selecione uma classe'
  },
  '已存在': {
    zh: '已存在',
    en: 'Already Exist',
    ar: 'موجودة بالفعل',
    fa: 'از قبل وجود دارد',
    pt: 'Já existe agora'
  },
  'APP风格': {
    zh: 'APP风格',
    en: 'APP Style',
    ar: 'نمط التطبيق',
    fa: 'سبک برنامه',
    pt: 'Estilo do APP'
  },
  '终端定制UI': {
    zh: '终端定制UI',
    en: 'Terminal Customization UI',
    ar: 'واجهة المستخدم لتخصيص المحطة الطرفية',
    fa: 'رابط کاربری سفارشی سازی ترمینال',
    pt: 'Personalização terminal UI'
  },
  '请输入CID': {
    zh: '请输入CID',
    en: 'Please enter CID',
    ar: 'الرجاء إدخال CID',
    fa: 'لطفا CID را وارد کنید',
    pt: 'Por favor insira CID'
  },
  '请输入PID': {
    zh: '请输入PID',
    en: 'Please enter PID',
    ar: 'الرجاء إدخال معرف المنتج',
    fa: 'لطفا PID را وارد کنید',
    pt: 'Por favor insira PID'
  },
  '请输入MID': {
    zh: '请输入MID',
    en: 'Please enter MID',
    ar: 'الرجاء إدخال MID',
    fa: 'لطفا MID را وارد کنید',
    pt: 'Por favor insira MID'
  },
  'CID的长度应在1到9字符之间': {
    zh: 'CID的长度应在1到9字符之间',
    en: 'The length of the CID should be between 1 and 9 characters',
    ar: 'يجب أن يكون طول CID بين 1 و 9 أحرف',
    fa: 'طول CID باید بین 1 تا 9 کاراکتر باشد',
    pt: 'O CID deve ter entre 1 e 9 caracteres'
  },
  'PID的长度应在1到9字符之间': {
    zh: 'PID的长度应在1到9字符之间',
    en: 'The length of the PID should be between 1 and 9 characters',
    ar: 'يجب أن يكون طول معرف العملية بين 1 و 9 أحرف',
    fa: 'طول PID باید بین 1 تا 9 کاراکتر باشد',
    pt: 'O PID deve ter entre 1 e 9 caracteres'
  },
  'MID的长度应在1到9字符之间': {
    zh: 'MID的长度应在1到9字符之间',
    en: 'The length of the MID should be between 1 and 9 characters',
    ar: 'يجب أن يكون طول MID بين 1 و 9 أحرف',
    fa: 'طول MID باید بین 1 تا 9 کاراکتر باشد',
    pt: 'O MID deve ter entre 1 e 9 caracteres'
  },
  '选择子品牌': {
    zh: '选择子品牌',
    en: 'Select Sub Brand',
    ar: 'اختر العلامة التجارية الفرعية',
    fa: 'Sub Brand را انتخاب کنید',
    pt: 'Selecione uma sub-marca'
  },
  '关联子品牌': {
    zh: '关联子品牌',
    en: 'Associated Sub Brand',
    ar: 'العلامة التجارية الفرعية المرتبطة',
    fa: 'زیر نام تجاری مرتبط',
    pt: 'Submarcas associadas'
  },
  '创建关联子品牌': {
    zh: '创建关联子品牌',
    en: 'Create associated Sub Brand',
    ar: 'إنشاء العلامة التجارية الفرعية المرتبطة',
    fa: 'زیر نام تجاری مرتبط ایجاد کنید',
    pt: 'Criação de sub-marcas afiliadas'
  },
  '请先停运子品牌，再操作解除关联': {
    zh: '请先停运子品牌，再操作解除关联',
    en: 'Please stop the Sub Brand first and then disassociate it',
    ar: 'يرجى إيقاف العلامة التجارية الفرعية أولاً ثم فصلها',
    fa: 'لطفاً ابتدا ساب برند را متوقف کنید و سپس آن را جدا کنید',
    pt: 'Por favor, desligue a sub-marca antes de operar para desassociar'
  },
  '确定解除关联吗？': {
    zh: '确定解除关联吗？',
    en: 'Are you sure about disassociating?',
    ar: 'هل أنت متأكد من الانفصال؟',
    fa: 'آیا از جداسازی مطمئن هستید؟',
    pt: 'Tens a certeza da desassociação?'
  },
  '终端主品牌配置': {
    zh: '终端主品牌配置',
    en: 'Terminal Main Brand',
    ar: 'العلامة التجارية الرئيسية للمحطة',
    fa: 'نام تجاری اصلی ترمینال',
    pt: 'Tipo principal do terminal'
  },
  '关联主品牌': {
    zh: '关联主品牌',
    en: 'Associated Main Brand',
    ar: 'العلامة التجارية الرئيسية المرتبطة',
    fa: 'نام تجاری اصلی مرتبط',
    pt: 'Principais marcas associadas'
  },
  '确认要删除该条信息？': {
    zh: '确认要删除该条信息？',
    en: 'Confirm to delete this message?',
    ar: 'تأكيد حذف هذه الرسالة؟',
    fa: 'برای حذف این پیام تأیید می‌کنید؟',
    pt: 'Confirme que deseja remover esta mensagem?'
  },
  '移除将解除SN与所关联子品牌的关联关系，确认移除SN吗？': {
    zh: '移除将解除SN与所关联子品牌的关联关系，确认移除SN吗？',
    en: 'Removal will disassociate the SN from the associated sub-brand. Are you sure to remove the SN?',
    ar: 'سيؤدي الإزالة إلى فصل الرقم التسلسلي عن العلامة التجارية الفرعية المرتبطة به. هل أنت متأكد من إزالة الرقم التسلسلي؟',
    fa: 'حذف SN را از برند فرعی مرتبط جدا می کند. آیا مطمئن هستید که SN را حذف می کنید؟',
    pt: 'A remoção desassociará a SN à submarca associada. Confirma a remoção da SN?'
  },

  // '为节目被操作的次数，例如节目被操作2次上线，数据即为2。': {
  //   zh: '为节目被操作的次数，例如节目被操作2次上线，数据即为2。',
  //   en: 'Indicates the number of times the program has been operated. For example, if the program has been operated to go online twice, the data is 2',
  //   ar: '',
  //   fa: '',
  //   pt: 'Para o número de vezes que o programa é operado, por exemplo, o programa é lançado duas vezes e os dados são 2.'
  // },

  // '获取模板中的配置': {
  //   zh: '获取模板中的配置',
  //   en: 'Obtain configuration from template',
  //   ar: 'الحصول على التكوين في القالب',
  //   fa: 'پیکربندی را در الگوی دریافت کنید',
  //   pt: 'Obtenha a configuração no modelo'
  // },

  'CDN来源': {
    zh: 'CDN来源', en: 'CDN Source', ar: 'مصدر CDN', fa: 'منبع CDN', pt: 'Origem CDN'
  },
  '风险等级': {
    zh: '风险等级', en: 'Risk Level', ar: 'مستوى المخاطر', fa: 'سطح ریسک', pt: 'Nível de Risco'
  },
  '确认盗链': {
    zh: '确认盗链', en: 'Confirmed Piracy', ar: 'قرصنة مؤكدة', fa: 'سرقت محتوا تأیید شد', pt: 'Pirateamento Confirmado'
  },
  '疑似多路并发': {
    zh: '疑似多路并发', en: 'Suspected Multi-Stream', ar: 'تدفقات متزامنة مشتبه بها', fa: 'چندپخشی مشکوک', pt: 'Possível Multistream'
  },
  '主要频道': {
    zh: '主要频道', en: 'Top Channels', ar: 'القنوات الرئيسية', fa: 'کانال‌های اصلی', pt: 'Canais Principais'
  },
  'IP': {
    zh: 'IP', en: 'IP', ar: 'IP', fa: 'IP', pt: 'IP'
  },
  '黑名单状态': {
    zh: '黑名单状态', en: 'Blacklist Status', ar: 'حالة القائمة السوداء', fa: 'وضعیت فهرست سیاه', pt: 'Estado da Lista Negra'
  },
  '黑名单时间': {
    zh: '黑名单时间', en: 'Blacklist Time', ar: 'وقت الإدراج بالقائمة السوداء', fa: 'زمان فهرست سیاه', pt: 'Hora da Lista Negra'
  },
  '检测窗口起点': {
    zh: '检测窗口起点', en: 'Detection Window Start', ar: 'بداية نافذة الكشف', fa: 'شروع پنجره تشخیص', pt: 'Início da Janela de Detecção'
  },
  '检测窗口终点': {
    zh: '检测窗口终点', en: 'Detection Window End', ar: 'نهاية نافذة الكشف', fa: 'پایان پنجره تشخیص', pt: 'Fim da Janela de Detecção'
  },
  '详情': {
    zh: '详情', en: 'Details', ar: 'التفاصيل', fa: 'جزئیات', pt: 'Detalhes'
  },
  '盗链异常列表': {
    zh: '盗链异常列表', en: 'Piracy Record List', ar: 'قائمة سجلات القرصنة', fa: 'فهرست سوابق سرقت محتوا', pt: 'Lista de Registos de Pirataria'
  },
  '盗链异常详情': {
    zh: '盗链异常详情', en: 'Piracy Record Details', ar: 'تفاصيل سجل القرصنة', fa: 'جزئیات سابقه سرقت محتوا', pt: 'Detalhes do Registo de Pirataria'
  },
  '已拉黑': {
    zh: '已拉黑', en: 'Blacklisted', ar: 'مدرج بالقائمة السوداء', fa: 'در فهرست سیاه', pt: 'Na Lista Negra'
  },
  '未拉黑': {
    zh: '未拉黑', en: 'Not Blacklisted', ar: 'غير مدرج بالقائمة السوداء', fa: 'خارج از فهرست سیاه', pt: 'Fora da Lista Negra'
  },
  '检测窗口内日志数': {
    zh: '检测窗口内日志数', en: 'Log Count in Detection Window', ar: 'عدد السجلات ضمن نافذة الكشف', fa: 'تعداد گزارش‌ها در پنجره تشخیص', pt: 'Registos na Janela de Deteção'
  },
  'IP数量': {
    zh: 'IP数量', en: 'IP Count', ar: 'عدد عناوين IP', fa: 'تعداد IP', pt: 'Quantidade de IPs'
  },
  '风险判定原因': {
    zh: '风险判定原因', en: 'Risk Reason', ar: 'سبب تحديد المخاطر', fa: 'دلیل تشخیص ریسک', pt: 'Motivo do Risco'
  },
  'Cloudflare/GCP 证据信息': {
    zh: 'Cloudflare/GCP 证据信息', en: 'Cloudflare/GCP Evidence', ar: 'أدلة Cloudflare/GCP', fa: 'شواهد Cloudflare/GCP', pt: 'Evidências Cloudflare/GCP'
  },
  'AWS 证据信息': {
    zh: 'AWS 证据信息', en: 'AWS Evidence', ar: 'أدلة AWS', fa: 'شواهد AWS', pt: 'Evidências AWS'
  },
  '30秒窗口内最大频道数': {
    zh: '30秒窗口内最大频道数', en: 'Max Channels in 30s Window', ar: 'أقصى عدد قنوات في نافذة 30 ثانية', fa: 'حداکثر کانال در پنجره ۳۰ ثانیه‌ای', pt: 'Máximo de Canais em 30s'
  },
  '同秒物理分片最大并发频道数': {
    zh: '同秒物理分片最大并发频道数', en: 'Max Concurrent Slice Channels', ar: 'أقصى قنوات شرائح متزامنة', fa: 'حداکثر کانال‌های قطعه‌ای هم‌زمان', pt: 'Máximo de Canais de Segmentos Simultâneos'
  },
  '多频道物理分片秒数': {
    zh: '多频道物理分片秒数', en: 'Seconds with Multi-Channel Slices', ar: 'ثوانٍ تحتوي على شرائح متعددة القنوات', fa: 'ثانیه‌های دارای قطعه چندکاناله', pt: 'Segundos com Segmentos Multicanais'
  },
  '多频道初筛窗口数': {
    zh: '多频道初筛窗口数', en: 'Multi-Channel Screening Windows', ar: 'نوافذ الفحص الأولي متعددة القنوات', fa: 'پنجره‌های غربالگری چندکاناله', pt: 'Janelas de Triagem Multicanais'
  },
  '频道重合次数': {
    zh: '频道重合次数', en: 'Channel Overlap Count', ar: 'عدد تداخل القنوات', fa: 'تعداد هم‌پوشانی کانال', pt: 'Contagem de Sobreposição de Canais'
  },
  '证据发生时间': {
    zh: '证据发生时间', en: 'Evidence Time', ar: 'وقت الدليل', fa: 'زمان وقوع شواهد', pt: 'Hora da Evidência'
  },
  '证据频道': {
    zh: '证据频道', en: 'Evidence Channels', ar: 'قنوات الأدلة', fa: 'کانال‌های شواهد', pt: 'Canais de Evidência'
  },
  '频道': {
    zh: '频道', en: 'Channel', ar: 'القناة', fa: 'کانال', pt: 'Canal'
  },
  '终端类型': {
    zh: '终端类型', en: 'Terminal Type', ar: 'نوع الجهاز الطرفي', fa: 'نوع پایانه', pt: 'Tipo de Terminal'
  },

}